export const ERROR_CODES = {
  OK: 0,
  SYNTAX_ERROR: 1,
  NAME_ERROR: 2,
  SURNAME_ERROR: 3,
  BDAY_ERROR: 4
};

export const MONTH_CODES = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'H',
    'L',
    'M',
    'P',
    'R',
    'S',
    'T'
  ];
  
  export const CHECK_CODE_ODD = {
    0: 1,
    1: 0,
    2: 5,
    3: 7,
    4: 9,
    5: 13,
    6: 15,
    7: 17,
    8: 19,
    9: 21,
    A: 1,
    B: 0,
    C: 5,
    D: 7,
    E: 9,
    F: 13,
    G: 15,
    H: 17,
    I: 19,
    J: 21,
    K: 2,
    L: 4,
    M: 18,
    N: 20,
    O: 11,
    P: 3,
    Q: 6,
    R: 8,
    S: 12,
    T: 14,
    U: 16,
    V: 10,
    W: 22,
    X: 25,
    Y: 24,
    Z: 23
  };
  
  export const CHECK_CODE_EVEN = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 0,
    B: 1,
    C: 2,
    D: 3,
    E: 4,
    F: 5,
    G: 6,
    H: 7,
    I: 8,
    J: 9,
    K: 10,
    L: 11,
    M: 12,
    N: 13,
    O: 14,
    P: 15,
    Q: 16,
    R: 17,
    S: 18,
    T: 19,
    U: 20,
    V: 21,
    W: 22,
    X: 23,
    Y: 24,
    Z: 25
  };
  
  export const OMOCODIA_TABLE = {
    0: 'L',
    1: 'M',
    2: 'N',
    3: 'P',
    4: 'Q',
    5: 'R',
    6: 'S',
    7: 'T',
    8: 'U',
    9: 'V'
  };
  
  export const CHECK_CODE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  
  export const CODICI_CATASTALI = {
    EE: [
      ['ALBANIA', 'Z100'],
      ['ANDORRA', 'Z101'],
      ['AUSTRIA', 'Z102'],
      ['BELGIO', 'Z103'],
      ['BULGARIA', 'Z104'],
      ['CITTA\' DEL VATICANO', 'Z106'],
      ['DANIMARCA', 'Z107'],
      ['FAER OER (ISOLE)', 'Z108'],
      ['FINLANDIA', 'Z109'],
      ['FRANCIA', 'Z110'],
      ['GERMANIA', 'Z112'],
      ['GIBILTERRA', 'Z113'],
      ['REGNO UNITO', 'Z114'],
      ['GRECIA', 'Z115'],
      ['IRLANDA', 'Z116'],
      ['ISLANDA', 'Z117'],
      ['LIECHTENSTEIN', 'Z119'],
      ['LUSSEMBURGO', 'Z120'],
      ['MALTA', 'Z121'],
      ['MAN (ISOLA)', 'Z122'],
      ['MONACO', 'Z123'],
      ['ISOLE DEL CANALE', 'Z124'],
      ['NORVEGIA', 'Z125'],
      ['PAESI BASSI', 'Z126'],
      ['POLONIA', 'Z127'],
      ['PORTOGALLO', 'Z128'],
      ['ROMANIA', 'Z129'],
      ['SAN MARINO', 'Z130'],
      ['SPAGNA', 'Z131'],
      ['SVEZIA', 'Z132'],
      ['SVIZZERA', 'Z133'],
      ['UNGHERIA', 'Z134'],
      ['UCRAINA', 'Z138'],
      ['BIELORUSSIA', 'Z139'],
      ['MOLDAVIA', 'Z140'],
      ['ESTONIA', 'Z144'],
      ['LETTONIA', 'Z145'],
      ['LITUANIA', 'Z146'],
      ['MACEDONIA', 'Z148'],
      ['CROAZIA', 'Z149'],
      ['SLOVENIA', 'Z150'],
      ['BOSNIA ED ERZEGOVINA', 'Z153'],
      ['FEDERAZIONE RUSSA', 'Z154'],
      ['SLOVACCHIA', 'Z155'],
      ['REPUBBLICA CECA', 'Z156'],
      ['KOSOVO', 'Z160'],
      ['TERRITORI PALESTINESI', 'Z161'],
      ['AFGHANISTAN', 'Z200'],
      ['ARABIA SAUDITA', 'Z203'],
      ['BAHREIN', 'Z204'],
      ['BHUTAN', 'Z205'],
      ['MYANMAR', 'Z206'],
      ['BRUNEI', 'Z207'],
      ['CAMBOGIA', 'Z208'],
      ['SRI LANKA', 'Z209'],
      ['CINA REPUBBLICA POPOLARE', 'Z210'],
      ['CIPRO', 'Z211'],
      ['COCOS (ISOLE)', 'Z212'],
      ['REPUBBLICA DI COREA', 'Z213'],
      ['COREA DEL NORD', 'Z214'],
      ['EMIRATI ARABI UNITI', 'Z215'],
      ['FILIPPINE', 'Z216'],
      ['TAIWAN', 'Z217'],
      ['GAZA (TERRITORIO DI)', 'Z218'],
      ['GIAPPONE', 'Z219'],
      ['GIORDANIA', 'Z220'],
      ['INDIA', 'Z222'],
      ['INDONESIA', 'Z223'],
      ['IRAN', 'Z224'],
      ['IRAQ', 'Z225'],
      ['ISRAELE', 'Z226'],
      ['KUWAIT', 'Z227'],
      ['LAOS', 'Z228'],
      ['LIBANO', 'Z229'],
      ['MACAO', 'Z231'],
      ['MALDIVE', 'Z232'],
      ['MONGOLIA', 'Z233'],
      ['NEPAL', 'Z234'],
      ['OMAN', 'Z235'],
      ['PAKISTAN', 'Z236'],
      ['QATAR', 'Z237'],
      ['SIRIA', 'Z240'],
      ['THAILANDIA', 'Z241'],
      ['TURCHIA', 'Z243'],
      ['YEMEN', 'Z246'],
      ['MALAYSIA', 'Z247'],
      ['SINGAPORE', 'Z248'],
      ['BANGLADESH', 'Z249'],
      ['VIETNAM', 'Z251'],
      ['ARMENIA', 'Z252'],
      ['AZERBAIGIAN', 'Z253'],
      ['GEORGIA', 'Z254'],
      ['KAZAKHSTAN', 'Z255'],
      ['KIRGHIZISTAN', 'Z256'],
      ['TAGIKISTAN', 'Z257'],
      ['TURKMENISTAN', 'Z258'],
      ['UZBEKISTAN', 'Z259'],
      ['NAMIBIA', 'Z300'],
      ['ALGERIA', 'Z301'],
      ['ANGOLA', 'Z302'],
      ['BURUNDI', 'Z305'],
      ['CAMERUN', 'Z306'],
      ['CAPO VERDE', 'Z307'],
      ['CENTRAFRICANA REPUBBLICA', 'Z308'],
      ['CIAD', 'Z309'],
      ['COMORE', 'Z310'],
      ['CONGO REPUBBLICA POPOLARE', 'Z311'],
      ['CONGO REPUBBLICA DEMOCRATICA', 'Z312'],
      ['COSTA D\'AVORIO', 'Z313'],
      ['BENIN', 'Z314'],
      ['ETIOPIA', 'Z315'],
      ['GABON', 'Z316'],
      ['GAMBIA', 'Z317'],
      ['GHANA', 'Z318'],
      ['GUINEA', 'Z319'],
      ['GUINEA BISSAU', 'Z320'],
      ['GUINEA EQUATORIALE', 'Z321'],
      ['KENYA', 'Z322'],
      ['LA REUNION (ISOLA)', 'Z324'],
      ['LIBERIA', 'Z325'],
      ['LIBIA', 'Z326'],
      ['MADAGASCAR', 'Z327'],
      ['MALAWI', 'Z328'],
      ['MALI', 'Z329'],
      ['MAROCCO', 'Z330'],
      ['MAURITANIA', 'Z331'],
      ['MAURIZIO', 'Z332'],
      ['MOZAMBICO', 'Z333'],
      ['NIGER', 'Z334'],
      ['NIGERIA', 'Z335'],
      ['EGITTO', 'Z336'],
      ['ZIMBABWE', 'Z337'],
      ['RUANDA', 'Z338'],
      ['SANT\'ELENA (ISOLA)', 'Z340'],
      ['SAO TOME\' E PRINCIPE', 'Z341'],
      ['SEICELLE', 'Z342'],
      ['SENEGAL', 'Z343'],
      ['SIERRA LEONE', 'Z344'],
      ['SOMALIA', 'Z345'],
      ['SUDAFRICANA REPUBBLICA', 'Z347'],
      ['SUDAN', 'Z348'],
      ['SWAZILAND', 'Z349'],
      ['TOGO', 'Z351'],
      ['TUNISIA', 'Z352'],
      ['UGANDA', 'Z353'],
      ['BURKINA FASO', 'Z354'],
      ['ZAMBIA', 'Z355'],
      ['TANZANIA', 'Z357'],
      ['BOTSWANA', 'Z358'],
      ['LESOTHO', 'Z359'],
      ['MAYOTTE (ISOLA)', 'Z360'],
      ['GIBUTI', 'Z361'],
      ['ERITREA', 'Z368'],
      ['BERMUDA (ISOLE)', 'Z400'],
      ['CANADA', 'Z401'],
      ['GROENLANDIA', 'Z402'],
      ['SAINT PIERRE ET MIQUELON (ISOLE)', 'Z403'],
      ['STATI UNITI D\'AMERICA', 'Z404'],
      ['ANTILLE OLANDESI', 'Z501'],
      ['BAHAMAS', 'Z502'],
      ['COSTA RICA', 'Z503'],
      ['CUBA', 'Z504'],
      ['REPUBBLICA DOMINICANA', 'Z505'],
      ['EL SALVADOR', 'Z506'],
      ['GIAMAICA', 'Z507'],
      ['GUADALUPA', 'Z508'],
      ['GUATEMALA', 'Z509'],
      ['HAITI', 'Z510'],
      ['HONDURAS', 'Z511'],
      ['BELIZE', 'Z512'],
      ['MARTINICA', 'Z513'],
      ['MESSICO', 'Z514'],
      ['NICARAGUA', 'Z515'],
      ['PANAMA', 'Z516'],
      ['PANAMA ZONA DEL CANALE', 'Z517'],
      ['PUERTO RICO', 'Z518'],
      ['TURKS E CAICOS (ISOLE)', 'Z519'],
      ['VERGINI AMERICANE (ISOLE)', 'Z520'],
      ['BARBADOS', 'Z522'],
      ['GRENADA', 'Z524'],
      ['VERGINI BRITANNICHE (ISOLE)', 'Z525'],
      ['DOMINICA', 'Z526'],
      ['SAINT LUCIA', 'Z527'],
      ['SAINT VINCENT E GRENADINE', 'Z528'],
      ['ANGUILLA (ISOLA)', 'Z529'],
      ['CAYMAN (ISOLE)', 'Z530'],
      ['MONTSERRAT', 'Z531'],
      ['ANTIGUA E BARBUDA', 'Z532'],
      ['SAINT KITTS E NEVIS', 'Z533'],
      ['ARGENTINA', 'Z600'],
      ['BOLIVIA', 'Z601'],
      ['BRASILE', 'Z602'],
      ['CILE', 'Z603'],
      ['COLOMBIA', 'Z604'],
      ['ECUADOR', 'Z605'],
      ['GUYANA', 'Z606'],
      ['GUIANA FRANCESE', 'Z607'],
      ['SURINAME', 'Z608'],
      ['FALKLAND (ISOLE)', 'Z609'],
      ['PARAGUAY', 'Z610'],
      ['PERU\'', 'Z611'],
      ['TRINIDAD E TOBAGO', 'Z612'],
      ['URUGUAY', 'Z613'],
      ['VENEZUELA', 'Z614'],
      ['AUSTRALIA', 'Z700'],
      ['CHRISTMAS (ISOLA)', 'Z702'],
      ['COOK (ISOLE)', 'Z703'],
      ['VITI', 'Z704'],
      ['GUAM (ISOLA)', 'Z706'],
      ['IRIAN OCCIDENTALE', 'Z707'],
      ['MACQUARIE (ISOLE)', 'Z708'],
      ['MARIANNE (ISOLE)', 'Z710'],
      ['MARSHALL', 'Z711'],
      ['MIDWAY (ISOLE)', 'Z712'],
      ['NAURU', 'Z713'],
      ['SAVAGE (ISOLE)', 'Z714'],
      ['NORFOLK (ISOLE E ISOLE DEL MAR DEI CORALLI)', 'Z715'],
      ['NUOVA CALEDONIA (ISOLE E DIPENDENZE)', 'Z716'],
      ['NUOVA ZELANDA', 'Z719'],
      ['ISOLE CILENE (PASQUA E SALA Y GOMEZ)', 'Z721'],
      ['PITCAIRN (E DIPENDENZE)', 'Z722'],
      ['POLINESIA FRANCESE (ISOLE)', 'Z723'],
      ['SALOMONE', 'Z724'],
      ['SAMOA AMERICANE (ISOLE)', 'Z725'],
      ['SAMOA', 'Z726'],
      ['ISOLE DELL\'UNIONE', 'Z727'],
      ['TONGA', 'Z728'],
      ['WALLIS E FUTUNA (ISOLE)', 'Z729'],
      ['PAPUA NUOVA GUINEA', 'Z730'],
      ['KIRIBATI', 'Z731'],
      ['TUVALU', 'Z732'],
      ['VANUATU', 'Z733'],
      ['PALAU', 'Z734'],
      ['MICRONESIA STATI FEDERATI', 'Z735'],
      ['DIPENDENZE CANADESI', 'Z800'],
      ['DIPENDENZE NORVEGESI ARTICHE', 'Z801'],
      ['DIPENDENZE RUSSE', 'Z802'],
      ['DIPENDENZE AUSTRALIANE', 'Z900'],
      ['DIPENDENZE BRITANNICHE', 'Z901'],
      ['DIPENDENZE FRANCESI', 'Z902'],
      ['DIPENDENZE NEOZELANDESI', 'Z903'],
      ['DIPENDENZE NORVEGESI ANTARTICHE', 'Z904'],
      ['DIPENDENZE STATUNITENSI', 'Z905'],
      ['DIPENDENZE SUDAFRICANE', 'Z906'],
      ['SUD SUDAN', 'Z907']
    ],
    AG: [
      ['SANTO STEFANO QUISQUINA', 'I356'],
      ['CALAMONACI', 'B377'],
      ['PALMA DI MONTECHIARO', 'G282'],
      ['SAMBUCA DI SICILIA', 'H743'],
      ['SCIACCA', 'I533'],
      ['RACALMUTO', 'H148'],
      ['CASTELTERMINI', 'C275'],
      ['CAMPOBELLO DI LICATA', 'B520'],
      ['SICULIANA', 'I723'],
      ['COMITINI', 'C928'],
      ['RIBERA', 'H269'],
      ['VILLAFRANCA SICULA', 'L944'],
      ['SAN GIOVANNI GEMINI', 'H914'],
      ['AGRIGENTO', 'A089'],
      ['REALMONTE', 'H205'],
      ['ARAGONA', 'A351'],
      ['ALESSANDRIA DELLA ROCCA', 'A181'],
      ['CATTOLICA ERACLEA', 'C356'],
      ['LUCCA SICULA', 'E714'],
      ['MONTALLEGRO', 'F414'],
      ['CANICATTI\'', 'B602'],
      ['MONTEVAGO', 'F655'],
      ['CIANCIANA', 'C668'],
      ['GROTTE', 'E209'],
      ['CAMMARATA', 'B486'],
      ['RAVANUSA', 'H194'],
      ['LAMPEDUSA E LINOSA', 'E431'],
      ['SAN BIAGIO PLATANI', 'H778'],
      ['RAFFADALI', 'H159'],
      ['SANT\'ANGELO MUXARO', 'I290'],
      ['JOPPOLO GIANCAXIO', 'E390'],
      ['BIVONA', 'A896'],
      ['SANTA MARGHERITA DI BELICE', 'I224'],
      ['PORTO EMPEDOCLE', 'F299'],
      ['NARO', 'F845'],
      ['LICATA', 'E573'],
      ['CAMASTRA', 'B460'],
      ['MENFI', 'F126'],
      ['CASTROFILIPPO', 'C341'],
      ['BURGIO', 'B275'],
      ['SANTA ELISABETTA', 'I185'],
      ['CALTABELLOTTA', 'B427'],
      ['FAVARA', 'D514']
    ],
    AL: [
      ['ACQUI TERME', 'A052'],
      ['GAVI', 'D944'],
      ['GAVAZZANA', 'D941'],
      ['PIETRA MARAZZI', 'G619'],
      ['SAN SALVATORE MONFERRATO', 'I144'],
      ['CASTELLANIA', 'C137'],
      ['QUATTORDIO', 'H121'],
      ['BERGAMASCO', 'A793'],
      ['CARREGA LIGURE', 'B836'],
      ['CASTELLETTO D\'ERRO', 'C156'],
      ['CASTELLETTO D\'ORBA', 'C158'],
      ['QUARGNENTO', 'H104'],
      ['SAN CRISTOFORO', 'H810'],
      ['CARPENETO', 'B818'],
      ['MASIO', 'F015'],
      ['CABELLA LIGURE', 'B311'],
      ['CASSINE', 'C027'],
      ['CASAL CERMELLI', 'B870'],
      ['MONTEMARZINO', 'F562'],
      ['OVIGLIO', 'G199'],
      ['OTTIGLIO', 'G193'],
      ['OVADA', 'G197'],
      ['ALBERA LIGURE', 'A146'],
      ['PARODI LIGURE', 'G338'],
      ['MALVICINO', 'E870'],
      ['VALMACCA', 'L633'],
      ['CARBONARA SCRIVIA', 'B736'],
      ['CELLA MONTE', 'C432'],
      ['CASSINELLE', 'C030'],
      ['STREVI', 'I977'],
      ['TAGLIOLO MONFERRATO', 'L027'],
      ['SAN GIORGIO MONFERRATO', 'H878'],
      ['CASTELSPINA', 'C274'],
      ['TREVILLE', 'L403'],
      ['GAMALERO', 'D890'],
      ['BELFORTE MONFERRATO', 'A738'],
      ['VILLALVERNIA', 'L963'],
      ['PASTURANA', 'G367'],
      ['MELAZZO', 'F096'],
      ['VILLAROMAGNANO', 'M009'],
      ['VIGNALE MONFERRATO', 'L881'],
      ['VIGNOLE BORBERA', 'L887'],
      ['ISOLA SANT\'ANTONIO', 'E360'],
      ['TICINETO', 'L165'],
      ['BORGORATTO ALESSANDRINO', 'B029'],
      ['MOLARE', 'F281'],
      ['MORANO SUL PO', 'F707'],
      ['SPINETO SCRIVIA', 'I911'],
      ['CAPRIATA D\'ORBA', 'B701'],
      ['TERZO', 'L143'],
      ['BISTAGNO', 'A889'],
      ['CONIOLO', 'C962'],
      ['RIVARONE', 'H343'],
      ['MOMPERONE', 'F320'],
      ['PECETTO DI VALENZA', 'G397'],
      ['ARQUATA SCRIVIA', 'A436'],
      ['MERANA', 'F131'],
      ['VIGUZZOLO', 'L904'],
      ['PONZONE', 'G877'],
      ['PONZANO MONFERRATO', 'G872'],
      ['SERRALUNGA DI CREA', 'I645'],
      ['ALZANO SCRIVIA', 'A245'],
      ['ALFIANO NATTA', 'A189'],
      ['ALESSANDRIA', 'A182'],
      ['FRUGAROLO', 'D813'],
      ['FUBINE', 'D814'],
      ['RICALDONE', 'H272'],
      ['PADERNA', 'G215'],
      ['MURISENGO', 'F814'],
      ['MONGIARDINO LIGURE', 'F365'],
      ['CAMAGNA MONFERRATO', 'B453'],
      ['PONTESTURA', 'G858'],
      ['CERRINA', 'C531'],
      ['SAREZZANO', 'I432'],
      ['FELIZZANO', 'D528'],
      ['GABIANO', 'D835'],
      ['ALICE BEL COLLE', 'A197'],
      ['ODALENGO PICCOLO', 'F998'],
      ['OCCIMIANO', 'F995'],
      ['ODALENGO GRANDE', 'F997'],
      ['CUCCARO MONFERRATO', 'D194'],
      ['PONTECURONE', 'G839'],
      ['GARBAGNA', 'D910'],
      ['ROCCHETTA LIGURE', 'H465'],
      ['CASALEGGIO BOIRO', 'B882'],
      ['CASALE MONFERRATO', 'B885'],
      ['BOSIO', 'B080'],
      ['LU', 'E712'],
      ['GIAROLE', 'E015'],
      ['ALLUVIONI CAMBIO\'', 'A211'],
      ['ROCCAFORTE LIGURE', 'H406'],
      ['FRASSINETO PO', 'D780'],
      ['SALA MONFERRATO', 'H677'],
      ['SAN SEBASTIANO CURONE', 'I150'],
      ['MONTACUTO', 'F387'],
      ['SANT\'AGATA FOSSILI', 'I190'],
      ['CANTALUPO LIGURE', 'B629'],
      ['TORTONA', 'L304'],
      ['BOZZOLE', 'B109'],
      ['MONTECASTELLO', 'F455'],
      ['CAMINO', 'B482'],
      ['AVOLASCA', 'A523'],
      ['CASTELLAR GUIDOBONO', 'C142'],
      ['CASTELLAZZO BORMIDA', 'C148'],
      ['RIVALTA BORMIDA', 'H334'],
      ['DENICE', 'D272'],
      ['DERNICE', 'D277'],
      ['TASSAROLO', 'L059'],
      ['CASTELLETTO MONFERRATO', 'C162'],
      ['CASTELLETTO MERLI', 'C160'],
      ['ROSIGNANO MONFERRATO', 'H569'],
      ['GROGNARDO', 'E188'],
      ['CASTELNUOVO BORMIDA', 'C229'],
      ['CARTOSIO', 'B847'],
      ['CARROSIO', 'B840'],
      ['MONTEGIOCO', 'F518'],
      ['MIRABELLO MONFERRATO', 'F232'],
      ['BASSIGNANA', 'A708'],
      ['CASTELNUOVO SCRIVIA', 'C243'],
      ['STAZZANO', 'I941'],
      ['MORSASCO', 'F751'],
      ['VISONE', 'M077'],
      ['POZZOL GROPPO', 'G960'],
      ['POZZOLO FORMIGARO', 'G961'],
      ['SEZZADIO', 'I711'],
      ['FABBRICA CURONE', 'D447'],
      ['CASSANO SPINOLA', 'C005'],
      ['VILLAMIROGLIO', 'L970'],
      ['VILLANOVA MONFERRATO', 'L972'],
      ['MORNESE', 'F737'],
      ['CREMOLINO', 'D149'],
      ['CASASCO', 'B941'],
      ['CAREZZANO', 'B769'],
      ['CARENTINO', 'B765'],
      ['SILVANO D\'ORBA', 'I738'],
      ['VILLADEATI', 'L931'],
      ['MORBELLO', 'F713'],
      ['SPIGNO MONFERRATO', 'I901'],
      ['TRISOBBIO', 'L432'],
      ['BASALUZZO', 'A689'],
      ['BORGO SAN MARTINO', 'B037'],
      ['MOLINO DEI TORTI', 'F293'],
      ['GREMIASCO', 'E164'],
      ['MONCESTINO', 'F337'],
      ['COSTA VESCOVATO', 'D102'],
      ['ORSARA BORMIDA', 'G124'],
      ['CAVATORE', 'C387'],
      ['CASALNOCETO', 'B902'],
      ['GRONDONA', 'E191'],
      ['CONZANO', 'C977'],
      ['MOMBELLO MONFERRATO', 'F313'],
      ['SERRAVALLE SCRIVIA', 'I657'],
      ['CERESETO', 'C503'],
      ['CERRETO GRUE', 'C507'],
      ['BOSCO MARENGO', 'B071'],
      ['SOLERO', 'I798'],
      ['MONLEALE', 'F374'],
      ['PONTI', 'G861'],
      ['BORGHETTO DI BORBERA', 'A998'],
      ['SALE', 'H694'],
      ['PIOVERA', 'G695'],
      ['PRASCO', 'G987'],
      ['PREDOSA', 'H021'],
      ['FRANCAVILLA BISIO', 'D759'],
      ['NOVI LIGURE', 'F965'],
      ['OZZANO MONFERRATO', 'G204'],
      ['TERRUGGIA', 'L139'],
      ['BERZANO DI TORTONA', 'A813'],
      ['BALZOLA', 'A605'],
      ['PARETO', 'G334'],
      ['BRIGNANO-FRASCATA', 'B179'],
      ['SARDIGLIANO', 'I429'],
      ['FRASSINELLO MONFERRATO', 'D777'],
      ['FRASCARO', 'D770'],
      ['OLIVOLA', 'G042'],
      ['GUAZZORA', 'E255'],
      ['MONTALDEO', 'F403'],
      ['MONTALDO BORMIDA', 'F404'],
      ['ALTAVILLA MONFERRATO', 'A227'],
      ['FRESONARA', 'D797'],
      ['VALENZA', 'L570'],
      ['POMARO MONFERRATO', 'G807'],
      ['MONTECHIARO D\'ACQUI', 'F469'],
      ['VOLPEDO', 'M120'],
      ['VOLPEGLINO', 'M121'],
      ['VOLTAGGIO', 'M123'],
      ['LERMA', 'E543'],
      ['ROCCA GRIMALDA', 'H414'],
      ['SOLONGHELLO', 'I808'],
      ['FRACONALTO', 'D559']
    ],
    AN: [
      ['OFFAGNA', 'G003'],
      ['CHIARAVALLE', 'C615'],
      ['MONTE ROBERTO', 'F600'],
      ['CASTELLEONE DI SUASA', 'C152'],
      ['ROSORA', 'H575'],
      ['FILOTTRANO', 'D597'],
      ['MONTEMARCIANO', 'F560'],
      ['RIPE', 'H322'],
      ['SANTA MARIA NUOVA', 'I251'],
      ['MORRO D\'ALBA', 'F745'],
      ['OSIMO', 'G157'],
      ['MAIOLATI SPONTINI', 'E837'],
      ['CASTEL COLONNA', 'C071'],
      ['STAFFOLO', 'I932'],
      ['OSTRA VETERE', 'F581'],
      ['SAN MARCELLO', 'H979'],
      ['CAMERATA PICENA', 'B470'],
      ['SERRA DE\' CONTI', 'I643'],
      ['NUMANA', 'F978'],
      ['JESI', 'E388'],
      ['CASTELFIDARDO', 'C100'],
      ['MONSANO', 'F381'],
      ['ANCONA', 'A271'],
      ['LORETO', 'E690'],
      ['MONTECAROTTO', 'F453'],
      ['CUPRAMONTANA', 'D211'],
      ['SAN PAOLO DI JESI', 'I071'],
      ['CORINALDO', 'D007'],
      ['SENIGALLIA', 'I608'],
      ['MONTE SAN VITO', 'F634'],
      ['BELVEDERE OSTRENSE', 'A769'],
      ['SIROLO', 'I758'],
      ['CASTELPLANIO', 'C248'],
      ['POGGIO SAN MARCELLO', 'G771'],
      ['CASTELBELLINO', 'C060'],
      ['CERRETO D\'ESI', 'C524'],
      ['AGUGLIANO', 'A092'],
      ['MONTERADO', 'F593'],
      ['FABRIANO', 'D451'],
      ['FALCONARA MARITTIMA', 'D472'],
      ['CAMERANO', 'B468'],
      ['SERRA SAN QUIRICO', 'I653'],
      ['SASSOFERRATO', 'I461'],
      ['ARCEVIA', 'A366'],
      ['BARBARA', 'A626'],
      ['MERGO', 'F145'],
      ['OSTRA', 'F401'],
      ['GENGA', 'D965'],
      ['POLVERIGI', 'G803']
    ],
    AO: [
      ['GIGNOD', 'E029'],
      ['FENIS', 'D537'],
      ['ARNAD', 'A424'],
      ['COURMAYEUR', 'D012'],
      ['VALTOURNENCHE', 'L654'],
      ['ROISAN', 'H497'],
      ['BRISSOGNE', 'B192'],
      ['RHEMES-NOTRE-DAME', 'H262'],
      ['RHEMES-SAINT-GEORGES', 'H263'],
      ['EMARESE', 'D402'],
      ['ARVIER', 'A452'],
      ['AYMAVILLES', 'A108'],
      ['CHATILLON', 'C294'],
      ['CHAMPORCHER', 'B540'],
      ['LILLIANES', 'E587'],
      ['ISSIME', 'E369'],
      ['INTROD', 'E306'],
      ['DOUES', 'D356'],
      ['MONTJOVET', 'F367'],
      ['PONT-SAINT-MARTIN', 'G854'],
      ['COGNE', 'C821'],
      ['GABY', 'D839'],
      ['MORGEX', 'F726'],
      ['OYACE', 'G012'],
      ['SAINT-OYEN', 'H673'],
      ['SAINT-NICOLAS', 'H672'],
      ['SAINT-MARCEL', 'H671'],
      ['SAINT-DENIS', 'H670'],
      ['SAINT-VINCENT', 'H676'],
      ['SAINT-RHEMY-EN-BOSSES', 'H675'],
      ['SAINT-PIERRE', 'H674'],
      ['VILLENEUVE', 'L981'],
      ['CHALLAND-SAINT-ANSELME', 'C593'],
      ['CHAMPDEPRAZ', 'C596'],
      ['CHAMBAVE', 'C595'],
      ['CHALLAND-SAINT-VICTOR', 'C594'],
      ['CHARVENSOD', 'C598'],
      ['AVISE', 'A521'],
      ['VERRES', 'C282'],
      ['QUART', 'H110'],
      ['FONTAINEMORE', 'D666'],
      ['VALGRISENCHE', 'L582'],
      ['CHAMOIS', 'B491'],
      ['VALPELLINE', 'L643'],
      ['VALSAVARENCHE', 'L647'],
      ['LA SALLE', 'E458'],
      ['PERLOZ', 'G459'],
      ['LA THUILE', 'E470'],
      ['ETROUBLES', 'D444'],
      ['BIONAZ', 'A877'],
      ['ANTEY-SAINT-ANDRE\'', 'A305'],
      ['LA MAGDELEINE', 'A308'],
      ['AYAS', 'A094'],
      ['VERRAYES', 'L783'],
      ['BRUSSON', 'B230'],
      ['ISSOGNE', 'E371'],
      ['DONNAS', 'D338'],
      ['GRESSAN', 'E165'],
      ['GRESSONEY-LA-TRINITE\'', 'E167'],
      ['GRESSONEY-SAINT-JEAN', 'E168'],
      ['AOSTA', 'A326'],
      ['TORGNON', 'L217'],
      ['SARRE', 'I442'],
      ['BARD', 'A643'],
      ['PONTEY', 'G860'],
      ['HONE', 'E273'],
      ['PONTBOSET', 'G545'],
      ['PRE\'-SAINT-DIDIER', 'H042'],
      ['OLLOMONT', 'G045'],
      ['NUS', 'F987'],
      ['JOVENCAN', 'E391'],
      ['SAINT-CHRISTOPHE', 'H669'],
      ['POLLEIN', 'G794'],
      ['ALLEIN', 'A205']
    ],
    AP: [
      ['OFFIDA', 'G005'],
      ['CASTEL DI LAMA', 'C093'],
      ['MONTE VIDON COMBATTE', 'F664'],
      ['MONTE VIDON CORRADO', 'F665'],
      ['PALMIANO', 'G289'],
      ['PEDASO', 'G403'],
      ['MONTE SAN PIETRANGELI', 'F626'],
      ['MONTEDINOVE', 'F487'],
      ['SANTA VITTORIA IN MATENANO', 'I315'],
      ['FERMO', 'D542'],
      ['TORRE SAN PATRIZIO', 'L279'],
      ['MONTELPARO', 'F549'],
      ['FOLIGNANO', 'D652'],
      ['LAPEDONA', 'E447'],
      ['MONTEFORTINO', 'F509'],
      ['MONTEFIORE DELL\'ASO', 'F501'],
      ['MONTEGIORGIO', 'F520'],
      ['MONTEGRANARO', 'F522'],
      ['COSSIGNANO', 'D096'],
      ['SERVIGLIANO', 'C070'],
      ['SPINETOLI', 'I912'],
      ['APPIGNANO DEL TRONTO', 'A335'],
      ['FORCE', 'D691'],
      ['ORTEZZANO', 'G137'],
      ['ARQUATA DEL TRONTO', 'A437'],
      ['PONZANO DI FERMO', 'G873'],
      ['PETRITOLI', 'G516'],
      ['MONTOTTONE', 'F697'],
      ['CASTORANO', 'C331'],
      ['FRANCAVILLA D\'ETE', 'D760'],
      ['MONTALTO DELLE MARCHE', 'F415'],
      ['MORESCO', 'F722'],
      ['MONTE URANO', 'F653'],
      ['MONSAMPOLO DEL TRONTO', 'F380'],
      ['MASSIGNANO', 'F044'],
      ['ACQUAVIVA PICENA', 'A047'],
      ['ACQUASANTA TERME', 'A044'],
      ['GROTTAMMARE', 'E207'],
      ['GROTTAZZOLINA', 'E208'],
      ['AMANDOLA', 'A252'],
      ['MASSA FERMANA', 'F021'],
      ['CUPRA MARITTIMA', 'D210'],
      ['MONTERUBBIANO', 'F614'],
      ['MONTEFALCONE APPENNINO', 'F493'],
      ['SANT\'ELPIDIO A MARE', 'I324'],
      ['MONTEMONACO', 'F570'],
      ['ALTIDONA', 'A233'],
      ['BELMONTE PICENO', 'A760'],
      ['MONTEGALLO', 'F516'],
      ['MONTE GIBERTO', 'F517'],
      ['ROCCAFLUVIONE', 'H390'],
      ['VENAROTTA', 'L728'],
      ['MALTIGNANO', 'E868'],
      ['CARASSAI', 'B727'],
      ['SMERILLO', 'I774'],
      ['RIPATRANSONE', 'H321'],
      ['CAMPOFILONE', 'B534'],
      ['MONTELEONE DI FERMO', 'F536'],
      ['MAGLIANO DI TENNA', 'E807'],
      ['COMUNANZA', 'C935'],
      ['ASCOLI PICENO', 'A462'],
      ['PORTO SAN GIORGIO', 'G920'],
      ['PORTO SANT\'ELPIDIO', 'G921'],
      ['SAN BENEDETTO DEL TRONTO', 'H769'],
      ['MONTEPRANDONE', 'F591'],
      ['MONTE RINALDO', 'F599'],
      ['FALERONE', 'D477'],
      ['ROTELLA', 'H588'],
      ['MONSAMPIETRO MORICO', 'F379'],
      ['MONTAPPONE', 'F428'],
      ['CASTIGNANO', 'C321'],
      ['RAPAGNANO', 'H182'],
      ['COLLI DEL TRONTO', 'C877']
    ],
    AQ: [
      ['OFENA', 'G002'],
      ['SAN PIO DELLE CAMERE', 'I121'],
      ['ROCCARASO', 'H434'],
      ['CELANO', 'C426'],
      ['TRASACCO', 'L334'],
      ['CAGNANO AMITERNO', 'B358'],
      ['CASTEL DI IERI', 'C090'],
      ['CASTEL DI SANGRO', 'C096'],
      ['CAPITIGNANO', 'B658'],
      ['CAPESTRANO', 'B651'],
      ['CAPISTRELLO', 'B656'],
      ['SAN DEMETRIO NE\' VESTINI', 'H819'],
      ['AVEZZANO', 'A515'],
      ['CAPORCIANO', 'B672'],
      ['CAPPADOCIA', 'B677'],
      ['RAIANO', 'H166'],
      ['SANT\'EUSANIO FORCONESE', 'I336'],
      ['PERETO', 'G449'],
      ['CIVITELLA ROVETO', 'C783'],
      ['TAGLIACOZZO', 'L025'],
      ['VILLETTA BARREA', 'M041'],
      ['MAGLIANO DE\' MARSI', 'E811'],
      ['POGGIO PICENZE', 'G766'],
      ['CASTELVECCHIO CALVISIO', 'C278'],
      ['CASTELVECCHIO SUBEQUO', 'C279'],
      ['CAMPO DI GIOVE', 'B526'],
      ['PESCASSEROLI', 'G484'],
      ['SECINARO', 'I558'],
      ['SCURCOLA MARSICANA', 'I553'],
      ['PIZZOLI', 'G726'],
      ['ANVERSA DEGLI ABRUZZI', 'A318'],
      ['CAMPOTOSTO', 'B569'],
      ['VILLA SANTA LUCIA DEGLI ABRUZZI', 'M021'],
      ['VILLA SANT\'ANGELO', 'M023'],
      ['BARREA', 'A678'],
      ['INTRODACQUA', 'E307'],
      ['BISEGNA', 'A884'],
      ['NAVELLI', 'F852'],
      ['FAGNANO ALTO', 'D465'],
      ['BARETE', 'A656'],
      ['AIELLI', 'A100'],
      ['CIVITA D\'ANTINO', 'C766'],
      ['ALFEDENA', 'A187'],
      ['MORINO', 'F732'],
      ['OPI', 'G079'],
      ['PACENTRO', 'G210'],
      ['ROCCACASALE', 'H389'],
      ['PRATA D\'ANSIDONIA', 'G992'],
      ['LECCE NEI MARSI', 'E505'],
      ['OCRE', 'F996'],
      ['SAN VINCENZO VALLE ROVETO', 'I389'],
      ['PREZZA', 'H056'],
      ['COLLELONGO', 'C862'],
      ['COLLEPIETRO', 'C866'],
      ['ROCCA DI CAMBIO', 'H400'],
      ['ROCCA DI MEZZO', 'H402'],
      ['CANISTRO', 'B606'],
      ['CALASCIO', 'B382'],
      ['MOLINA ATERNO', 'M255'],
      ['COLLARMELE', 'C844'],
      ['ROCCA PIA', 'H429'],
      ['CANSANO', 'B624'],
      ['CASTELLAFIUME', 'C126'],
      ['FONTECCHIO', 'D681'],
      ['MASSA D\'ALBE', 'F022'],
      ['TORNIMPARTE', 'L227'],
      ['CASTEL DEL MONTE', 'C083'],
      ['SAN BENEDETTO DEI MARSI', 'H772'],
      ['SAN BENEDETTO IN PERILLIS', 'H773'],
      ['SANTE MARIE', 'I326'],
      ['CARSOLI', 'B842'],
      ['CARAPELLE CALVISIO', 'B725'],
      ['SANTO STEFANO DI SESSANIO', 'I360'],
      ['CERCHIO', 'C492'],
      ['ORTUCCHIO', 'G145'],
      ['ORTONA DEI MARSI', 'G142'],
      ['PESCINA', 'G492'],
      ['PESCOCOSTANZO', 'G493'],
      ['SCOPPITO', 'I546'],
      ['SCONTRONE', 'I543'],
      ['TIONE DEGLI ABRUZZI', 'L173'],
      ['SULMONA', 'I804'],
      ['VILLALAGO', 'L958'],
      ['VILLAVALLELONGA', 'M031'],
      ['ORICOLA', 'G102'],
      ['RIVISONDOLI', 'H353'],
      ['MONTEREALE', 'F595'],
      ['BARISCIANO', 'A667'],
      ['GAGLIANO ATERNO', 'D850'],
      ['L\'AQUILA', 'A345'],
      ['BUGNARA', 'B256'],
      ['PRATOLA PELIGNA', 'H007'],
      ['FOSSA', 'D736'],
      ['CIVITELLA ALFEDENA', 'C778'],
      ['CORFINIO', 'C999'],
      ['ROCCA DI BOTTE', 'H399'],
      ['VITTORITO', 'M090'],
      ['PETTORANO SUL GIZIO', 'G524'],
      ['OVINDOLI', 'G200'],
      ['BALSORANO', 'A603'],
      ['GIOIA DEI MARSI', 'E040'],
      ['COCULLO', 'C811'],
      ['ACCIANO', 'A018'],
      ['ATELETA', 'A481'],
      ['SCANNO', 'I501'],
      ['LUCO DEI MARSI', 'E723'],
      ['LUCOLI', 'E724'],
      ['GORIANO SICOLI', 'E096']
    ],
    AR: [
      ['CASTELFRANCO DI SOPRA', 'C112'],
      ['CORTONA', 'D077'],
      ['LORO CIUFFENNA', 'E693'],
      ['MONTE SAN SAVINO', 'F628'],
      ['PIEVE SANTO STEFANO', 'G653'],
      ['CAPOLONA', 'B670'],
      ['MONTEMIGNAIO', 'F565'],
      ['CAPRESE MICHELANGELO', 'B693'],
      ['LATERINA', 'E468'],
      ['STIA', 'I952'],
      ['ORTIGNANO RAGGIOLO', 'G139'],
      ['TERRANUOVA BRACCIOLINI', 'L123'],
      ['BUCINE', 'B243'],
      ['POPPI', 'G879'],
      ['AREZZO', 'A390'],
      ['SUBBIANO', 'I991'],
      ['PIAN DI SCO', 'G552'],
      ['LUCIGNANO', 'E718'],
      ['CASTIGLION FIORENTINO', 'C319'],
      ['CASTIGLION FIBOCCHI', 'C318'],
      ['CHITIGNANO', 'C648'],
      ['CAVRIGLIA', 'C407'],
      ['SANSEPOLCRO', 'I155'],
      ['CASTEL FOCOGNANO', 'C102'],
      ['MONTEVARCHI', 'F656'],
      ['CHIUSI DELLA VERNA', 'C663'],
      ['SESTINO', 'I681'],
      ['FOIANO DELLA CHIANA', 'D649'],
      ['ANGHIARI', 'A291'],
      ['BADIA TEDALDA', 'A541'],
      ['TALLA', 'L038'],
      ['BIBBIENA', 'A851'],
      ['CASTEL SAN NICCOLO\'', 'C263'],
      ['MONTERCHI', 'F594'],
      ['SAN GIOVANNI VALDARNO', 'H901'],
      ['PERGINE VALDARNO', 'G451'],
      ['PRATOVECCHIO', 'H008'],
      ['CIVITELLA IN VAL DI CHIANA', 'C774'],
      ['MARCIANO DELLA CHIANA', 'E933']
    ],
    AT: [
      ['VIARIGI', 'L834'],
      ['CALAMANDRANA', 'B376'],
      ['CORTAZZONE', 'D052'],
      ['CORTANZE', 'D051'],
      ['CORTANDONE', 'D050'],
      ['CUNICO', 'D207'],
      ['CANTARANA', 'B633'],
      ['AGLIANO TERME', 'A072'],
      ['SETTIME', 'I698'],
      ['CORTIGLIONE', 'D072'],
      ['CELLE ENOMONDO', 'C440'],
      ['CASTELLERO', 'C154'],
      ['QUARANTI', 'H102'],
      ['FONTANILE', 'D678'],
      ['SAN DAMIANO D\'ASTI', 'H811'],
      ['VESIME', 'L807'],
      ['CASSINASCO', 'C022'],
      ['DUSINO SAN MICHELE', 'D388'],
      ['PINO D\'ASTI', 'G676'],
      ['CASTELNUOVO DON BOSCO', 'C232'],
      ['CASTELNUOVO CALCEA', 'C230'],
      ['VIALE D\'ASTI', 'L829'],
      ['FRINCO', 'D802'],
      ['CASORZO', 'B991'],
      ['BELVEGLIO', 'A770'],
      ['CASTEL ROCCHERO', 'C253'],
      ['MONTEGROSSO D\'ASTI', 'F527'],
      ['SAN GIORGIO SCARAMPI', 'H899'],
      ['GRANA', 'E134'],
      ['SCURZOLENGO', 'I555'],
      ['ASTI', 'A479'],
      ['PASSERANO MARMORITO', 'G358'],
      ['TIGLIOLE', 'L168'],
      ['VILLAFRANCA D\'ASTI', 'L945'],
      ['ANTIGNANO', 'A312'],
      ['MORANSENGO', 'F709'],
      ['CHIUSANO D\'ASTI', 'C658'],
      ['COSTIGLIOLE D\'ASTI', 'D119'],
      ['CAPRIGLIO', 'B707'],
      ['TONCO', 'L203'],
      ['TONENGO', 'L204'],
      ['MARETTO', 'E944'],
      ['MONASTERO BORMIDA', 'F325'],
      ['MONALE', 'F323'],
      ['SOGLIO', 'I781'],
      ['GRAZZANO BADOGLIO', 'E159'],
      ['ARAMENGO', 'A352'],
      ['ROATTO', 'H366'],
      ['MOMBALDONE', 'F308'],
      ['MONGARDINO', 'F361'],
      ['CERRO TANARO', 'C533'],
      ['MONCUCCO TORINESE', 'F343'],
      ['COAZZOLO', 'C804'],
      ['COCCONATO', 'C807'],
      ['ROCCHETTA PALAFEA', 'H466'],
      ['ROCCHETTA TANARO', 'H468'],
      ['BRUNO', 'B221'],
      ['SAN MARZANO OLIVETO', 'I017'],
      ['MONTABONE', 'F386'],
      ['CORSIONE', 'D046'],
      ['PIEA', 'G593'],
      ['CANELLI', 'B594'],
      ['CELLARENGO', 'C438'],
      ['CASTELL\'ALFERO', 'C127'],
      ['PENANGO', 'G430'],
      ['CALLIANO', 'B418'],
      ['AZZANO D\'ASTI', 'A527'],
      ['SAN PAOLO SOLBRITO', 'I076'],
      ['MONTEMAGNO', 'F556'],
      ['CASTELLETTO MOLINA', 'C161'],
      ['VIGLIANO D\'ASTI', 'L879'],
      ['PORTACOMARO', 'G894'],
      ['ALBUGNANO', 'A173'],
      ['BUTTIGLIERA D\'ASTI', 'B306'],
      ['CASTELNUOVO BELBO', 'C226'],
      ['VINCHIO', 'M058'],
      ['MOASCA', 'F254'],
      ['LOAZZOLO', 'E633'],
      ['BALDICHIERI D\'ASTI', 'A588'],
      ['VILLA SAN SECONDO', 'M019'],
      ['CASTEL BOGLIONE', 'C064'],
      ['CASTELLO DI ANNONE', 'A300'],
      ['REVIGLIASCO D\'ASTI', 'H250'],
      ['BUBBIO', 'B236'],
      ['CASTAGNOLE DELLE LANZE', 'C049'],
      ['CISTERNA D\'ASTI', 'C739'],
      ['CASTAGNOLE MONFERRATO', 'C047'],
      ['NIZZA MONFERRATO', 'F902'],
      ['MONCALVO', 'F336'],
      ['COSSOMBRATO', 'D101'],
      ['SESSAME', 'I678'],
      ['REFRANCORE', 'H219'],
      ['MOMBARUZZO', 'F311'],
      ['MOMBERCELLI', 'F316'],
      ['CAMERANO CASASCO', 'B469'],
      ['ISOLA D\'ASTI', 'E338'],
      ['CINAGLIO', 'C701'],
      ['MONTIGLIO MONFERRATO', 'M302'],
      ['ROCCA D\'ARAZZO', 'H392'],
      ['SEROLE', 'I637'],
      ['PIOVA\' MASSAIA', 'G692'],
      ['CERRETO D\'ASTI', 'C528'],
      ['MONTAFIA', 'F390'],
      ['VAGLIO SERRA', 'L531'],
      ['INCISA SCAPACCINO', 'E295'],
      ['CALOSSO', 'B425'],
      ['BERZANO DI SAN PIETRO', 'A812'],
      ['ROCCAVERANO', 'H451'],
      ['OLMO GENTILE', 'G048'],
      ['VILLANOVA D\'ASTI', 'L984'],
      ['MONTALDO SCARAMPI', 'F409'],
      ['SAN MARTINO ALFIERI', 'H987'],
      ['VALFENERA', 'L574'],
      ['MONTECHIARO D\'ASTI', 'F468'],
      ['CESSOLE', 'C583'],
      ['MARANZANA', 'E917'],
      ['ROBELLA', 'H376'],
      ['FERRERE', 'D554']
    ],
    AV: [
      ['SAN POTITO ULTRA', 'I129'],
      ['GROTTOLELLA', 'E214'],
      ['CALABRITTO', 'B374'],
      ['MONTEVERDE', 'F660'],
      ['MONTECALVO IRPINO', 'F448'],
      ['PIETRADEFUSI', 'G611'],
      ['MANOCALZATI', 'E891'],
      ['QUINDICI', 'H128'],
      ['SORBO SERPICO', 'I843'],
      ['LUOGOSANO', 'E746'],
      ['SAN NICOLA BARONIA', 'I061'],
      ['FONTANAROSA', 'D671'],
      ['ZUNGOLI', 'M203'],
      ['TAURASI', 'L062'],
      ['TORRE LE NOCELLE', 'L272'],
      ['MONTELLA', 'F546'],
      ['CAPOSELE', 'B674'],
      ['ANDRETTA', 'A284'],
      ['MARZANO DI NOLA', 'E997'],
      ['LAPIO', 'E448'],
      ['SUMMONTE', 'L004'],
      ['MONTEMILETTO', 'F566'],
      ['TREVICO', 'L399'],
      ['CASSANO IRPINO', 'B997'],
      ['FLUMERI', 'D638'],
      ['SANTO STEFANO DEL SOLE', 'I357'],
      ['ROCCA SAN FELICE', 'H438'],
      ['LIONI', 'E605'],
      ['MOSCHIANO', 'F762'],
      ['MONTEFORTE IRPINO', 'F506'],
      ['VALLESACCARDA', 'L616'],
      ['LAURO', 'E487'],
      ['MORRA DE SANCTIS', 'F744'],
      ['PATERNOPOLI', 'G370'],
      ['ATRIPALDA', 'A489'],
      ['VILLAMAINA', 'L965'],
      ['CASTEL BARONIA', 'C058'],
      ['CAPRIGLIA IRPINA', 'B706'],
      ['CERVINARA', 'C557'],
      ['MELITO IRPINO', 'F110'],
      ['BISACCIA', 'A881'],
      ['ROCCABASCERANA', 'H382'],
      ['SAN MANGO SUL CALORE', 'H975'],
      ['TUFO', 'L461'],
      ['AIELLO DEL SABATO', 'A101'],
      ['ROTONDI', 'H592'],
      ['SANT\'ANGELO ALL\'ESCA', 'I279'],
      ['CESINALI', 'C576'],
      ['SPERONE', 'I893'],
      ['BAIANO', 'A580'],
      ['SAVIGNANO IRPINO', 'I471'],
      ['FORINO', 'D701'],
      ['PETRURO IRPINO', 'G519'],
      ['TEORA', 'L102'],
      ['TORRIONI', 'L301'],
      ['SAN MARTINO VALLE CAUDINA', 'I016'],
      ['CARIFE', 'B776'],
      ['SCAMPITELLA', 'I493'],
      ['QUADRELLE', 'H097'],
      ['PRATA DI PRINCIPATO ULTRA', 'G990'],
      ['ARIANO IRPINO', 'A399'],
      ['STURNO', 'I990'],
      ['MONTORO INFERIORE', 'F693'],
      ['MONTORO SUPERIORE', 'F694'],
      ['VENTICANO', 'L739'],
      ['GESUALDO', 'D998'],
      ['SENERCHIA', 'I606'],
      ['GUARDIA LOMBARDI', 'E245'],
      ['CALITRI', 'B415'],
      ['CASTELFRANCI', 'C105'],
      ['BONITO', 'A975'],
      ['VOLTURARA IRPINA', 'M130'],
      ['SANTA LUCIA DI SERINO', 'I219'],
      ['CANDIDA', 'B590'],
      ['GROTTAMINARDA', 'E206'],
      ['CAIRANO', 'B367'],
      ['CHIANCHE', 'C606'],
      ['AVELLA', 'A508'],
      ['AVELLINO', 'A509'],
      ['PIETRASTORNINA', 'G629'],
      ['SANTA PAOLINA', 'I301'],
      ['VALLATA', 'L589'],
      ['MONTEMARANO', 'F559'],
      ['MONTEFALCIONE', 'F491'],
      ['CASALBORE', 'B866'],
      ['MUGNANO DEL CARDINALE', 'F798'],
      ['TAURANO', 'L061'],
      ['SIRIGNANO', 'I756'],
      ['MONTEFREDANE', 'F511'],
      ['MONTEFUSCO', 'F512'],
      ['SANT\'ANGELO DEI LOMBARDI', 'I281'],
      ['SANT\'ANGELO A SCALA', 'I280'],
      ['MIRABELLA ECLANO', 'F230'],
      ['BAGNOLI IRPINO', 'A566'],
      ['SALZA IRPINA', 'H733'],
      ['CHIUSANO DI SAN DOMENICO', 'C659'],
      ['VILLANOVA DEL BATTISTA', 'L973'],
      ['OSPEDALETTO D\'ALPINOLO', 'G165'],
      ['PAROLISE', 'G340'],
      ['CASTELVETERE SUL CALORE', 'C283'],
      ['DOMICELLA', 'D331'],
      ['GRECI', 'E161'],
      ['TORELLA DEI LOMBARDI', 'L214'],
      ['AQUILONIA', 'A347'],
      ['PAGO DEL VALLO DI LAURO', 'G242'],
      ['CONTRADA', 'C971'],
      ['CONZA DELLA CAMPANIA', 'C976'],
      ['SANT\'ANDREA DI CONZA', 'I264'],
      ['PRATOLA SERRA', 'H006'],
      ['SERINO', 'I630'],
      ['MERCOGLIANO', 'F141'],
      ['MONTAGUTO', 'F397'],
      ['SAN MICHELE DI SERINO', 'I034'],
      ['NUSCO', 'F988'],
      ['SAN SOSSIO BARONIA', 'I163'],
      ['LACEDONIA', 'E397'],
      ['ALTAVILLA IRPINA', 'A228'],
      ['FRIGENTO', 'D798'],
      ['SOLOFRA', 'I805']
    ],
    BA: [
      ['CANOSA DI PUGLIA', 'B619'],
      ['RUVO DI PUGLIA', 'H645'],
      ['RUTIGLIANO', 'H643'],
      ['ADELFIA', 'A055'],
      ['GIOIA DEL COLLE', 'E038'],
      ['CASTELLANA GROTTE', 'C134'],
      ['SAMMICHELE DI BARI', 'H749'],
      ['BITONTO', 'A893'],
      ['SANTERAMO IN COLLE', 'I330'],
      ['ANDRIA', 'A285'],
      ['ALBEROBELLO', 'A149'],
      ['CASSANO DELLE MURGE', 'B998'],
      ['MINERVINO MURGE', 'F220'],
      ['CAPURSO', 'B716'],
      ['POGGIORSINI', 'G769'],
      ['MODUGNO', 'F262'],
      ['LOCOROTONDO', 'E645'],
      ['TRIGGIANO', 'L425'],
      ['TORITTO', 'L220'],
      ['MOLFETTA', 'F284'],
      ['MOLA DI BARI', 'F280'],
      ['NOCI', 'F915'],
      ['BISCEGLIE', 'A883'],
      ['TRANI', 'L328'],
      ['GRAVINA IN PUGLIA', 'E155'],
      ['CORATO', 'C983'],
      ['TERLIZZI', 'L109'],
      ['PUTIGNANO', 'H096'],
      ['POLIGNANO A MARE', 'G787'],
      ['GRUMO APPULA', 'E223'],
      ['SANNICANDRO DI BARI', 'I053'],
      ['PALO DEL COLLE', 'G291'],
      ['ACQUAVIVA DELLE FONTI', 'A048'],
      ['CELLAMARE', 'C436'],
      ['ALTAMURA', 'A225'],
      ['BITRITTO', 'A894'],
      ['BITETTO', 'A892'],
      ['BINETTO', 'A874'],
      ['SPINAZZOLA', 'I907'],
      ['BARLETTA', 'A669'],
      ['BARI', 'A662'],
      ['NOICATTARO', 'F923'],
      ['CONVERSANO', 'C975'],
      ['TURI', 'L472'],
      ['CASAMASSIMA', 'B923'],
      ['MONOPOLI', 'F376'],
      ['GIOVINAZZO', 'E047'],
      ['VALENZANO', 'L571']
    ],
    BG: [
      ['CANONICA D\'ADDA', 'B618'],
      ['ADRARA SAN MARTINO', 'A057'],
      ['ADRARA SAN ROCCO', 'A058'],
      ['GRUMELLO DEL MONTE', 'E219'],
      ['BRACCA', 'B112'],
      ['UBIALE CLANEZZO', 'C789'],
      ['GAVERINA TERME', 'D943'],
      ['SELVINO', 'I597'],
      ['BREMBATE', 'B137'],
      ['FORESTO SPARSO', 'D697'],
      ['BREMBATE DI SOPRA', 'B138'],
      ['CHIGNOLO D\'ISOLA', 'C635'],
      ['BERGAMO', 'A794'],
      ['ALZANO LOMBARDO', 'A246'],
      ['COLOGNO AL SERIO', 'C894'],
      ['SANTA BRIGIDA', 'I168'],
      ['VIGANO SAN MARTINO', 'L865'],
      ['FONTANELLA', 'D672'],
      ['CORNALBA', 'D016'],
      ['CORNA IMAGNA', 'D015'],
      ['ZANICA', 'M147'],
      ['ZANDOBBIO', 'M144'],
      ['AVIATICO', 'A517'],
      ['AVERARA', 'A511'],
      ['CERETE', 'C506'],
      ['SOTTO IL MONTE GIOVANNI XXIII', 'I869'],
      ['LALLIO', 'E422'],
      ['DALMINE', 'D245'],
      ['ALBINO', 'A163'],
      ['SAN PAOLO D\'ARGON', 'B310'],
      ['VALTORTA', 'L655'],
      ['ROGNO', 'H492'],
      ['GRONE', 'E192'],
      ['MOZZANICA', 'F786'],
      ['SCHILPARIO', 'I530'],
      ['VIADANICA', 'L827'],
      ['GANDELLINO', 'D903'],
      ['CARAVAGGIO', 'B731'],
      ['ZOGNO', 'M184'],
      ['GANDINO', 'D905'],
      ['GANDOSSO', 'D906'],
      ['LURANO', 'E751'],
      ['CASTEL ROZZONE', 'C255'],
      ['VILLA D\'OGNA', 'L938'],
      ['CARVICO', 'B854'],
      ['VILLONGO', 'M045'],
      ['ALBANO SANT\'ALESSANDRO', 'A129'],
      ['VALLEVE', 'L623'],
      ['MISANO DI GERA D\'ADDA', 'F243'],
      ['CAPRINO BERGAMASCO', 'B710'],
      ['STEZZANO', 'I951'],
      ['ENDINE GAIANO', 'D406'],
      ['TREVIOLO', 'L404'],
      ['TREVIGLIO', 'L400'],
      ['OSIO SOPRA', 'G159'],
      ['PUMENENGO', 'H091'],
      ['BEDULITA', 'A732'],
      ['CASTELLI CALEPIO', 'C079'],
      ['BIANZANO', 'A846'],
      ['LOCATELLO', 'E640'],
      ['CREDARO', 'D139'],
      ['FUIPIANO VALLE IMAGNA', 'D817'],
      ['CASNIGO', 'B978'],
      ['CASIRATE D\'ADDA', 'B971'],
      ['CISANO BERGAMASCO', 'C728'],
      ['SPINONE AL LAGO', 'I916'],
      ['SPIRANO', 'I919'],
      ['COSTA VOLPINO', 'D117'],
      ['COSTA DI MEZZATE', 'D110'],
      ['COSTA DI SERINA', 'D111'],
      ['SAN GIOVANNI BIANCO', 'H910'],
      ['ORNICA', 'G118'],
      ['CAPRIATE SAN GERVASIO', 'B703'],
      ['ALGUA', 'A193'],
      ['LEVATE', 'E562'],
      ['PALAZZAGO', 'G259'],
      ['MONASTEROLO DEL CASTELLO', 'F328'],
      ['TORRE DE\' ROVERI', 'L265'],
      ['CAMERATA CORNELLO', 'B471'],
      ['BARBATA', 'A631'],
      ['LENNA', 'E524'],
      ['CAZZANO SANT\'ANDREA', 'C410'],
      ['SERINA', 'I629'],
      ['FORNOVO SAN GIOVANNI', 'D727'],
      ['ONORE', 'G075'],
      ['PONTERANICA', 'G853'],
      ['PONTE SAN PIETRO', 'G856'],
      ['RANICA', 'H176'],
      ['RANZANICO', 'H177'],
      ['SERIATE', 'I628'],
      ['BONATE SOTTO', 'A962'],
      ['BONATE SOPRA', 'A963'],
      ['LEFFE', 'E509'],
      ['SARNICO', 'I437'],
      ['PREMOLO', 'H036'],
      ['OLTRE IL COLLE', 'G050'],
      ['OLTRESSENDA ALTA', 'G054'],
      ['PAGAZZANO', 'G233'],
      ['SUISIO', 'I997'],
      ['CALUSCO D\'ADDA', 'B434'],
      ['CASTRO', 'C337'],
      ['CLUSONE', 'C800'],
      ['BRUSAPORTO', 'B223'],
      ['BOTTANUCO', 'B088'],
      ['BOSSICO', 'B083'],
      ['URGNANO', 'L502'],
      ['ROVETTA', 'H615'],
      ['MORENGO', 'F720'],
      ['VERDELLINO', 'L752'],
      ['VERDELLO', 'L753'],
      ['CHIUDUNO', 'C649'],
      ['ALMENNO SAN BARTOLOMEO', 'A216'],
      ['ALMENNO SAN SALVATORE', 'A217'],
      ['ALME\'', 'A214'],
      ['VILLA D\'ALME\'', 'A215'],
      ['ISOLA DI FONDRA', 'E353'],
      ['PIARIO', 'G574'],
      ['PIAZZA BREMBANA', 'G579'],
      ['SOLTO COLLINA', 'I812'],
      ['SOLZA', 'I813'],
      ['MAPELLO', 'E901'],
      ['SOVERE', 'I873'],
      ['CENATE SOPRA', 'C456'],
      ['CENATE SOTTO', 'C457'],
      ['CENE', 'C459'],
      ['GAZZANIGA', 'D952'],
      ['BLELLO', 'A903'],
      ['VERTOVA', 'L795'],
      ['SONGAVAZZO', 'I830'],
      ['CUSIO', 'D233'],
      ['VALBREMBO', 'L545'],
      ['VALBONDIONE', 'L544'],
      ['PALOSCO', 'G295'],
      ['FONTENO', 'D684'],
      ['FOPPOLO', 'D688'],
      ['CORTENUOVA', 'D066'],
      ['CAPIZZONE', 'B661'],
      ['BERBENNO', 'A786'],
      ['AZZANO SAN PAOLO', 'A528'],
      ['AMBIVERE', 'A259'],
      ['SORISOLE', 'I858'],
      ['PARZANICA', 'G350'],
      ['GORLE', 'E103'],
      ['GORLAGO', 'E100'],
      ['GORNO', 'E106'],
      ['SAN PELLEGRINO TERME', 'I079'],
      ['PEDRENGO', 'G412'],
      ['PEIA', 'G418'],
      ['LUZZANA', 'E770'],
      ['FILAGO', 'D588'],
      ['BRANZI', 'B123'],
      ['NEMBRO', 'F864'],
      ['CARONA', 'B803'],
      ['CAROBBIO DEGLI ANGELI', 'B801'],
      ['FARA OLIVANA CON SOLA', 'D491'],
      ['FARA GERA D\'ADDA', 'D490'],
      ['VALNEGRA', 'L642'],
      ['VALSECCA', 'L649'],
      ['GROMO', 'E189'],
      ['TAVERNOLA BERGAMASCA', 'L073'],
      ['MOZZO', 'F791'],
      ['RONCOLA', 'H544'],
      ['MONTELLO', 'F547'],
      ['SANT\'OMOBONO IMAGNA', 'I349'],
      ['SCANZOROSCIATE', 'I506'],
      ['VILMINORE DI SCALVE', 'M050'],
      ['TRESCORE BALNEARIO', 'L388'],
      ['MEZZOLDO', 'F186'],
      ['FIORANO AL SERIO', 'D606'],
      ['FINO DEL MONTE', 'D604'],
      ['DOSSENA', 'D352'],
      ['TALEGGIO', 'L037'],
      ['SEDRINA', 'I567'],
      ['ROMANO DI LOMBARDIA', 'H509'],
      ['PRADALUNGA', 'G968'],
      ['CASSIGLIO', 'C007'],
      ['POGNANO', 'G774'],
      ['MARTINENGO', 'E987'],
      ['GEROSA', 'D991'],
      ['COLZATE', 'C910'],
      ['MORNICO AL SERIO', 'F738'],
      ['MEDOLAGO', 'F085'],
      ['ENTRATICO', 'D411'],
      ['ARZAGO D\'ADDA', 'A440'],
      ['OSIO SOTTO', 'G160'],
      ['PARRE', 'G346'],
      ['CASAZZA', 'B947'],
      ['MOIO DE\' CALVI', 'F276'],
      ['CISERANO', 'C730'],
      ['ANTEGNATE', 'A304'],
      ['COMUN NUOVO', 'C937'],
      ['RIVA DI SOLTO', 'H331'],
      ['COVO', 'D126'],
      ['BARZANA', 'A684'],
      ['ORIO AL SERIO', 'G108'],
      ['VIGOLO', 'L894'],
      ['BREMBILLA', 'B140'],
      ['ISSO', 'E370'],
      ['VILLA DI SERIO', 'L936'],
      ['COSTA VALLE IMAGNA', 'D103'],
      ['BARIANO', 'A664'],
      ['BORGO DI TERZO', 'B010'],
      ['GRASSOBBIO', 'E148'],
      ['PALADINA', 'G249'],
      ['BAGNATICA', 'A557'],
      ['ROTA D\'IMAGNA', 'H584'],
      ['TORRE PALLAVICINA', 'L276'],
      ['TERNO D\'ISOLA', 'L118'],
      ['AZZONE', 'A533'],
      ['ARCENE', 'A365'],
      ['PONTE NOSSA', 'F941'],
      ['CALVENZANO', 'B442'],
      ['PONTIROLO NUOVO', 'G867'],
      ['PONTIDA', 'G864'],
      ['VILLA D\'ADDA', 'L929'],
      ['BRIGNANO GERA D\'ADDA', 'B178'],
      ['TORRE BOLDONE', 'L251'],
      ['COLERE', 'C835'],
      ['MADONE', 'E794'],
      ['PREDORE', 'H020'],
      ['CIVIDATE AL PIANO', 'C759'],
      ['ONETA', 'G068'],
      ['ARDESIO', 'A383'],
      ['STROZZA', 'I986'],
      ['VEDESETA', 'L707'],
      ['BERZO SAN FERMO', 'A815'],
      ['CASTIONE DELLA PRESOLANA', 'C324'],
      ['RONCOBELLO', 'H535'],
      ['PRESEZZO', 'H046'],
      ['BRUMANO', 'B217'],
      ['OLMO AL BREMBO', 'G049'],
      ['LOVERE', 'E704'],
      ['BOLTIERE', 'A950'],
      ['PIANICO', 'G564'],
      ['VALGOGLIO', 'L579'],
      ['CALCIO', 'B395'],
      ['CALCINATE', 'B393'],
      ['CAVERNAGO', 'C396'],
      ['BOLGARE', 'A937'],
      ['GHISALBA', 'E006'],
      ['PIAZZOLO', 'G588'],
      ['PIAZZATORRE', 'G583'],
      ['CURNO', 'D221'],
      ['TELGATE', 'L087']
    ],
    BI: [
      ['VALDENGO', 'L556'],
      ['GIFFLENGA', 'E024'],
      ['CANDELO', 'B586'],
      ['SELVE MARCONE', 'I596'],
      ['SORDEVOLO', 'I847'],
      ['MASSAZZA', 'F037'],
      ['SOPRANA', 'I835'],
      ['CASTELLETTO CERVO', 'C155'],
      ['QUAREGNA', 'H103'],
      ['ZUMAGLIA', 'M201'],
      ['SOSTEGNO', 'I868'],
      ['ROPPOLO', 'H553'],
      ['ANDORNO MICCA', 'A280'],
      ['RONCO BIELLESE', 'H538'],
      ['QUITTENGO', 'H145'],
      ['CAMPIGLIA CERVO', 'B508'],
      ['GAGLIANICO', 'D848'],
      ['SALUSSOLA', 'H726'],
      ['COSSATO', 'D094'],
      ['PRAY', 'G974'],
      ['VIGLIANO BIELLESE', 'L880'],
      ['NETRO', 'F878'],
      ['CAPRILE', 'B708'],
      ['AILOCHE', 'A107'],
      ['CASAPINTA', 'B933'],
      ['MUZZANO', 'F833'],
      ['MONGRANDO', 'F369'],
      ['VEGLIO', 'L712'],
      ['CAMANDONA', 'B457'],
      ['CERRIONE', 'C532'],
      ['OCCHIEPPO INFERIORE', 'F992'],
      ['OCCHIEPPO SUPERIORE', 'F993'],
      ['GRAGLIA', 'E130'],
      ['CALLABIANA', 'B417'],
      ['PIATTO', 'G577'],
      ['PIEDICAVALLO', 'G594'],
      ['MASSERANO', 'F042'],
      ['BENNA', 'A784'],
      ['CURINO', 'D219'],
      ['SAN PAOLO CERVO', 'I074'],
      ['ZIMONE', 'M179'],
      ['VALLANZENGO', 'L586'],
      ['ROSAZZA', 'H561'],
      ['SANDIGLIANO', 'H821'],
      ['VALLE SAN NICOLAO', 'L620'],
      ['MOTTALCIATA', 'F776'],
      ['TOLLEGNO', 'L193'],
      ['BRUSNENGO', 'B229'],
      ['MIAGLIANO', 'F189'],
      ['DORZANO', 'D350'],
      ['VALLE MOSSO', 'L606'],
      ['ZUBIENA', 'M196'],
      ['CREVACUORE', 'D165'],
      ['BIELLA', 'A859'],
      ['VILLANOVA BIELLESE', 'L978'],
      ['TAVIGLIANO', 'L075'],
      ['MAGNANO', 'E821'],
      ['BIOGLIO', 'A876'],
      ['VERRONE', 'L785'],
      ['TRIVERO', 'L436'],
      ['SALA BIELLESE', 'H681'],
      ['TORRAZZO', 'L239'],
      ['DONATO', 'D339'],
      ['PORTULA', 'G927'],
      ['VILLA DEL BOSCO', 'L933'],
      ['CAMBURZANO', 'B465'],
      ['CAVAGLIA\'', 'C363'],
      ['LESSONA', 'E552'],
      ['TERNENGO', 'L116'],
      ['MOSSO', 'M304'],
      ['VIVERONE', 'M098'],
      ['CERRETO CASTELLO', 'C526'],
      ['PETTINENGO', 'G521'],
      ['PRALUNGO', 'G980'],
      ['BORRIANA', 'B058'],
      ['STRONA', 'I980'],
      ['COGGIOLA', 'C819'],
      ['MEZZANA MORTIGLIENGO', 'F167'],
      ['CROSA', 'D182'],
      ['PONDERANO', 'G820'],
      ['SAGLIANO MICCA', 'H662'],
      ['POLLONE', 'G798']
    ],
    BL: [
      ['CALALZO DI CADORE', 'B375'],
      ['VODO DI CADORE', 'M108'],
      ['CORTINA D\'AMPEZZO', 'A266'],
      ['LORENZAGO DI CADORE', 'E687'],
      ['SELVA DI CADORE', 'I592'],
      ['QUERO', 'H124'],
      ['CHIES D\'ALPAGO', 'C630'],
      ['PIEVE D\'ALPAGO', 'G638'],
      ['TAMBRE', 'L040'],
      ['VALLE DI CADORE', 'L590'],
      ['SAN NICOLO\' DI COMELICO', 'I063'],
      ['PEDAVENA', 'G404'],
      ['LAMON', 'E429'],
      ['DANTA DI CADORE', 'D247'],
      ['SAN PIETRO DI CADORE', 'I088'],
      ['BELLUNO', 'A757'],
      ['LIVINALLONGO DEL COL DI LANA', 'E622'],
      ['PERAROLO DI CADORE', 'G442'],
      ['ZOPPE\' DI CADORE', 'M189'],
      ['ALANO DI PIAVE', 'A121'],
      ['COMELICO SUPERIORE', 'C920'],
      ['MEL', 'F094'],
      ['SAN GREGORIO NELLE ALPI', 'H938'],
      ['TRICHIANA', 'L422'],
      ['LIMANA', 'E588'],
      ['GOSALDO', 'E113'],
      ['AGORDO', 'A083'],
      ['VAS', 'L692'],
      ['FORNO DI ZOLDO', 'D726'],
      ['SEREN DEL GRAPPA', 'I626'],
      ['BORCA DI CADORE', 'A982'],
      ['PUOS D\'ALPAGO', 'H092'],
      ['FARRA D\'ALPAGO', 'D506'],
      ['SOVERZENE', 'I876'],
      ['CENCENIGHE AGORDINO', 'C458'],
      ['FONZASO', 'D686'],
      ['CASTELLAVAZZO', 'C146'],
      ['AURONZO DI CADORE', 'A501'],
      ['VALLADA AGORDINA', 'L584'],
      ['PONTE NELLE ALPI', 'B662'],
      ['SOSPIROLO', 'I866'],
      ['PIEVE DI CADORE', 'G642'],
      ['ZOLDO ALTO', 'I345'],
      ['SAN TOMASO AGORDINO', 'I347'],
      ['RIVAMONTE AGORDINO', 'H327'],
      ['LONGARONE', 'E672'],
      ['LA VALLE AGORDINA', 'E490'],
      ['TAIBON AGORDINO', 'L030'],
      ['SEDICO', 'I563'],
      ['SANTO STEFANO DI CADORE', 'C919'],
      ['ARSIE\'', 'A443'],
      ['OSPITALE DI CADORE', 'G169'],
      ['CANALE D\'AGORDO', 'B574'],
      ['VIGO DI CADORE', 'L890'],
      ['DOMEGGE DI CADORE', 'D330'],
      ['SOVRAMONTE', 'I673'],
      ['SANTA GIUSTINA', 'I206'],
      ['LENTIAI', 'C562'],
      ['ROCCA PIETORE', 'H379'],
      ['FALCADE', 'D470'],
      ['FELTRE', 'D530'],
      ['SAPPADA', 'I421'],
      ['LOZZO DI CADORE', 'E708'],
      ['COLLE SANTA LUCIA', 'C872'],
      ['SAN VITO DI CADORE', 'I392'],
      ['VOLTAGO AGORDINO', 'M124'],
      ['CIBIANA DI CADORE', 'C672'],
      ['ALLEGHE', 'A206'],
      ['CESIOMAGGIORE', 'C577']
    ],
    BN: [
      ['AMOROSI', 'A265'],
      ['GINESTRA DEGLI SCHIAVONI', 'E034'],
      ['SAN NAZZARO', 'I049'],
      ['PIETRELCINA', 'G631'],
      ['SAN NICOLA MANFREDI', 'I062'],
      ['FOIANO DI VAL FORTORE', 'D650'],
      ['DURAZZANO', 'D386'],
      ['SAN BARTOLOMEO IN GALDO', 'H764'],
      ['CASALDUNI', 'B873'],
      ['CASTELPOTO', 'C250'],
      ['PAOLISI', 'G318'],
      ['PANNARANO', 'G311'],
      ['TOCCO CAUDIO', 'L185'],
      ['SAN GIORGIO LA MOLARA', 'H898'],
      ['SAN GIORGIO DEL SANNIO', 'H894'],
      ['CAMPOLI DEL MONTE TABURNO', 'B542'],
      ['CAMPOLATTARO', 'B541'],
      ['BASELICE', 'A696'],
      ['LIMATOLA', 'E589'],
      ['MOLINARA', 'F287'],
      ['REINO', 'H227'],
      ['MELIZZANO', 'F113'],
      ['CERRETO SANNITA', 'C525'],
      ['SASSINORO', 'I455'],
      ['APOLLOSA', 'A330'],
      ['FAICCHIO', 'D469'],
      ['SAN LUPO', 'H973'],
      ['FORCHIA', 'D693'],
      ['ARPAISE', 'A432'],
      ['ARPAIA', 'A431'],
      ['SAN LORENZELLO', 'H955'],
      ['SAN LEUCIO DEL SANNIO', 'H953'],
      ['BUONALBERGO', 'B267'],
      ['CAUTANO', 'C359'],
      ['AIROLA', 'A110'],
      ['CEPPALONI', 'C476'],
      ['GUARDIA SANFRAMONDI', 'E249'],
      ['SANT\'ARCANGELO TRIMONTE', 'F557'],
      ['FRASSO TELESINO', 'D784'],
      ['BONEA', 'A970'],
      ['COLLE SANNITA', 'C846'],
      ['SANT\'AGATA DE\' GOTI', 'I197'],
      ['CUSANO MUTRI', 'D230'],
      ['BENEVENTO', 'A783'],
      ['PIETRAROJA', 'G626'],
      ['MONTESARCHIO', 'F636'],
      ['MONTEFALCONE DI VAL FORTORE', 'F494'],
      ['FOGLIANISE', 'D644'],
      ['CASTELPAGANO', 'C245'],
      ['PESCO SANNITA', 'G494'],
      ['PUGLIANELLO', 'H087'],
      ['SANTA CROCE DEL SANNIO', 'I179'],
      ['DUGENTA', 'D380'],
      ['MOIANO', 'F274'],
      ['CASTELVETERE IN VAL FORTORE', 'C284'],
      ['CASTELVENERE', 'C280'],
      ['MORCONE', 'F717'],
      ['APICE', 'A328'],
      ['PAUPISI', 'G386'],
      ['SAN MARTINO SANNITA', 'I002'],
      ['CIRCELLO', 'C719'],
      ['SAN SALVATORE TELESINO', 'I145'],
      ['SAN LORENZO MAGGIORE', 'H967'],
      ['VITULANO', 'M093'],
      ['CALVI', 'B444'],
      ['TORRECUSO', 'L254'],
      ['FRAGNETO L\'ABATE', 'D755'],
      ['FRAGNETO MONFORTE', 'D756'],
      ['PONTELANDOLFO', 'G848'],
      ['PADULI', 'G227'],
      ['PONTE', 'G827'],
      ['SAN MARCO DEI CAVOTI', 'H984'],
      ['CASTELFRANCO IN MISCANO', 'C106'],
      ['BUCCIANO', 'B239'],
      ['SANT\'ANGELO A CUPOLO', 'I277'],
      ['PAGO VEIANO', 'G243'],
      ['SOLOPACA', 'I809'],
      ['TELESE TERME', 'L086']
    ],
    BO: [
      ['VERGATO', 'L762'],
      ['MONTE SAN PIETRO', 'F627'],
      ['SAN GIOVANNI IN PERSICETO', 'G467'],
      ['ZOLA PREDOSA', 'M185'],
      ['LIZZANO IN BELVEDERE', 'A771'],
      ['PORRETTA TERME', 'A558'],
      ['CASTELLO DI SERRAVALLE', 'C191'],
      ['DOZZA', 'D360'],
      ['SASSO MARCONI', 'G972'],
      ['SAN GIORGIO DI PIANO', 'H896'],
      ['CASTEL D\'AIANO', 'C075'],
      ['GRANAGLIONE', 'E135'],
      ['CASTENASO', 'C292'],
      ['BORGO TOSSIGNANO', 'B044'],
      ['MOLINELLA', 'F288'],
      ['MONZUNO', 'F706'],
      ['CRESPELLANO', 'D158'],
      ['BUDRIO', 'B249'],
      ['SAVIGNO', 'I474'],
      ['GALLIERA', 'D878'],
      ['CASTEL SAN PIETRO TERME', 'C265'],
      ['CASTELLO D\'ARGILE', 'C185'],
      ['MONGHIDORO', 'F363'],
      ['ARGELATO', 'A392'],
      ['SANT\'AGATA BOLOGNESE', 'I191'],
      ['BOLOGNA', 'A944'],
      ['CASALECCHIO DI RENO', 'B880'],
      ['GRANAROLO DELL\'EMILIA', 'E136'],
      ['CASTIGLIONE DEI PEPOLI', 'C296'],
      ['CASTEL DEL RIO', 'C086'],
      ['PIANORO', 'G570'],
      ['SALA BOLOGNESE', 'H678'],
      ['MONTEVEGLIO', 'F659'],
      ['CASTEL GUELFO DI BOLOGNA', 'C121'],
      ['BENTIVOGLIO', 'A785'],
      ['SAN PIETRO IN CASALE', 'I110'],
      ['FONTANELICE', 'D668'],
      ['PIEVE DI CENTO', 'G643'],
      ['CASTEL MAGGIORE', 'C204'],
      ['GRIZZANA MORANDI', 'E187'],
      ['MARZABOTTO', 'B689'],
      ['MALALBERGO', 'E844'],
      ['MINERBIO', 'F219'],
      ['IMOLA', 'E289'],
      ['CREVALCORE', 'D166'],
      ['GAGGIO MONTANO', 'D847'],
      ['BAZZANO', 'A726'],
      ['LOIANO', 'E655'],
      ['MEDICINA', 'F083'],
      ['MORDANO', 'F718'],
      ['CAMUGNANO', 'B572'],
      ['CASTEL DI CASIO', 'B969'],
      ['ANZOLA DELL\'EMILIA', 'A324'],
      ['MONTERENZIO', 'F597'],
      ['BARICELLA', 'A665'],
      ['CALDERARA DI RENO', 'B399'],
      ['SAN LAZZARO DI SAVENA', 'H945'],
      ['OZZANO DELL\'EMILIA', 'G205'],
      ['SAN BENEDETTO VAL DI SAMBRO', 'G566'],
      ['CASALFIUMANESE', 'B892']
    ],
    BR: [
      ['CELLINO SAN MARCO', 'C448'],
      ['SAN MICHELE SALENTINO', 'I045'],
      ['CEGLIE MESSAPICO', 'C424'],
      ['SAN PANCRAZIO SALENTINO', 'I066'],
      ['ERCHIE', 'D422'],
      ['ORIA', 'G098'],
      ['MESAGNE', 'F152'],
      ['CISTERNINO', 'C741'],
      ['TORRE SANTA SUSANNA', 'L280'],
      ['FASANO', 'D508'],
      ['FRANCAVILLA FONTANA', 'D761'],
      ['SAN PIETRO VERNOTICO', 'I119'],
      ['CAROVIGNO', 'B809'],
      ['SAN DONACI', 'H822'],
      ['OSTUNI', 'G187'],
      ['LATIANO', 'E471'],
      ['BRINDISI', 'B180'],
      ['TORCHIAROLO', 'L213'],
      ['VILLA CASTELLI', 'L920'],
      ['SAN VITO DEI NORMANNI', 'I396']
    ],
    BS: [
      ['ODOLO', 'G001'],
      ['OFFLAGA', 'G006'],
      ['TOSCOLANO-MADERNO', 'L312'],
      ['GAVARDO', 'D940'],
      ['CORTE FRANCA', 'D058'],
      ['CHIARI', 'C618'],
      ['VOBARNO', 'M104'],
      ['TRAVAGLIATO', 'L339'],
      ['BERLINGO', 'A799'],
      ['COLOGNE', 'C893'],
      ['SONICO', 'I831'],
      ['CAZZAGO SAN MARTINO', 'C408'],
      ['SAN PAOLO', 'G407'],
      ['CARPENEDOLO', 'B817'],
      ['MANERBIO', 'E884'],
      ['CAPOVALLE', 'B676'],
      ['MALEGNO', 'E851'],
      ['SAN FELICE DEL BENACO', 'H838'],
      ['BAGOLINO', 'A578'],
      ['ANFO', 'A288'],
      ['SULZANO', 'L002'],
      ['CAPRIANO DEL COLLE', 'B698'],
      ['INCUDINE', 'E297'],
      ['QUINZANO D\'OGLIO', 'H140'],
      ['GARGNANO', 'D924'],
      ['CAPRIOLO', 'B711'],
      ['POZZOLENGO', 'G959'],
      ['PALAZZOLO SULL\'OGLIO', 'G264'],
      ['VIONE', 'M065'],
      ['TREVISO BRESCIANO', 'L406'],
      ['ARTOGNE', 'A451'],
      ['ORZIVECCHI', 'G150'],
      ['GAMBARA', 'D891'],
      ['PRALBOINO', 'G977'],
      ['LONATO', 'E667'],
      ['CASTELCOVATI', 'C072'],
      ['PASSIRANO', 'G361'],
      ['COMEZZANO-CIZZAGO', 'C925'],
      ['OSPITALETTO', 'G170'],
      ['OSSIMO', 'G179'],
      ['CASTENEDOLO', 'C293'],
      ['PASPARDO', 'G354'],
      ['ISORELLA', 'E364'],
      ['TIGNALE', 'L169'],
      ['BIENNO', 'A861'],
      ['CASTEGNATO', 'C055'],
      ['GOTTOLENGO', 'E116'],
      ['CONCESIO', 'C948'],
      ['TAVERNOLE SUL MELLA', 'C698'],
      ['AGNOSINE', 'A082'],
      ['VILLACHIARA', 'L923'],
      ['SALE MARASINO', 'H699'],
      ['NAVE', 'F851'],
      ['VALVESTINO', 'L468'],
      ['ROVATO', 'H598'],
      ['PAVONE DEL MELLA', 'G391'],
      ['IRMA', 'E325'],
      ['SAVIORE DELL\'ADAMELLO', 'I476'],
      ['SOIANO DEL LAGO', 'I782'],
      ['CIVIDATE CAMUNO', 'C760'],
      ['BARBARIGA', 'A630'],
      ['ALFIANELLO', 'A188'],
      ['LENO', 'E526'],
      ['CEDEGOLO', 'C417'],
      ['SAN ZENO NAVIGLIO', 'I412'],
      ['BORGOSATOLLO', 'B040'],
      ['ONO SAN PIETRO', 'G074'],
      ['PADENGHE SUL GARDA', 'G213'],
      ['PADERNO FRANCIACORTA', 'G217'],
      ['CALVISANO', 'B450'],
      ['PONTEVICO', 'G859'],
      ['CIGOLE', 'C685'],
      ['SAREZZO', 'I433'],
      ['NUVOLERA', 'F990'],
      ['GHEDI', 'D999'],
      ['CALVAGESE DELLA RIVIERA', 'B436'],
      ['SENIGA', 'I607'],
      ['GARDONE RIVIERA', 'D917'],
      ['CASTREZZATO', 'C332'],
      ['CASTO', 'C330'],
      ['COCCAGLIO', 'C806'],
      ['MARCHENO', 'E928'],
      ['PRESTINE', 'H050'],
      ['PREVALLE', 'H055'],
      ['BRENO', 'B149'],
      ['EDOLO', 'D391'],
      ['POMPIANO', 'G815'],
      ['PONCARALE', 'G818'],
      ['GIANICO', 'E010'],
      ['PROVAGLIO D\'ISEO', 'H078'],
      ['PROVAGLIO VAL SABBIA', 'H077'],
      ['MAZZANO', 'F063'],
      ['LUMEZZANE', 'E738'],
      ['VEROLAVECCHIA', 'L778'],
      ['VEROLANUOVA', 'L777'],
      ['MONTICHIARI', 'F471'],
      ['CEVO', 'C591'],
      ['LOSINE', 'E698'],
      ['ERBUSCO', 'D421'],
      ['MARMENTINO', 'E961'],
      ['MARONE', 'E967'],
      ['RUDIANO', 'H630'],
      ['TEMU\'', 'L094'],
      ['SELLERO', 'I588'],
      ['SABBIO CHIESE', 'H650'],
      ['CELLATICA', 'C439'],
      ['CAINO', 'B365'],
      ['MONTICELLI BRUSATI', 'F672'],
      ['BOVEZZO', 'B102'],
      ['BOVEGNO', 'B100'],
      ['CORTENO GOLGI', 'D064'],
      ['AZZANO MELLA', 'A529'],
      ['ADRO', 'A060'],
      ['BRANDICO', 'B120'],
      ['BRAONE', 'B124'],
      ['GARDONE VAL TROMPIA', 'D918'],
      ['COLLIO', 'C883'],
      ['DELLO', 'D270'],
      ['CAPO DI PONTE', 'B664'],
      ['PERTICA ALTA', 'G474'],
      ['PERTICA BASSA', 'G475'],
      ['BAGNOLO MELLA', 'A569'],
      ['ANGOLO TERME', 'A293'],
      ['ROE\' VOLCIANO', 'H484'],
      ['CASTEL MELLA', 'C208'],
      ['DARFO BOARIO TERME', 'D251'],
      ['VESTONE', 'L812'],
      ['VEZZA D\'OGLIO', 'L816'],
      ['PARATICO', 'G327'],
      ['MAIRANO', 'E841'],
      ['MILZANO', 'F216'],
      ['VALLIO TERME', 'L626'],
      ['SALO\'', 'H717'],
      ['BERZO INFERIORE', 'A817'],
      ['TRENZANO', 'L380'],
      ['IDRO', 'E280'],
      ['RONCADELLE', 'H525'],
      ['MALONNO', 'E865'],
      ['BRESCIA', 'B157'],
      ['LIMONE SUL GARDA', 'E596'],
      ['BRIONE', 'B184'],
      ['SAN GERVASIO BRESCIANO', 'H865'],
      ['BASSANO BRESCIANO', 'A702'],
      ['LONGHENA', 'E673'],
      ['LAVENONE', 'E497'],
      ['MONTE ISOLA', 'F532'],
      ['VISANO', 'M070'],
      ['ORZINUOVI', 'G149'],
      ['MAGASA', 'E800'],
      ['CORZANO', 'D082'],
      ['PUEGNAGO SUL GARDA', 'H086'],
      ['BEDIZZOLE', 'A729'],
      ['POLAVENO', 'G779'],
      ['LOGRATO', 'E654'],
      ['LODRINO', 'E652'],
      ['NIARDO', 'F884'],
      ['BIONE', 'A878'],
      ['REZZATO', 'H256'],
      ['ESINE', 'D434'],
      ['CERVENO', 'C549'],
      ['BORGO SAN GIACOMO', 'B035'],
      ['REMEDELLO', 'H230'],
      ['MACLODIO', 'E787'],
      ['BARGHE', 'A661'],
      ['TORBOLE CASAGLIA', 'L210'],
      ['VILLA CARCINA', 'L919'],
      ['PAISCO LOVENO', 'G247'],
      ['PISOGNE', 'G710'],
      ['PAITONE', 'G248'],
      ['MUSCOLINE', 'F820'],
      ['MANERBA DEL GARDA', 'E883'],
      ['ISEO', 'E333'],
      ['MURA', 'F806'],
      ['MONIGA DEL GARDA', 'F373'],
      ['MONNO', 'F375'],
      ['URAGO D\'OGLIO', 'L494'],
      ['PONTOGLIO', 'G869'],
      ['SERLE', 'I631'],
      ['SIRMIONE', 'I633'],
      ['CIMBERGO', 'C691'],
      ['PEZZAZE', 'G529'],
      ['OME', 'G061'],
      ['GUSSAGO', 'E271'],
      ['MONTIRONE', 'F680'],
      ['PONTE DI LEGNO', 'G844'],
      ['BERZO DEMO', 'A816'],
      ['BORNO', 'B054'],
      ['PIANCOGNO', 'G549'],
      ['PIAN CAMUNO', 'G546'],
      ['PRESEGLIE', 'H043'],
      ['CETO', 'C585'],
      ['NUVOLENTO', 'F989'],
      ['LOZIO', 'E706'],
      ['FLERO', 'D634'],
      ['RODENGO-SAIANO', 'H477'],
      ['BOTTICINO', 'B091'],
      ['FIESSE', 'D576'],
      ['ACQUAFREDDA', 'A034'],
      ['VILLANUOVA SUL CLISI', 'L995'],
      ['TREMOSINE', 'L372'],
      ['ZONE', 'M188'],
      ['CALCINATO', 'B394'],
      ['DESENZANO DEL GARDA', 'D284'],
      ['POLPENAZZE DEL GARDA', 'G801'],
      ['COLLEBEATO', 'C850'],
      ['ROCCAFRANCA', 'H410']
    ],
    BT: [
      ['ANDRIA', 'A285'],
      ['BARLETTA', 'A669'],
      ['BISCEGLIE', 'A883'],
      ['CANOSA DI PUGLIA', 'B619'],
      ['MARGHERITA DI SAVOIA', 'E946'],
      ['MINERVINO MURGE', 'F220'],
      ['SAN FERDINANDO DI PUGLIA', 'H839'],
      ['SPINAZZOLA', 'I907'],
      ['TRANI', 'L328'],
      ['TRINITAPOLI', 'B915']
    ],
    BZ: [
      ['VALDAORA', 'L552'],
      ['BRAIES', 'B116'],
      ['SAN CANDIDO', 'H786'],
      ['SELVA DI VAL GARDENA', 'I591'],
      ['SELVA DEI MOLINI', 'I593'],
      ['LUSON', 'E764'],
      ['CORVARA IN BADIA', 'D079'],
      ['CORTINA SULLA STRADA DEL VINO', 'D075'],
      ['RIFIANO', 'H284'],
      ['TESIMO', 'L149'],
      ['MARLENGO', 'E959'],
      ['VALLE AURINA', 'L595'],
      ['FALZES', 'D484'],
      ['SAN PANCRAZIO', 'I065'],
      ['LAIVES', 'E421'],
      ['LAION', 'E420'],
      ['ANDRIANO', 'A286'],
      ['PERCA', 'G443'],
      ['SAN GENESIO ATESINO', 'H858'],
      ['CASTELROTTO', 'C254'],
      ['MOSO IN PASSIRIA', 'F766'],
      ['SCENA', 'I519'],
      ['GARGAZZONE', 'D923'],
      ['LAUREGNO', 'E481'],
      ['CAMPO DI TRENS', 'B529'],
      ['VIPITENO', 'M067'],
      ['TERENTO', 'L106'],
      ['SILANDRO', 'I729'],
      ['TRODENA', 'L444'],
      ['MELTINA', 'F118'],
      ['LAGUNDO', 'E412'],
      ['POSTAL', 'G936'],
      ['APPIANO SULLA STRADA DEL VINO', 'A332'],
      ['NAZ SCIAVES', 'F856'],
      ['MERANO', 'F132'],
      ['CORNEDO ALL\'ISARCO', 'B799'],
      ['NOVA PONENTE', 'F950'],
      ['NALLES', 'F836'],
      ['SAN LORENZO DI SEBATO', 'H956'],
      ['SAN LEONARDO IN PASSIRIA', 'H952'],
      ['BARBIANO', 'A635'],
      ['BADIA', 'A537'],
      ['TERLANO', 'L108'],
      ['PREDOI', 'H019'],
      ['SARENTINO', 'I431'],
      ['BRONZOLO', 'B203'],
      ['VADENA', 'L527'],
      ['PONTE GARDENA', 'G830'],
      ['SENALE-SAN FELICE', 'I603'],
      ['SENALES', 'I604'],
      ['BRUNICO', 'B220'],
      ['EGNA', 'D392'],
      ['VAL DI VIZZE', 'L564'],
      ['CERMES', 'A022'],
      ['CORTACCIA SULLA STRADA DEL VINO', 'D048'],
      ['PLAUS', 'G299'],
      ['CAINES', 'B364'],
      ['CASTELBELLO CIARDES', 'C062'],
      ['SESTO', 'I687'],
      ['VANDOIES', 'L660'],
      ['CHIENES', 'C625'],
      ['AVELENGO', 'A507'],
      ['LANA', 'E434'],
      ['MARTELLO', 'E981'],
      ['LASA', 'E457'],
      ['ALDINO', 'A179'],
      ['PARCINES', 'G328'],
      ['RACINES', 'H152'],
      ['SALORNO', 'H719'],
      ['VELTURNO', 'L724'],
      ['MALLES VENOSTA', 'E862'],
      ['VALLE DI CASIES', 'L601'],
      ['RASUN ANTERSELVA', 'H189'],
      ['SLUDERNO', 'I771'],
      ['STELVIO', 'I948'],
      ['LA VALLE', 'E491'],
      ['RIO DI PUSTERIA', 'H299'],
      ['ORTISEI', 'G140'],
      ['PROVES', 'H081'],
      ['VILLANDRO', 'L971'],
      ['SANTA CRISTINA VALGARDENA', 'I173'],
      ['MAGRE\' SULLA STRADA DEL VINO', 'E829'],
      ['DOBBIACO', 'D311'],
      ['TIROLO', 'L178'],
      ['TIRES', 'L176'],
      ['ANTERIVO', 'A306'],
      ['CAMPO TURES', 'B570'],
      ['BRENNERO', 'B145'],
      ['RENON', 'H236'],
      ['NATURNO', 'F849'],
      ['TUBRE', 'L455'],
      ['VARNA', 'L687'],
      ['VILLABASSA', 'L915'],
      ['TERMENO SULLA STRADA DEL VINO', 'L111'],
      ['PRATO ALLO STELVIO', 'H004'],
      ['FORTEZZA', 'D731'],
      ['ORA', 'G083'],
      ['NOVA LEVANTE', 'F949'],
      ['MONGUELFO', 'F371'],
      ['ULTIMO', 'L490'],
      ['MONTAGNA', 'F392'],
      ['FUNES', 'D821'],
      ['GAIS', 'D860'],
      ['SAN MARTINO IN PASSIRIA', 'H989'],
      ['SAN MARTINO IN BADIA', 'H988'],
      ['BOLZANO', 'A952'],
      ['CHIUSA', 'C652'],
      ['GLORENZA', 'E069'],
      ['LACES', 'E398'],
      ['RODENGO', 'H475'],
      ['MAREBBE', 'E938'],
      ['FIE\' ALLO SCILIAR', 'D571'],
      ['CALDARO SULLA STRADA DEL VINO', 'B397'],
      ['VERANO', 'L745'],
      ['BRESSANONE', 'B160'],
      ['CURON VENOSTA', 'D222']
    ],
    CA: [
      ['CARBONIA', 'B745'],
      ['GIBA', 'E022'],
      ['SAN GIOVANNI SUERGIU', 'G287'],
      ['TRATALIAS', 'L337'],
      ['CAGLIARI', 'B354'],
      ['SETTIMO SAN PIETRO', 'I699'],
      ['SESTU', 'I695'],
      ['LUNAMATRONA', 'E742'],
      ['DECIMOPUTZU', 'D260'],
      ['SANT\'ANNA ARRESI', 'M209'],
      ['GONI', 'E084'],
      ['CAPOTERRA', 'B675'],
      ['SAN BASILIO', 'H766'],
      ['PERDAXIUS', 'G446'],
      ['MANDAS', 'E877'],
      ['FLUMINIMAGGIORE', 'D639'],
      ['SAN GAVINO MONREALE', 'H856'],
      ['VILLASIMIUS', 'B738'],
      ['SIURGUS DONIGALA', 'I765'],
      ['DONORI', 'D344'],
      ['LAS PLASSAS', 'E464'],
      ['VALLERMOSA', 'L613'],
      ['SETZU', 'I705'],
      ['SEGARIU', 'I570'],
      ['SIDDI', 'I724'],
      ['VILLAMAR', 'L966'],
      ['VILLAMASSARGIA', 'L968'],
      ['SANT\'ANTIOCO', 'I294'],
      ['ASSEMINI', 'A474'],
      ['VILLASOR', 'M025'],
      ['VILLASPECIOSA', 'M026'],
      ['BARRALI', 'A677'],
      ['ARMUNGIA', 'A419'],
      ['DOLIANOVA', 'D323'],
      ['SANLURI', 'H974'],
      ['TUILI', 'L463'],
      ['SERRENTI', 'I667'],
      ['ORTACESUS', 'G133'],
      ['SAN VITO', 'I402'],
      ['ARBUS', 'A359'],
      ['SERRAMANNA', 'I647'],
      ['FURTEI', 'D827'],
      ['SERDIANA', 'I624'],
      ['UTA', 'L521'],
      ['NUXIS', 'F991'],
      ['SUELLI', 'I995'],
      ['GESTURI', 'D997'],
      ['GESICO', 'D994'],
      ['BALLAO', 'A597'],
      ['PISCINAS', 'M291'],
      ['ELMAS', 'D399'],
      ['GENURI', 'D970'],
      ['VILLAPERUCCIO', 'M278'],
      ['MASAINAS', 'M270'],
      ['MARACALAGONIS', 'E903'],
      ['VILLANOVAFRANCA', 'L987'],
      ['VILLANOVAFORRU', 'L986'],
      ['CALASETTA', 'B383'],
      ['MONSERRATO', 'F383'],
      ['SELEGAS', 'I582'],
      ['SELARGIUS', 'I580'],
      ['VILLA SAN PIETRO', 'I118'],
      ['QUARTU SANT\'ELENA', 'H118'],
      ['QUARTUCCIU', 'H119'],
      ['COLLINAS', 'C882'],
      ['DECIMOMANNU', 'D259'],
      ['SINNAI', 'I752'],
      ['PIMENTEL', 'G669'],
      ['IGLESIAS', 'E281'],
      ['SAMASSI', 'H738'],
      ['SAMATZAI', 'H739'],
      ['PULA', 'H088'],
      ['VILLASALTO', 'M016'],
      ['SILIUS', 'I735'],
      ['SILIQUA', 'I734'],
      ['BARUMINI', 'A681'],
      ['DOMUSNOVAS', 'D334'],
      ['DOMUS DE MARIA', 'D333'],
      ['TEULADA', 'L154'],
      ['PORTOSCUSO', 'G922'],
      ['NARCAO', 'F841'],
      ['MONASTIR', 'F333'],
      ['PAULI ARBAREI', 'G382'],
      ['SAN NICOLO\' GERREI', 'G383'],
      ['SARROCH', 'I443'],
      ['MUSEI', 'F822'],
      ['TURRI', 'L473'],
      ['GONNESA', 'E086'],
      ['GONNOSFANADIGA', 'E085'],
      ['BUGGERRU', 'B250'],
      ['SOLEMINIS', 'I797'],
      ['GUAMAGGIORE', 'E234'],
      ['CARLOFORTE', 'B789'],
      ['MURAVERA', 'F808'],
      ['VILLACIDRO', 'L924'],
      ['BURCEI', 'B274'],
      ['SANTADI', 'I182'],
      ['PABILLONIS', 'G207'],
      ['GUSPINI', 'E270'],
      ['SENORBI\'', 'I615'],
      ['SARDARA', 'I428'],
      ['USSANA', 'L512'],
      ['USSARAMANNA', 'L513'],
      ['NURAMINIS', 'F983'],
      ['SAN SPERATE', 'I166'],
      ['GUASILA', 'E252'],
      ['CASTIADAS', 'M288'],
      ['SANT\'ANDREA FRIUS', 'I271'],
      ['VILLAPUTZU', 'L998']
    ],
    CB: [
      ['SAN POLO MATESE', 'I122'],
      ['ACQUAVIVA COLLECROCE', 'A050'],
      ['LUPARA', 'E748'],
      ['SAN BIASE', 'H782'],
      ['PIETRACUPA', 'G610'],
      ['SANT\'ANGELO LIMOSANO', 'I289'],
      ['SAN MASSIMO', 'I023'],
      ['MATRICE', 'F055'],
      ['SAN GIACOMO DEGLI SCHIAVONI', 'H867'],
      ['TAVENNA', 'L069'],
      ['MONTELONGO', 'F548'],
      ['CASTELLINO DEL BIFERNO', 'C175'],
      ['SAN FELICE DEL MOLISE', 'H833'],
      ['CASALCIPRANO', 'B871'],
      ['MONTEMITRO', 'F569'],
      ['CASACALENDA', 'B858'],
      ['CASTELMAURO', 'C197'],
      ['MORRONE DEL SANNIO', 'F748'],
      ['CAMPOCHIARO', 'B522'],
      ['CAMPODIPIETRA', 'B528'],
      ['CERCEPICCOLA', 'C488'],
      ['CERCEMAGGIORE', 'C486'],
      ['GAMBATESA', 'D896'],
      ['CAMPOLIETO', 'B544'],
      ['PORTOCANNONE', 'G910'],
      ['SPINETE', 'I910'],
      ['SALCITO', 'H693'],
      ['PALATA', 'G257'],
      ['MONACILIONI', 'F322'],
      ['CIVITACAMPOMARANO', 'C764'],
      ['PETRELLA TIFERNINA', 'G512'],
      ['RICCIA', 'H273'],
      ['BARANELLO', 'A616'],
      ['SAN MARTINO IN PENSILIS', 'H990'],
      ['JELSI', 'E381'],
      ['URURI', 'L505'],
      ['GUARDIAREGIA', 'E248'],
      ['BONEFRO', 'A971'],
      ['MONTECILFONE', 'F475'],
      ['GILDONE', 'E030'],
      ['PIETRACATELLA', 'G609'],
      ['MONTEFALCONE NEL SANNIO', 'F495'],
      ['SANT\'ELIA A PIANISI', 'I320'],
      ['MONTENERO DI BISACCIA', 'F576'],
      ['GUGLIONESI', 'E259'],
      ['CAMPOBASSO', 'B519'],
      ['VINCHIATURO', 'M057'],
      ['MIRABELLO SANNITICO', 'F233'],
      ['PROVVIDENTI', 'H083'],
      ['LARINO', 'E456'],
      ['CAMPOMARINO', 'B550'],
      ['GUARDIALFIERA', 'E244'],
      ['CASTELBOTTACCIO', 'C066'],
      ['SAN GIOVANNI IN GALDO', 'H920'],
      ['SAN GIULIANO DI PUGLIA', 'H929'],
      ['SAN GIULIANO DEL SANNIO', 'H928'],
      ['TRIVENTO', 'L435'],
      ['LIMOSANO', 'E599'],
      ['TORO', 'L230'],
      ['BUSSO', 'B295'],
      ['MOLISE', 'F294'],
      ['MACCHIA VALFORTORE', 'E780'],
      ['TUFARA', 'L458'],
      ['TORELLA DEL SANNIO', 'L215'],
      ['RIPABOTTONI', 'H311'],
      ['RIPALIMOSANI', 'H313'],
      ['ROTELLO', 'H589'],
      ['PETACCIATO', 'G506'],
      ['TERMOLI', 'L113'],
      ['FOSSALTO', 'D737'],
      ['DURONIA', 'C772'],
      ['ORATINO', 'G086'],
      ['CASTROPIGNANO', 'C346'],
      ['MAFALDA', 'E799'],
      ['MONTAGANO', 'F391'],
      ['SANTA CROCE DI MAGLIANO', 'I181'],
      ['MONTORIO NEI FRENTANI', 'F689'],
      ['SEPINO', 'I618'],
      ['ROCCAVIVARA', 'H454'],
      ['COLLETORTO', 'C875'],
      ['LUCITO', 'E722'],
      ['BOIANO', 'A930'],
      ['COLLE D\'ANCHISE', 'C854'],
      ['FERRAZZANO', 'D550']
    ],
    CE: [
      ['ROCCAROMANA', 'H436'],
      ['CANCELLO ED ARNONE', 'B581'],
      ['GIOIA SANNITICA', 'E039'],
      ['CASTEL DI SASSO', 'C097'],
      ['PIETRAVAIRANO', 'G630'],
      ['VALLE DI MADDALONI', 'L591'],
      ['VALLE AGRICOLA', 'L594'],
      ['AVERSA', 'A512'],
      ['SPARANISE', 'I885'],
      ['CASTEL MORRONE', 'C211'],
      ['CASTELLO DEL MATESE', 'C178'],
      ['RUVIANO', 'H165'],
      ['MIGNANO MONTE LUNGO', 'F203'],
      ['SAN FELICE A CANCELLO', 'H834'],
      ['BELLONA', 'A755'],
      ['BAIA E LATINA', 'A579'],
      ['CASAL DI PRINCIPE', 'B872'],
      ['MARZANO APPIO', 'E998'],
      ['SAN PRISCO', 'I131'],
      ['SAN POTITO SANNITICO', 'I130'],
      ['VILLA DI BRIANO', 'D801'],
      ['LUSCIANO', 'E754'],
      ['CAPUA', 'B715'],
      ['RIARDO', 'H268'],
      ['CASTEL VOLTURNO', 'C291'],
      ['DRAGONI', 'D361'],
      ['CARINARO', 'B779'],
      ['SAN GREGORIO MATESE', 'H939'],
      ['SANTA MARIA A VICO', 'I233'],
      ['VILLA LITERNO', 'L844'],
      ['CAPRIATI A VOLTURNO', 'B704'],
      ['CERVINO', 'C558'],
      ['CASALUCE', 'B916'],
      ['TORA E PICCILLI', 'L205'],
      ['RAVISCANINA', 'H202'],
      ['SAN MARCELLINO', 'H978'],
      ['AILANO', 'A106'],
      ['ORTA DI ATELLA', 'G130'],
      ['CASAPULLA', 'B935'],
      ['FORMICOLA', 'D709'],
      ['GRAZZANISE', 'E158'],
      ['CAMIGLIANO', 'B477'],
      ['ALVIGNANO', 'A243'],
      ['PRATA SANNITA', 'G991'],
      ['PRATELLA', 'G995'],
      ['SUCCIVO', 'I993'],
      ['FRANCOLISE', 'D769'],
      ['GIANO VETUSTO', 'E011'],
      ['SAN CIPRIANO D\'AVERSA', 'H798'],
      ['ROCCAMONFINA', 'H423'],
      ['PIEDIMONTE MATESE', 'G596'],
      ['SAN MARCO EVANGELISTA', 'F043'],
      ['VAIRANO PATENORA', 'L540'],
      ['SAN NICOLA LA STRADA', 'I056'],
      ['CAIAZZO', 'B362'],
      ['CAIANELLO', 'B361'],
      ['FONTEGRECA', 'D683'],
      ['CAPODRISE', 'B667'],
      ['SAN PIETRO INFINE', 'I113'],
      ['SANTA MARIA CAPUA VETERE', 'I234'],
      ['PIETRAMELARA', 'G620'],
      ['SANT\'ARPINO', 'I306'],
      ['CASTEL CAMPAGNANO', 'B494'],
      ['CASAGIOVE', 'B860'],
      ['PIGNATARO MAGGIORE', 'G661'],
      ['GALLO MATESE', 'D884'],
      ['GALLUCCIO', 'D886'],
      ['PORTICO DI CASERTA', 'G903'],
      ['CONCA DELLA CAMPANIA', 'C939'],
      ['CASERTA', 'B963'],
      ['TEVEROLA', 'L155'],
      ['MACERATA CAMPANIA', 'E784'],
      ['SESSA AURUNCA', 'I676'],
      ['ARIENZO', 'A403'],
      ['CESA', 'C561'],
      ['LIBERI', 'E570'],
      ['CIORLANO', 'C716'],
      ['RECALE', 'H210'],
      ['FALCIANO DEL MASSICO', 'D471'],
      ['SAN TAMMARO', 'I261'],
      ['LETINO', 'E554'],
      ['CARINOLA', 'B781'],
      ['GRICIGNANO DI AVERSA', 'E173'],
      ['ROCCA D\'EVANDRO', 'H398'],
      ['VITULAZIO', 'M092'],
      ['CALVI RISORTA', 'B445'],
      ['SANTA MARIA LA FOSSA', 'I247'],
      ['MADDALONI', 'E791'],
      ['PONTELATONE', 'G849'],
      ['MONDRAGONE', 'F352'],
      ['PIANA DI MONTE VERNA', 'G541'],
      ['ROCCHETTA E CROCE', 'H459'],
      ['PARETE', 'G333'],
      ['PRESENZANO', 'H045'],
      ['ALIFE', 'A200'],
      ['MARCIANISE', 'E932'],
      ['FRIGNANO', 'D799'],
      ['SANT\'ANGELO D\'ALIFE', 'I273'],
      ['TRENTOLA DUCENTA', 'L379'],
      ['PASTORANO', 'G364'],
      ['CELLOLE', 'M262'],
      ['CASAPESENNA', 'M260'],
      ['CURTI', 'D228'],
      ['TEANO', 'L083']
    ],
    CH: [
      ['CASTEL FRENTANO', 'C114'],
      ['SAN BUONO', 'H784'],
      ['PIETRAFERRAZZANA', 'G613'],
      ['ROCCA SAN GIOVANNI', 'H439'],
      ['CUPELLO', 'D209'],
      ['CELENZA SUL TRIGNO', 'C428'],
      ['CHIETI', 'C632'],
      ['TARANTA PELIGNA', 'L047'],
      ['FALLO', 'D480'],
      ['LAMA DEI PELIGNI', 'E424'],
      ['ROIO DEL SANGRO', 'H495'],
      ['SANT\'EUSANIO DEL SANGRO', 'I335'],
      ['MOZZAGROGNA', 'F785'],
      ['PERANO', 'G441'],
      ['MIGLIANICO', 'F196'],
      ['CASACANDITELLA', 'B859'],
      ['CARUNCHIO', 'B853'],
      ['POGGIOFIORITO', 'G760'],
      ['GAMBERALE', 'D898'],
      ['VILLAMAGNA', 'L964'],
      ['VILLALFONSINA', 'L961'],
      ['CASTIGLIONE MESSER MARINO', 'C298'],
      ['CRECCHIO', 'D137'],
      ['TORNARECCIO', 'L224'],
      ['RIPA TEATINA', 'H320'],
      ['PIZZOFERRATO', 'G724'],
      ['VILLA SANTA MARIA', 'M022'],
      ['MONTEODORISIO', 'F582'],
      ['SAN GIOVANNI TEATINO', 'D690'],
      ['CIVITALUPARELLA', 'C768'],
      ['PALENA', 'G271'],
      ['MONTEBELLO SUL SANGRO', 'B268'],
      ['GIULIANO TEATINO', 'E056'],
      ['GISSI', 'E052'],
      ['ROCCASCALEGNA', 'H442'],
      ['ROCCASPINALVETI', 'H448'],
      ['VACRI', 'L526'],
      ['ARI', 'A398'],
      ['PAGLIETA', 'G237'],
      ['GUILMI', 'E266'],
      ['GESSOPALENA', 'D996'],
      ['MONTAZZOLI', 'F433'],
      ['SAN MARTINO SULLA MARRUCINA', 'H991'],
      ['TORREVECCHIA TEATINA', 'L284'],
      ['PRETORO', 'H052'],
      ['FRANCAVILLA AL MARE', 'D763'],
      ['TREGLIO', 'L363'],
      ['ROCCAMONTEPIANO', 'H424'],
      ['CANOSA SANNITA', 'B620'],
      ['PALMOLI', 'G290'],
      ['PALOMBARO', 'G294'],
      ['CASTELGUIDONE', 'C123'],
      ['PENNADOMO', 'G434'],
      ['PENNAPIEDIMONTE', 'G435'],
      ['FARA SAN MARTINO', 'D495'],
      ['CARPINETO SINELLO', 'B826'],
      ['LANCIANO', 'E435'],
      ['FARA FILIORUM PETRI', 'D494'],
      ['ROSELLO', 'H566'],
      ['MONTEFERRANTE', 'F498'],
      ['CASALANGUIDA', 'B861'],
      ['CASALBORDINO', 'B865'],
      ['MONTENERODOMO', 'F578'],
      ['SCHIAVI DI ABRUZZO', 'I526'],
      ['SCERNI', 'I520'],
      ['ALTINO', 'A235'],
      ['QUADRI', 'H098'],
      ['CASOLI', 'B985'],
      ['SAN VITO CHIETINO', 'I394'],
      ['MONTELAPIANO', 'F535'],
      ['ORTONA', 'G141'],
      ['FILETTO', 'D592'],
      ['TOLLO', 'L194'],
      ['DOGLIOLA', 'D315'],
      ['GUARDIAGRELE', 'E243'],
      ['SAN GIOVANNI LIPIONI', 'H923'],
      ['VASTO', 'E372'],
      ['TUFILLO', 'L459'],
      ['ARIELLI', 'A402'],
      ['ORSOGNA', 'G128'],
      ['TORINO DI SANGRO', 'L218'],
      ['LETTOPALENA', 'E559'],
      ['FRISA', 'D803'],
      ['FOSSACESIA', 'D738'],
      ['CIVITELLA MESSER RAIMONDO', 'C776'],
      ['ARCHI', 'A367'],
      ['SANTA MARIA IMBARO', 'I244'],
      ['LENTELLA', 'E531'],
      ['TORREBRUNA', 'L253'],
      ['BORRELLO', 'B057'],
      ['FURCI', 'D823'],
      ['FRAINE', 'D757'],
      ['LISCIA', 'E611'],
      ['RAPINO', 'H184'],
      ['BOMBA', 'A956'],
      ['ATESSA', 'A485'],
      ['TORRICELLA PELIGNA', 'L291'],
      ['BUCCHIANICO', 'B238'],
      ['CASALINCONTRADA', 'B896'],
      ['FRESAGRANDINARIA', 'D796'],
      ['POLLUTRI', 'G799'],
      ['SAN SALVO', 'I148'],
      ['COLLEDIMEZZO', 'C856'],
      ['COLLEDIMACINE', 'C855']
    ],
    CL: [
      ['SOMMATINO', 'I824'],
      ['DELIA', 'D267'],
      ['MONTEDORO', 'F489'],
      ['NISCEMI', 'F899'],
      ['RIESI', 'H281'],
      ['MUSSOMELI', 'F830'],
      ['SERRADIFALCO', 'I644'],
      ['MARIANOPOLI', 'E953'],
      ['MAZZARINO', 'F065'],
      ['RESUTTANO', 'H245'],
      ['SAN CATALDO', 'H792'],
      ['ACQUAVIVA PLATANI', 'A049'],
      ['SANTA CATERINA VILLARMOSA', 'I169'],
      ['BUTERA', 'B302'],
      ['MILENA', 'E618'],
      ['SUTERA', 'L016'],
      ['VALLELUNGA PRATAMENO', 'L609'],
      ['CAMPOFRANCO', 'B537'],
      ['VILLALBA', 'L959'],
      ['CALTANISSETTA', 'B429'],
      ['BOMPENSIERE', 'A957'],
      ['GELA', 'D960']
    ],
    CN: [
      ['VALDIERI', 'L558'],
      ['CAMO', 'B489'],
      ['MONTICELLO D\'ALBA', 'F669'],
      ['MONTEZEMOLO', 'F666'],
      ['BRA', 'B111'],
      ['BAGNASCO', 'A555'],
      ['SOMMARIVA PERNO', 'I823'],
      ['SOMMARIVA DEL BOSCO', 'I822'],
      ['MARSAGLIA', 'E973'],
      ['CUNEO', 'D205'],
      ['MONTEROSSO GRANA', 'F608'],
      ['CELLE DI MACRA', 'C441'],
      ['BERGOLO', 'A798'],
      ['LAGNASCO', 'E406'],
      ['TARANTASCA', 'L048'],
      ['ROSSANA', 'H578'],
      ['SAN DAMIANO MACRA', 'H812'],
      ['SAMBUCO', 'H746'],
      ['CERESOLE ALBA', 'C504'],
      ['SANTA VITTORIA D\'ALBA', 'I316'],
      ['ROASCIO', 'H363'],
      ['CASTELNUOVO DI CEVA', 'C214'],
      ['CASTELLINALDO', 'C173'],
      ['CASTELLINO TANARO', 'C176'],
      ['VERZUOLO', 'L804'],
      ['BELLINO', 'A750'],
      ['BAGNOLO PIEMONTE', 'A571'],
      ['ROCCABRUNA', 'H385'],
      ['CAPRAUNA', 'B692'],
      ['PAROLDO', 'G339'],
      ['VALLORIATE', 'L631'],
      ['VALMALA', 'L636'],
      ['SANFRONT', 'H852'],
      ['SANFRE\'', 'H851'],
      ['SALE SAN GIOVANNI', 'H704'],
      ['BELVEDERE LANGHE', 'A774'],
      ['BENE VAGIENNA', 'A779'],
      ['BERNEZZO', 'A805'],
      ['RIFREDDO', 'H285'],
      ['SCARNAFIGI', 'I512'],
      ['CRISSOLO', 'D172'],
      ['ALBA', 'A124'],
      ['CAVALLERMAGGIORE', 'C376'],
      ['CARAGLIO', 'B719'],
      ['SALUZZO', 'H727'],
      ['BATTIFOLLO', 'A716'],
      ['SANTO STEFANO ROERO', 'I372'],
      ['MOROZZO', 'F743'],
      ['ELVA', 'D401'],
      ['VIOLA', 'M063'],
      ['COSSANO BELBO', 'D093'],
      ['GAMBASCA', 'D894'],
      ['PRADLEVES', 'G970'],
      ['BEINETTE', 'A735'],
      ['POCAPAGLIA', 'G742'],
      ['NIELLA TANARO', 'F895'],
      ['NIELLA BELBO', 'F894'],
      ['CRAVANZANA', 'D133'],
      ['TRINITA\'', 'L427'],
      ['VIGNOLO', 'L888'],
      ['BUSCA', 'B285'],
      ['CARDE\'', 'B755'],
      ['VICOFORTE', 'L841'],
      ['GOTTASECCA', 'E115'],
      ['GORZEGNO', 'E111'],
      ['GOVONE', 'E118'],
      ['VILLAFALLETTO', 'L942'],
      ['BAROLO', 'A671'],
      ['ORMEA', 'G114'],
      ['SANT\'ALBANO STURA', 'I210'],
      ['CERVERE', 'C550'],
      ['LEVICE', 'E564'],
      ['MARGARITA', 'E945'],
      ['MELLE', 'F114'],
      ['GAIOLA', 'D856'],
      ['TORRE BORMIDA', 'L252'],
      ['SALE DELLE LANGHE', 'H695'],
      ['MONASTERO DI VASCO', 'F326'],
      ['MONASTEROLO CASOTTO', 'F329'],
      ['GARESSIO', 'D920'],
      ['ISASCA', 'E327'],
      ['MANTA', 'E894'],
      ['SAVIGLIANO', 'I470'],
      ['SCAGNELLO', 'I484'],
      ['MOMBARCARO', 'F309'],
      ['SERRALUNGA D\'ALBA', 'I646'],
      ['TORRE MONDOVI\'', 'L241'],
      ['PRAZZO', 'H011'],
      ['NUCETTO', 'F972'],
      ['MURELLO', 'F811'],
      ['CIGLIE\'', 'C681'],
      ['PIOBESI D\'ALBA', 'G683'],
      ['CERRETTO DELLE LANGHE', 'C530'],
      ['PEZZOLO VALLE UZZONE', 'G532'],
      ['ROCCASPARVERA', 'H447'],
      ['BRONDELLO', 'B200'],
      ['BROSSASCO', 'B204'],
      ['ARGUELLO', 'A396'],
      ['ARGENTERA', 'A394'],
      ['PONTECHIANALE', 'G837'],
      ['AISONE', 'A113'],
      ['TORRESINA', 'L281'],
      ['ALTO', 'A238'],
      ['ROCCHETTA BELBO', 'H462'],
      ['PRIERO', 'H059'],
      ['BOSSOLASCO', 'B084'],
      ['VERDUNO', 'L758'],
      ['DIANO D\'ALBA', 'D291'],
      ['MORETTA', 'F723'],
      ['ROCCAFORTE MONDOVI\'', 'H407'],
      ['PIASCO', 'G575'],
      ['SOMANO', 'I817'],
      ['FOSSANO', 'D742'],
      ['FRASSINO', 'D782'],
      ['REVELLO', 'H247'],
      ['SAN MICHELE MONDOVI\'', 'I037'],
      ['TREISO', 'L367'],
      ['VERNANTE', 'L771'],
      ['MONTEU ROERO', 'F654'],
      ['BRIAGLIA', 'B167'],
      ['MONTA\'', 'F385'],
      ['VOTTIGNASCO', 'M136'],
      ['CHERASCO', 'C599'],
      ['MARMORA', 'E963'],
      ['RUFFIA', 'H633'],
      ['CANOSIO', 'B621'],
      ['BOVES', 'B101'],
      ['MONTELUPO ALBESE', 'F550'],
      ['CORTEMILIA', 'D062'],
      ['BENEVELLO', 'A782'],
      ['FEISOGLIO', 'D523'],
      ['CASTELLAR', 'C140'],
      ['CASTELDELFINO', 'C081'],
      ['SAMPEYRE', 'H755'],
      ['NEIVE', 'F863'],
      ['PIETRAPORZIO', 'G625'],
      ['LA MORRA', 'E430'],
      ['DEMONTE', 'D271'],
      ['VALGRANA', 'L580'],
      ['MONTEMALE DI CUNEO', 'F558'],
      ['FARIGLIANO', 'D499'],
      ['CASTELLETTO UZZONE', 'C167'],
      ['CASTELLETTO STURA', 'C165'],
      ['CORNELIANO D\'ALBA', 'D022'],
      ['SAN BENEDETTO BELBO', 'H770'],
      ['MARTINIANA PO', 'E988'],
      ['LEQUIO BERRIA', 'E540'],
      ['OSTANA', 'G183'],
      ['VEZZA D\'ALBA', 'L817'],
      ['PERLO', 'G458'],
      ['RACCONIGI', 'H150'],
      ['SINIO', 'I750'],
      ['SALICETO', 'H710'],
      ['SALMOUR', 'H716'],
      ['LISIO', 'E615'],
      ['CARTIGNANO', 'B845'],
      ['CARRU\'', 'B841'],
      ['VINADIO', 'M055'],
      ['VENASCA', 'L729'],
      ['IGLIANO', 'E282'],
      ['PAMPARATO', 'G302'],
      ['LIMONE PIEMONTE', 'E597'],
      ['CARAMAGNA PIEMONTE', 'B720'],
      ['RITTANA', 'H326'],
      ['BASTIA MONDOVI\'', 'A709'],
      ['SANTO STEFANO BELBO', 'I367'],
      ['CLAVESANA', 'C792'],
      ['ALBARETTO DELLA TORRE', 'A139'],
      ['MAGLIANO ALFIERI', 'E809'],
      ['MAGLIANO ALPI', 'E808'],
      ['GRINZANE CAVOUR', 'E182'],
      ['DRONERO', 'D372'],
      ['CASTELMAGNO', 'C205'],
      ['PRUNETTO', 'H085'],
      ['BALDISSERO D\'ALBA', 'A589'],
      ['VILLANOVA MONDOVI\'', 'L974'],
      ['NEVIGLIE', 'F883'],
      ['ENVIE', 'D412'],
      ['ENTRACQUE', 'D410'],
      ['VILLAR SAN COSTANZO', 'M015'],
      ['TREZZO TINELLA', 'L410'],
      ['DOGLIANI', 'D314'],
      ['MOIOLA', 'F279'],
      ['ROASCHIA', 'H362'],
      ['CANALE', 'B573'],
      ['COSTIGLIOLE SALUZZO', 'D120'],
      ['CERVASCA', 'C547'],
      ['BORGO SAN DALMAZZO', 'B033'],
      ['CISSONE', 'C738'],
      ['CASTAGNITO', 'C046'],
      ['MACRA', 'E789'],
      ['NARZOLE', 'F846'],
      ['MONASTEROLO DI SAVIGLIANO', 'F330'],
      ['MONCHIERO', 'F338'],
      ['BARGE', 'A660'],
      ['PERLETTO', 'G457'],
      ['BORGOMALE', 'B018'],
      ['CASTIGLIONE TINELLA', 'C317'],
      ['ROBILANTE', 'H377'],
      ['ROBURENT', 'H378'],
      ['MOMBASIGLIO', 'F312'],
      ['CAMERANA', 'B467'],
      ['SERRAVALLE LANGHE', 'I659'],
      ['MANGO', 'E887'],
      ['BOSIA', 'B079'],
      ['TORRE SAN GIORGIO', 'L278'],
      ['MURAZZANO', 'F809'],
      ['ROCCA DE\' BALDI', 'H395'],
      ['ROCCA CIGLIE\'', 'H391'],
      ['CASTIGLIONE FALLETTO', 'C314'],
      ['BARBARESCO', 'A629'],
      ['PIOZZO', 'G697'],
      ['LEQUIO TANARO', 'E539'],
      ['PEVERAGNO', 'G526'],
      ['FRABOSA SOPRANA', 'D751'],
      ['FRABOSA SOTTANA', 'D752'],
      ['ONCINO', 'G066'],
      ['NOVELLO', 'F961'],
      ['STROPPO', 'I985'],
      ['MONESIGLIO', 'F355'],
      ['MONDOVI\'', 'F351'],
      ['MONFORTE D\'ALBA', 'F358'],
      ['BONVICINO', 'A979'],
      ['CASTINO', 'C323'],
      ['BRIGA ALTA', 'B175'],
      ['ROCCAVIONE', 'H453'],
      ['FAULE', 'D511'],
      ['ACCEGLIO', 'A016'],
      ['PAESANA', 'G228'],
      ['GUARENE', 'E251'],
      ['MONTALDO DI MONDOVI\'', 'F405'],
      ['MONTALDO ROERO', 'F408'],
      ['CHIUSA DI PESIO', 'C653'],
      ['RODELLO', 'H474'],
      ['RODDINO', 'H473'],
      ['RODDI', 'H472'],
      ['PIANFEI', 'G561'],
      ['MARENE', 'E939'],
      ['PRIOCCA', 'H068'],
      ['PRIOLA', 'H069'],
      ['CASALGRASSO', 'B894'],
      ['MONTANERA', 'F424'],
      ['VILLANOVA SOLARO', 'L990'],
      ['CENTALLO', 'C466'],
      ['GENOLA', 'D967'],
      ['POLONGHERA', 'G800'],
      ['CEVA', 'C589'],
      ['PAGNO', 'G240'],
      ['LESEGNO', 'E546'],
      ['CAVALLERLEONE', 'C375']
    ],
    CO: [
      ['LURAGO D\'ERBA', 'E749'],
      ['ALBESE CON CASSANO', 'A153'],
      ['CANTU\'', 'B639'],
      ['PELLIO INTELVI', 'G427'],
      ['CAGNO', 'B359'],
      ['CAGLIO', 'B355'],
      ['BREGNANO', 'B134'],
      ['BEREGAZZO CON FIGLIARO', 'A791'],
      ['ALZATE BRIANZA', 'A249'],
      ['LAGLIO', 'E405'],
      ['FALOPPIO', 'D482'],
      ['CAPIAGO INTIMIANO', 'B653'],
      ['LAMBRUGO', 'E428'],
      ['MASLIANICO', 'F017'],
      ['ALBIOLO', 'A164'],
      ['PORLEZZA', 'G889'],
      ['CABIATE', 'B313'],
      ['CASSINA RIZZARDI', 'C020'],
      ['SAN FEDELE INTELVI', 'H830'],
      ['SAN BARTOLOMEO VAL CAVARGNA', 'H760'],
      ['LIVO', 'E623'],
      ['LANZO D\'INTELVI', 'E444'],
      ['MOZZATE', 'F788'],
      ['MONTEMEZZO', 'F564'],
      ['ALBAVILLA', 'A143'],
      ['CARATE URIO', 'B730'],
      ['BENE LARIO', 'A778'],
      ['DONGO', 'D341'],
      ['CLAINO CON OSTENO', 'C787'],
      ['LURATE CACCIVIO', 'E753'],
      ['LURAGO MARINONE', 'E750'],
      ['LIPOMO', 'E607'],
      ['CARUGO', 'B851'],
      ['LASNIGO', 'E462'],
      ['CAVALLASCA', 'C374'],
      ['COLONNO', 'C902'],
      ['CERANO D\'INTELVI', 'C482'],
      ['GARZENO', 'D930'],
      ['MAGREGLIO', 'E830'],
      ['DREZZO', 'D369'],
      ['CARIMATE', 'B778'],
      ['CASTIGLIONE D\'INTELVI', 'C299'],
      ['GRANDATE', 'E139'],
      ['VERTEMATE CON MINOPRIO', 'L792'],
      ['ASSO', 'A476'],
      ['TORNO', 'L228'],
      ['CASNATE CON BERNATE', 'B977'],
      ['CASLINO D\'ERBA', 'B974'],
      ['ANZANO DEL PARCO', 'A319'],
      ['BARNI', 'A670'],
      ['INVERIGO', 'E309'],
      ['DOMASO', 'D329'],
      ['CERNOBBIO', 'C520'],
      ['GRIANTE', 'E172'],
      ['APPIANO GENTILE', 'A333'],
      ['CONSIGLIO DI RUMO', 'C965'],
      ['FAGGETO LARIO', 'D462'],
      ['AROSIO', 'A430'],
      ['GRAVEDONA', 'E151'],
      ['NOVEDRATE', 'F958'],
      ['MOLTRASIO', 'F305'],
      ['UGGIATE-TREVANO', 'L487'],
      ['LENNO', 'E525'],
      ['FENEGRO\'', 'D531'],
      ['CERMENATE', 'C516'],
      ['BULGAROGRASSO', 'B262'],
      ['MERONE', 'F151'],
      ['VELESO', 'L715'],
      ['GIRONICO', 'E051'],
      ['PUSIANO', 'H094'],
      ['CREMIA', 'D147'],
      ['MARIANO COMENSE', 'E951'],
      ['OLTRONA DI SAN MAMETTE', 'G056'],
      ['ARGEGNO', 'A391'],
      ['CUCCIAGO', 'D196'],
      ['VENIANO', 'L737'],
      ['PIANELLO DEL LARIO', 'G556'],
      ['FINO MORNASCO', 'D605'],
      ['BRENNA', 'B144'],
      ['GERA LARIO', 'D974'],
      ['MONTANO LUCINO', 'F427'],
      ['PROSERPIO', 'H074'],
      ['SALA COMACINA', 'H679'],
      ['LUISAGO', 'E735'],
      ['BLESSAGNO', 'A904'],
      ['BLEVIO', 'A905'],
      ['CORRIDO', 'D041'],
      ['CUSINO', 'D232'],
      ['VALBRONA', 'L547'],
      ['SAN NAZZARO VAL CAVARGNA', 'I051'],
      ['SORICO', 'I856'],
      ['LAINO', 'E416'],
      ['CANZO', 'B641'],
      ['PEGLIO', 'G415'],
      ['CADORAGO', 'B346'],
      ['SORMANO', 'I860'],
      ['VALMOREA', 'L640'],
      ['ZELBIO', 'M156'],
      ['BELLAGIO', 'A744'],
      ['ROVELLO PORRO', 'H602'],
      ['CASTELMARTE', 'C206'],
      ['TAVERNERIO', 'L071'],
      ['RAMPONIO VERNA', 'H171'],
      ['SCHIGNANO', 'I529'],
      ['OSSUCCIO', 'G182'],
      ['PARE\'', 'G329'],
      ['SAN FERMO DELLA BATTAGLIA', 'H840'],
      ['CIRIMIDO', 'C724'],
      ['PIGRA', 'G665'],
      ['CAMPIONE D\'ITALIA', 'B513'],
      ['RONAGO', 'H521'],
      ['MEZZEGRA', 'F181'],
      ['DOSSO DEL LIRO', 'D355'],
      ['NESSO', 'F877'],
      ['LONGONE AL SEGRINO', 'E679'],
      ['STAZZONA', 'I943'],
      ['LOCATE VARESINO', 'E638'],
      ['EUPILIO', 'D445'],
      ['POGNANA LARIO', 'G773'],
      ['LOMAZZO', 'E659'],
      ['ERBA', 'D416'],
      ['TREZZONE', 'L413'],
      ['CASASCO D\'INTELVI', 'B942'],
      ['DIZZASCO', 'D310'],
      ['BINAGO', 'A870'],
      ['VILLA GUARDIA', 'L956'],
      ['VALSOLDA', 'C936'],
      ['COMO', 'C933'],
      ['REZZAGO', 'H255'],
      ['VAL REZZO', 'H259'],
      ['LIMIDO COMASCO', 'E593'],
      ['LEZZENO', 'E569'],
      ['CARBONATE', 'B742'],
      ['BIZZARONE', 'A898'],
      ['PLESIO', 'G737'],
      ['ORSENIGO', 'G126'],
      ['CAVARGNA', 'C381'],
      ['GRANDOLA ED UNITI', 'E141'],
      ['MUSSO', 'F828'],
      ['TURATE', 'L470'],
      ['MENAGGIO', 'F120'],
      ['SOLBIATE', 'I792'],
      ['GUANZATE', 'E235'],
      ['CARLAZZO', 'B785'],
      ['MONGUZZO', 'F372'],
      ['CIVENNA', 'C754'],
      ['MONTORFANO', 'F688'],
      ['PONTE LAMBRO', 'G847'],
      ['SENNA COMASCO', 'I611'],
      ['CASTELNUOVO BOZZENTE', 'C220'],
      ['BRUNATE', 'B218'],
      ['ROVELLASCA', 'H601'],
      ['SAN SIRO', 'I162'],
      ['GERMASINO', 'D986'],
      ['PONNA', 'G821'],
      ['ALSERIO', 'A224'],
      ['RODERO', 'H478'],
      ['FIGINO SERENZA', 'D579'],
      ['OLGIATE COMASCO', 'G025'],
      ['TREMEZZO', 'L371'],
      ['VERCANA', 'L748'],
      ['BRIENNO', 'B172']
    ],
    CR: [
      ['OFFANENGO', 'G004'],
      ['CASTEL GABBIANO', 'C115'],
      ['GRUMELLO CREMONESE ED UNITI', 'E217'],
      ['CORTE DE\' FRATI', 'D057'],
      ['CORTE DE\' CORTESI CON CIGNONE', 'D056'],
      ['SONCINO', 'I827'],
      ['CUMIGNANO SUL NAVIGLIO', 'D203'],
      ['AGNADELLO', 'A076'],
      ['CHIEVE', 'C634'],
      ['SORESINA', 'I849'],
      ['CAPERGNANICA', 'B650'],
      ['CASTELLEONE', 'C153'],
      ['CAMISANO', 'B484'],
      ['SAN DANIELE PO', 'H815'],
      ['PIEVE SAN GIACOMO', 'G651'],
      ['SOSPIRO', 'I865'],
      ['CAPPELLA CANTONE', 'B679'],
      ['PERSICO DOSIMO', 'G469'],
      ['VESCOVATO', 'L806'],
      ['VOLONGO', 'M116'],
      ['SAN BASSANO', 'H767'],
      ['BAGNOLO CREMASCO', 'A570'],
      ['CELLA DATI', 'C435'],
      ['MOSCAZZANO', 'F761'],
      ['BORDOLANO', 'A986'],
      ['CREMONA', 'D150'],
      ['CREMOSANO', 'D151'],
      ['PESCAROLO ED UNITI', 'G483'],
      ['SCANDOLARA RIPA D\'OGLIO', 'I498'],
      ['STAGNO LOMBARDO', 'I935'],
      ['TRIGOLO', 'L426'],
      ['CASTELVISCONTI', 'C290'],
      ['TORNATA', 'L225'],
      ['TORLINO VIMERCATI', 'L221'],
      ['TICENGO', 'L164'],
      ['PIZZIGHETTONE', 'G721'],
      ['SPINO D\'ADDA', 'I914'],
      ['SAN GIOVANNI IN CROCE', 'H918'],
      ['POZZAGLIO ED UNITI', 'B914'],
      ['CINGIA DE\' BOTTI', 'C703'],
      ['RIVAROLO DEL RE ED UNITI', 'H341'],
      ['VAIANO CREMASCO', 'L535'],
      ['VAILATE', 'L539'],
      ['RICENGO', 'H276'],
      ['SERGNANO', 'I627'],
      ['PIADENA', 'G536'],
      ['SCANDOLARA RAVARA', 'I497'],
      ['CREMA', 'D142'],
      ['GERRE DE\' CAPRIOLI', 'D993'],
      ['CALVATONE', 'B439'],
      ['PIANENGO', 'G558'],
      ['IZANO', 'E380'],
      ['CASALE CREMASCO-VIDOLASCO', 'B881'],
      ['CASALETTO CEREDANO', 'B889'],
      ['CASTELDIDONE', 'C089'],
      ['GABBIONETA BINANUOVA', 'D834'],
      ['ISOLA DOVARESE', 'E356'],
      ['BONEMERSE', 'A972'],
      ['QUINTANO', 'H130'],
      ['AZZANELLO', 'A526'],
      ['PIERANICA', 'G603'],
      ['SESTO ED UNITI', 'I683'],
      ['CASTELVERDE', 'B129'],
      ['SALVIROLA', 'H731'],
      ['MONTE CREMASCO', 'F434'],
      ['DEROVERE', 'D278'],
      ['CA\' D\'ANDREA', 'B320'],
      ['CAMPAGNOLA CREMASCA', 'B498'],
      ['ANNICCO', 'A299'],
      ['PIEVE D\'OLMI', 'G647'],
      ['CASALBUTTANO ED UNITI', 'B869'],
      ['CAPRALBA', 'B686'],
      ['CAPPELLA DE\' PICENARDI', 'B680'],
      ['OSTIANO', 'G185'],
      ['MALAGNINO', 'E843'],
      ['MOTTA BALUFFI', 'F771'],
      ['TRESCORE CREMASCO', 'L389'],
      ['PANDINO', 'G306'],
      ['DOVERA', 'D358'],
      ['ROMANENGO', 'H508'],
      ['DRIZZONA', 'D370'],
      ['MARTIGNANA DI PO', 'E983'],
      ['CREDERA RUBBIANO', 'D141'],
      ['SPINADESCO', 'I906'],
      ['SPINEDA', 'I909'],
      ['GADESCO PIEVE DELMONA', 'D841'],
      ['RIVOLTA D\'ADDA', 'H357'],
      ['CASALMORANO', 'B900'],
      ['RIPALTA ARPINA', 'H314'],
      ['SAN MARTINO DEL LAGO', 'I007'],
      ['RIPALTA CREMASCA', 'H315'],
      ['RIPALTA GUERINA', 'H316'],
      ['GRONTARDO', 'E193'],
      ['FORMIGARA', 'D710'],
      ['ROBECCO D\'OGLIO', 'H372'],
      ['FIESCO', 'D574'],
      ['GOMBITO', 'E082'],
      ['PESSINA CREMONESE', 'G504'],
      ['SOLAROLO RAINERIO', 'I790'],
      ['PALAZZO PIGNANO', 'G260'],
      ['TORRE DE\' PICENARDI', 'L258'],
      ['MADIGNANO', 'E793'],
      ['GUSSOLA', 'E272'],
      ['MONTODINE', 'F681'],
      ['VOLTIDO', 'M127'],
      ['OLMENETA', 'G047'],
      ['PADERNO PONCHIELLI', 'G222'],
      ['CROTTA D\'ADDA', 'D186'],
      ['TORRICELLA DEL PIZZO', 'L296'],
      ['CASALMAGGIORE', 'B898'],
      ['CASALETTO VAPRIO', 'B891'],
      ['CASALETTO DI SOPRA', 'B890'],
      ['ACQUANEGRA CREMONESE', 'A039'],
      ['GENIVOLTA', 'D966'],
      ['CICOGNOLO', 'C678']
    ],
    CS: [
      ['ACRI', 'A053'],
      ['BOCCHIGLIERO', 'A912'],
      ['AMENDOLARA', 'A263'],
      ['PIETRAFITTA', 'G615'],
      ['PAPASIDERO', 'G320'],
      ['ALTOMONTE', 'A240'],
      ['LUNGRO', 'E745'],
      ['LAGO', 'E407'],
      ['SAN NICOLA ARCELLA', 'I060'],
      ['PEDACE', 'G400'],
      ['ROSETO CAPO SPULICO', 'H572'],
      ['ROSSANO', 'H579'],
      ['SAN DEMETRIO CORONE', 'H818'],
      ['ZUMPANO', 'M202'],
      ['CARPANZANO', 'B813'],
      ['ALBIDONA', 'A160'],
      ['MALITO', 'E859'],
      ['SAN BASILE', 'H765'],
      ['ROGLIANO', 'H490'],
      ['MALVITO', 'E872'],
      ['MANDATORICCIO', 'E878'],
      ['CELICO', 'C430'],
      ['CELLARA', 'C437'],
      ['BELVEDERE MARITTIMO', 'A773'],
      ['SANTO STEFANO DI ROGLIANO', 'I359'],
      ['CAMPANA', 'B500'],
      ['PAOLA', 'G317'],
      ['FIRMO', 'D614'],
      ['SANGINETO', 'H877'],
      ['COLOSIMI', 'C905'],
      ['CERCHIARA DI CALABRIA', 'C489'],
      ['AIETA', 'A105'],
      ['AIELLO CALABRO', 'A102'],
      ['PATERNO CALABRO', 'G372'],
      ['MAIERA\'', 'E835'],
      ['PRAIA A MARE', 'G975'],
      ['BIANCHI', 'A842'],
      ['SAN PIETRO IN AMANTEA', 'I108'],
      ['AMANTEA', 'A253'],
      ['DIPIGNANO', 'D304'],
      ['MORANO CALABRO', 'F708'],
      ['SAN GIOVANNI IN FIORE', 'H919'],
      ['ORIOLO', 'G110'],
      ['CERVICATI', 'C554'],
      ['TORANO CASTELLO', 'L206'],
      ['DOMANICO', 'D328'],
      ['FIGLINE VEGLIATURO', 'D582'],
      ['BISIGNANO', 'A887'],
      ['FAGNANO CASTELLO', 'D464'],
      ['SAN LUCIDO', 'H971'],
      ['SPEZZANO ALBANESE', 'I895'],
      ['SPEZZANO DELLA SILA', 'I896'],
      ['SPEZZANO PICCOLO', 'I898'],
      ['TERRANOVA DA SIBARI', 'L124'],
      ['CIVITA', 'C763'],
      ['SERRA D\'AIELLO', 'I642'],
      ['ALESSANDRIA DEL CARRETTO', 'A183'],
      ['FUSCALDO', 'D828'],
      ['MORMANNO', 'F735'],
      ['CERISANO', 'C515'],
      ['CARIATI', 'B774'],
      ['SANT\'AGATA DI ESARO', 'I192'],
      ['SAN MARTINO DI FINITA', 'H992'],
      ['PIANE CRATI', 'G553'],
      ['SAN VINCENZO LA COSTA', 'I388'],
      ['FRANCAVILLA MARITTIMA', 'D764'],
      ['GUARDIA PIEMONTESE', 'E242'],
      ['MONTALTO UFFUGO', 'F416'],
      ['SCIGLIANO', 'D290'],
      ['VACCARIZZO ALBANESE', 'L524'],
      ['CANNA', 'B607'],
      ['BONIFATI', 'A973'],
      ['SCALA COELI', 'I485'],
      ['PALUDI', 'G298'],
      ['ACQUAPPESA', 'A041'],
      ['TORTORA', 'L305'],
      ['MARZI', 'F001'],
      ['LAINO BORGO', 'E417'],
      ['LAINO CASTELLO', 'E419'],
      ['SANTA CATERINA ALBANESE', 'I171'],
      ['SAN PIETRO IN GUARANO', 'I114'],
      ['PEDIVIGLIANO', 'G411'],
      ['LUZZI', 'E773'],
      ['CORIGLIANO CALABRO', 'D005'],
      ['SAN COSMO ALBANESE', 'H806'],
      ['PIETRAPAOLA', 'G622'],
      ['SANTA SOFIA D\'EPIRO', 'I309'],
      ['CAROLEI', 'B802'],
      ['TARSIA', 'L055'],
      ['ROSE', 'H565'],
      ['SAN DONATO DI NINEA', 'H825'],
      ['SAN BENEDETTO ULLANO', 'H774'],
      ['ROGGIANO GRAVINA', 'H488'],
      ['GRIMALDI', 'E180'],
      ['SAN SOSTI', 'I165'],
      ['LAPPANO', 'E450'],
      ['ALTILIA', 'A234'],
      ['FIUMEFREDDO BRUZIO', 'D624'],
      ['SAN FILI', 'H841'],
      ['BELSITO', 'A768'],
      ['BELMONTE CALABRO', 'A762'],
      ['LATTARICO', 'E475'],
      ['MOTTAFOLLONE', 'F775'],
      ['MONTEGIORDANO', 'F519'],
      ['PANETTIERI', 'G307'],
      ['CASOLE BRUZIO', 'B983'],
      ['CLETO', 'C795'],
      ['LONGOBARDI', 'E677'],
      ['LONGOBUCCO', 'E678'],
      ['GRISOLIA', 'E185'],
      ['COSENZA', 'D086'],
      ['CASTIGLIONE COSENTINO', 'C301'],
      ['SAN GIORGIO ALBANESE', 'H881'],
      ['CASSANO ALLO IONIO', 'C002'],
      ['SCALEA', 'I489'],
      ['PLATACI', 'G733'],
      ['NOCARA', 'F907'],
      ['RENDE', 'H235'],
      ['ORSOMARSO', 'G129'],
      ['CERZETO', 'C560'],
      ['VILLAPIANA', 'B903'],
      ['TERRAVECCHIA', 'L134'],
      ['SANTA MARIA DEL CEDRO', 'C717'],
      ['APRIGLIANO', 'A340'],
      ['FALCONARA ALBANESE', 'D473'],
      ['SAN LORENZO DEL VALLO', 'H962'],
      ['SAN LORENZO BELLIZZI', 'H961'],
      ['SERRA PEDACE', 'I650'],
      ['ROTA GRECA', 'H585'],
      ['MANGONE', 'E888'],
      ['MENDICINO', 'F125'],
      ['TRENTA', 'L375'],
      ['MONGRASSANO', 'F370'],
      ['CASTROREGIO', 'C348'],
      ['CASTROVILLARI', 'C349'],
      ['BUONVICINO', 'B270'],
      ['DIAMANTE', 'D289'],
      ['ROVITO', 'H621'],
      ['SANTA DOMENICA TALAO', 'I183'],
      ['CALOPEZZATI', 'B424'],
      ['CALOVETO', 'B426'],
      ['PARENTI', 'G331'],
      ['SARACENA', 'I423'],
      ['FRASCINETO', 'D774'],
      ['TREBISACCE', 'L353'],
      ['CROPALATI', 'D180'],
      ['CROSIA', 'D184'],
      ['SAN MARCO ARGENTANO', 'H981'],
      ['CASTROLIBERO', 'C108'],
      ['ACQUAFORMOSA', 'A033'],
      ['VERBICARO', 'L747'],
      ['CETRARO', 'C588'],
      ['ROCCA IMPERIALE', 'H416'],
      ['MARANO PRINCIPATO', 'E915'],
      ['MARANO MARCHESATO', 'E914']
    ],
    CT: [
      ['ADRANO', 'A056'],
      ['VIZZINI', 'M100'],
      ['CASTEL DI IUDICA', 'C091'],
      ['PEDARA', 'G402'],
      ['SANTA VENERINA', 'I314'],
      ['MALETTO', 'E854'],
      ['RAMACCA', 'H168'],
      ['MILITELLO IN VAL DI CATANIA', 'F209'],
      ['VALVERDE', 'L658'],
      ['LICODIA EUBEA', 'E578'],
      ['MOTTA SANT\'ANASTASIA', 'F781'],
      ['VIAGRANDE', 'L828'],
      ['LINGUAGLOSSA', 'E602'],
      ['PATERNO\'', 'G371'],
      ['BIANCAVILLA', 'A841'],
      ['NICOLOSI', 'F890'],
      ['RIPOSTO', 'H325'],
      ['MISTERBIANCO', 'F250'],
      ['CAMPOROTONDO ETNEO', 'B561'],
      ['SANT\'ALFIO', 'I216'],
      ['PALAGONIA', 'G253'],
      ['GRAVINA DI CATANIA', 'E156'],
      ['CATANIA', 'C351'],
      ['BRONTE', 'B202'],
      ['CASTIGLIONE DI SICILIA', 'C297'],
      ['GRAMMICHELE', 'E133'],
      ['GIARRE', 'E017'],
      ['MAZZARRONE', 'M271'],
      ['ACI BONACCORSI', 'A025'],
      ['ACI CATENA', 'A027'],
      ['ACI CASTELLO', 'A026'],
      ['ACI SANT\'ANTONIO', 'A029'],
      ['ACIREALE', 'A028'],
      ['CALATABIANO', 'B384'],
      ['ZAFFERANA ETNEA', 'M139'],
      ['PIEDIMONTE ETNEO', 'G597'],
      ['MASCALI', 'F004'],
      ['SAN CONO', 'H805'],
      ['MASCALUCIA', 'F005'],
      ['SAN PIETRO CLARENZA', 'I098'],
      ['RANDAZZO', 'H175'],
      ['RADDUSA', 'H154'],
      ['FIUMEFREDDO DI SICILIA', 'D623'],
      ['MINEO', 'F217'],
      ['MILO', 'F214'],
      ['BELPASSO', 'A766'],
      ['MIRABELLA IMBACCARI', 'F231'],
      ['SCORDIA', 'I548'],
      ['SAN GIOVANNI LA PUNTA', 'H922'],
      ['SANT\'AGATA LI BATTIATI', 'I202'],
      ['SAN MICHELE DI GANZARIA', 'I035'],
      ['SAN GREGORIO DI CATANIA', 'H940'],
      ['SANTA MARIA DI LICODIA', 'I240'],
      ['CALTAGIRONE', 'B428'],
      ['TRECASTAGNI', 'L355'],
      ['MANIACE', 'M283'],
      ['RAGALNA', 'M287'],
      ['TREMESTIERI ETNEO', 'L369']
    ],
    CZ: [
      ['ALBI', 'A155'],
      ['CHIARAVALLE CENTRALE', 'C616'],
      ['SELLIA MARINA', 'I590'],
      ['SORBO SAN BASILE', 'I844'],
      ['DECOLLATURA', 'D261'],
      ['SAN SOSTENE', 'I164'],
      ['ZAGARISE', 'M140'],
      ['LAMEZIA TERME', 'M208'],
      ['FEROLETO ANTICO', 'D544'],
      ['PIANOPOLI', 'D546'],
      ['MIGLIERINA', 'F200'],
      ['SIMERI CRICHI', 'I745'],
      ['MARTIRANO LOMBARDO', 'E991'],
      ['MARTIRANO', 'E990'],
      ['MOTTA SANTA LUCIA', 'F780'],
      ['SOVERIA SIMERI', 'I875'],
      ['CARAFFA DI CATANZARO', 'B717'],
      ['SETTINGIANO', 'I704'],
      ['GASPERINA', 'D932'],
      ['MAIDA', 'E834'],
      ['BELCASTRO', 'A736'],
      ['STALETTI', 'I937'],
      ['AMATO', 'A257'],
      ['AMARONI', 'A255'],
      ['CARDINALE', 'B758'],
      ['NOCERA TERINESE', 'F910'],
      ['BORGIA', 'B002'],
      ['GAGLIATO', 'D852'],
      ['CONFLENTI', 'C960'],
      ['MONTEPAONE', 'F586'],
      ['SAN MANGO D\'AQUINO', 'H976'],
      ['ISCA SULLO IONIO', 'E328'],
      ['CARLOPOLI', 'B790'],
      ['PALERMITI', 'G272'],
      ['PETRIZZI', 'G517'],
      ['PETRONA\'', 'G518'],
      ['TORRE DI RUGGIERO', 'L240'],
      ['CATANZARO', 'C352'],
      ['GIRIFALCO', 'E050'],
      ['FOSSATO SERRALTA', 'D744'],
      ['ARGUSTO', 'A397'],
      ['MONTAURO', 'F432'],
      ['MARCELLINARA', 'E925'],
      ['MARCEDUSA', 'E923'],
      ['BOTRICELLO', 'B085'],
      ['OLIVADI', 'G034'],
      ['SANTA CATERINA DELLO IONIO', 'I170'],
      ['CENTRACHE', 'C472'],
      ['SOVERIA MANNELLI', 'I874'],
      ['SOVERATO', 'I872'],
      ['CENADI', 'C453'],
      ['CORTALE', 'D049'],
      ['GIMIGLIANO', 'E031'],
      ['ANDALI', 'A272'],
      ['SELLIA', 'I589'],
      ['PENTONE', 'G439'],
      ['CURINGA', 'D218'],
      ['SAN PIETRO APOSTOLO', 'I095'],
      ['SAN PIETRO A MAIDA', 'I093'],
      ['VALLEFIORITA', 'I322'],
      ['DAVOLI', 'D257'],
      ['SAN FLORO', 'H846'],
      ['BADOLATO', 'A542'],
      ['MAGISANO', 'E806'],
      ['SQUILLACE', 'I929'],
      ['TAVERNA', 'L070'],
      ['TIRIOLO', 'L177'],
      ['CERVA', 'C542'],
      ['PLATANIA', 'G734'],
      ['SERSALE', 'I671'],
      ['FALERNA', 'D476'],
      ['SERRASTRETTA', 'I655'],
      ['SANT\'ANDREA APOSTOLO DELLO IONIO', 'I266'],
      ['SATRIANO', 'I463'],
      ['JACURSO', 'E274'],
      ['CROPANI', 'D181'],
      ['GIZZERIA', 'E068'],
      ['SAN VITO SULLO IONIO', 'I393'],
      ['GUARDAVALLE', 'E239'],
      ['CICALA', 'C674']
    ],
    EN: [
      ['AGIRA', 'A070'],
      ['CERAMI', 'C480'],
      ['NICOSIA', 'F892'],
      ['ASSORO', 'A478'],
      ['REGALBUTO', 'H221'],
      ['TROINA', 'L448'],
      ['BARRAFRANCA', 'A676'],
      ['ENNA', 'C342'],
      ['SPERLINGA', 'I891'],
      ['CATENANUOVA', 'C353'],
      ['CENTURIPE', 'C471'],
      ['CALASCIBETTA', 'B381'],
      ['PIETRAPERZIA', 'G624'],
      ['VALGUARNERA CAROPEPE', 'L583'],
      ['GAGLIANO CASTELFERRATO', 'D849'],
      ['VILLAROSA', 'M011'],
      ['AIDONE', 'A098'],
      ['NISSORIA', 'F900'],
      ['LEONFORTE', 'E536'],
      ['PIAZZA ARMERINA', 'G580']
    ],
    FC: [
      ['VERGHERETO', 'L764'],
      ['MONTIANO', 'F668'],
      ['ROCCA SAN CASCIANO', 'H437'],
      ['SAN MAURO PASCOLI', 'I027'],
      ['SANTA SOFIA', 'I310'],
      ['BERTINORO', 'A809'],
      ['GATTEO', 'D935'],
      ['GAMBETTOLA', 'D899'],
      ['MELDOLA', 'F097'],
      ['BORGHI', 'B001'],
      ['CESENATICO', 'C574'],
      ['CESENA', 'C573'],
      ['MERCATO SARACENO', 'F139'],
      ['SAVIGNANO SUL RUBICONE', 'I472'],
      ['FORLIMPOPOLI', 'D705'],
      ['FORLI\'', 'D704'],
      ['PREDAPPIO', 'H017'],
      ['PREMILCUORE', 'H034'],
      ['CASTROCARO TERME E TERRA DEL SOLE', 'C339'],
      ['TREDOZIO', 'L361'],
      ['RONCOFREDDO', 'H542'],
      ['DOVADOLA', 'D357'],
      ['BAGNO DI ROMAGNA', 'A565'],
      ['SOGLIANO AL RUBICONE', 'I779'],
      ['LONGIANO', 'E675'],
      ['MODIGLIANA', 'F259'],
      ['PORTICO E SAN BENEDETTO', 'G904'],
      ['CIVITELLA DI ROMAGNA', 'C777'],
      ['GALEATA', 'D867'],
      ['SARSINA', 'I444']
    ],
    FE: [
      ['BERRA', 'A806'],
      ['VIGARANO MAINARDA', 'L868'],
      ['RO', 'H360'],
      ['MASI TORELLO', 'F016'],
      ['TRESIGALLO', 'L390'],
      ['MIGLIARINO', 'F198'],
      ['MIGLIARO', 'F199'],
      ['POGGIO RENATICO', 'G768'],
      ['PORTOMAGGIORE', 'G916'],
      ['COPPARO', 'C980'],
      ['MESOLA', 'F156'],
      ['BONDENO', 'A965'],
      ['ARGENTA', 'A393'],
      ['FERRARA', 'D548'],
      ['VOGHIERA', 'M110'],
      ['LAGOSANTO', 'E410'],
      ['MASSA FISCAGLIA', 'F026'],
      ['OSTELLATO', 'G184'],
      ['MIRABELLO', 'F235'],
      ['COMACCHIO', 'C912'],
      ['GORO', 'E107'],
      ['SANT\'AGOSTINO', 'I209'],
      ['FORMIGNANA', 'D713'],
      ['CODIGORO', 'C814'],
      ['CENTO', 'C469'],
      ['JOLANDA DI SAVOIA', 'E320']
    ],
    FG: [
      ['ALBERONA', 'A150'],
      ['RIGNANO GARGANICO', 'H287'],
      ['MATTINATA', 'F059'],
      ['CANDELA', 'B584'],
      ['CELENZA VALFORTORE', 'C429'],
      ['CAGNANO VARANO', 'B357'],
      ['CELLE SAN VITO', 'C442'],
      ['DELICETO', 'D269'],
      ['MANFREDONIA', 'E885'],
      ['TORREMAGGIORE', 'L273'],
      ['SAN FERDINANDO DI PUGLIA', 'H839'],
      ['PANNI', 'G312'],
      ['CASTELLUCCIO DEI SAURI', 'C198'],
      ['POGGIO IMPERIALE', 'G761'],
      ['PESCHICI', 'G487'],
      ['ISOLE TREMITI', 'E363'],
      ['VICO DEL GARGANO', 'L842'],
      ['TROIA', 'L447'],
      ['TRINITAPOLI', 'B915'],
      ['CASALVECCHIO DI PUGLIA', 'B917'],
      ['MARGHERITA DI SAVOIA', 'E946'],
      ['APRICENA', 'A339'],
      ['ORTA NOVA', 'G131'],
      ['LESINA', 'E549'],
      ['CHIEUTI', 'C633'],
      ['SERRACAPRIOLA', 'I641'],
      ['CERIGNOLA', 'C514'],
      ['ROCCHETTA SANT\'ANTONIO', 'H467'],
      ['LUCERA', 'E716'],
      ['SAN SEVERO', 'I158'],
      ['VOLTURINO', 'M132'],
      ['VOLTURARA APPULA', 'M131'],
      ['SANT\'AGATA DI PUGLIA', 'I193'],
      ['SANNICANDRO GARGANICO', 'I054'],
      ['BOVINO', 'B104'],
      ['PIETRAMONTECORVINO', 'G604'],
      ['CARPINO', 'B829'],
      ['SAN PAOLO DI CIVITATE', 'I072'],
      ['VIESTE', 'L858'],
      ['ROSETO VALFORTORE', 'H568'],
      ['MONTE SANT\'ANGELO', 'F631'],
      ['FOGGIA', 'D643'],
      ['RODI GARGANICO', 'H480'],
      ['STORNARA', 'I962'],
      ['STORNARELLA', 'I963'],
      ['MOTTA MONTECORVINO', 'F777'],
      ['CARAPELLE', 'B724'],
      ['MONTELEONE DI PUGLIA', 'F538'],
      ['CASTELLUCCIO VALMAGGIORE', 'C202'],
      ['BICCARI', 'A854'],
      ['SAN GIOVANNI ROTONDO', 'H926'],
      ['ASCOLI SATRIANO', 'A463'],
      ['ANZANO DI PUGLIA', 'A320'],
      ['FAETO', 'D459'],
      ['ORSARA DI PUGLIA', 'G125'],
      ['CASALNUOVO MONTEROTARO', 'B904'],
      ['ISCHITELLA', 'E332'],
      ['CARLANTINO', 'B784'],
      ['CASTELNUOVO DELLA DAUNIA', 'C222'],
      ['ACCADIA', 'A015'],
      ['SAN MARCO IN LAMIS', 'H985'],
      ['SAN MARCO LA CATOLA', 'H986'],
      ['ZAPPONETA', 'M267'],
      ['ORDONA', 'M266']
    ],
    FI: [
      ['MARRADI', 'E971'],
      ['PELAGO', 'G420'],
      ['TAVARNELLE VAL DI PESA', 'L067'],
      ['SAN PIERO A SIEVE', 'I085'],
      ['INCISA IN VAL D\'ARNO', 'E296'],
      ['IMPRUNETA', 'E291'],
      ['LASTRA A SIGNA', 'E466'],
      ['CAMPI BISENZIO', 'B507'],
      ['RIGNANO SULL\'ARNO', 'H286'],
      ['SCARPERIA', 'I514'],
      ['FIRENZUOLA', 'D613'],
      ['FIRENZE', 'D612'],
      ['LONDA', 'E668'],
      ['EMPOLI', 'D403'],
      ['GAMBASSI TERME', 'D895'],
      ['SIGNA', 'I728'],
      ['SAN GODENZO', 'H937'],
      ['FUCECCHIO', 'D815'],
      ['REGGELLO', 'H222'],
      ['FIGLINE VALDARNO', 'D583'],
      ['PALAZZUOLO SUL SENIO', 'G270'],
      ['BARBERINO DI MUGELLO', 'A632'],
      ['BARBERINO VAL D\'ELSA', 'A633'],
      ['DICOMANO', 'D299'],
      ['VAGLIA', 'L529'],
      ['MONTELUPO FIORENTINO', 'F551'],
      ['CASTELFIORENTINO', 'C101'],
      ['SAN CASCIANO IN VAL DI PESA', 'H791'],
      ['RUFINA', 'H635'],
      ['SESTO FIORENTINO', 'I684'],
      ['CAPRAIA E LIMITE', 'B684'],
      ['VINCI', 'M059'],
      ['VICCHIO', 'L838'],
      ['CALENZANO', 'B406'],
      ['BAGNO A RIPOLI', 'A564'],
      ['CERTALDO', 'C540'],
      ['SCANDICCI', 'B962'],
      ['BORGO SAN LORENZO', 'B036'],
      ['GREVE IN CHIANTI', 'E169'],
      ['CERRETO GUIDI', 'C529'],
      ['PONTASSIEVE', 'G825'],
      ['FIESOLE', 'D575'],
      ['MONTESPERTOLI', 'F648'],
      ['MONTAIONE', 'F398']
    ],
    FM: [
      ['ALTIDONA', 'A233'],
      ['AMANDOLA', 'A252'],
      ['BELMONTE PICENO', 'A760'],
      ['CAMPOFILONE', 'B534'],
      ['FALERONE', 'D477'],
      ['FERMO', 'D542'],
      ['FRANCAVILLA D\'ETE', 'D760'],
      ['GROTTAZZOLINA', 'E208'],
      ['LAPEDONA', 'E447'],
      ['MAGLIANO DI TENNA', 'E807'],
      ['MASSA FERMANA', 'F021'],
      ['MONSAMPIETRO MORICO', 'F379'],
      ['MONTAPPONE', 'F428'],
      ['MONTE GIBERTO', 'F517'],
      ['MONTE RINALDO', 'F599'],
      ['MONTE SAN PIETRANGELI', 'F626'],
      ['MONTE URANO', 'F653'],
      ['MONTE VIDON COMBATTE', 'F664'],
      ['MONTE VIDON CORRADO', 'F665'],
      ['MONTEFALCONE APPENNINO', 'F493'],
      ['MONTEFORTINO', 'F509'],
      ['MONTEGIORGIO', 'F520'],
      ['MONTEGRANARO', 'F522'],
      ['MONTELEONE DI FERMO', 'F536'],
      ['MONTELPARO', 'F549'],
      ['MONTERUBBIANO', 'F614'],
      ['MONTOTTONE', 'F697'],
      ['MORESCO', 'F722'],
      ['ORTEZZANO', 'G137'],
      ['PEDASO', 'G403'],
      ['PETRITOLI', 'G516'],
      ['PONZANO DI FERMO', 'G873'],
      ['PORTO SAN GIORGIO', 'G920'],
      ['PORTO SANT\'ELPIDIO', 'G921'],
      ['RAPAGNANO', 'H182'],
      ['SANTA VITTORIA IN MATENANO', 'I315'],
      ['SANT\'ELPIDIO A MARE', 'I324'],
      ['SERVIGLIANO', 'C070'],
      ['SMERILLO', 'I774'],
      ['TORRE SAN PATRIZIO', 'L279']
    ],
    FR: [
      ['ACUTO', 'A054'],
      ['VICALVI', 'L836'],
      ['ANAGNI', 'A269'],
      ['SETTEFRATI', 'I697'],
      ['VALLECORSA', 'L598'],
      ['FALVATERRA', 'D483'],
      ['MONTE SAN GIOVANNI CAMPANO', 'F620'],
      ['CASTELLIRI', 'C177'],
      ['SUPINO', 'L009'],
      ['TREVI NEL LAZIO', 'L398'],
      ['BROCCOSTELLA', 'B195'],
      ['SANTOPADRE', 'I351'],
      ['CASSINO', 'C034'],
      ['STRANGOLAGALLI', 'I973'],
      ['ALATRI', 'A123'],
      ['VALLEROTONDA', 'L614'],
      ['ROCCADARCE', 'H393'],
      ['MOROLO', 'F740'],
      ['PATRICA', 'G374'],
      ['ISOLA DEL LIRI', 'E340'],
      ['POFI', 'G749'],
      ['CAMPOLI APPENNINO', 'B543'],
      ['VICO NEL LAZIO', 'L843'],
      ['FIUGGI', 'A310'],
      ['ESPERIA', 'D440'],
      ['SAN GIOVANNI INCARICO', 'H917'],
      ['CASALVIERI', 'B919'],
      ['POSTA FIBRENO', 'G935'],
      ['VILLA LATINA', 'A081'],
      ['SERRONE', 'I669'],
      ['ARPINO', 'A433'],
      ['VILLA SANTA LUCIA', 'L905'],
      ['PALIANO', 'G276'],
      ['SANT\'AMBROGIO SUL GARIGLIANO', 'I256'],
      ['ALVITO', 'A244'],
      ['TORRE CAJETANI', 'L243'],
      ['TERELLE', 'L105'],
      ['CECCANO', 'C413'],
      ['FROSINONE', 'D810'],
      ['FUMONE', 'D819'],
      ['VITICUSO', 'M083'],
      ['GIULIANO DI ROMA', 'E057'],
      ['ROCCASECCA', 'H443'],
      ['PONTECORVO', 'G838'],
      ['CASTRO DEI VOLSCI', 'C338'],
      ['CEPRANO', 'C479'],
      ['COLLEPARDO', 'C864'],
      ['SORA', 'I838'],
      ['PIEDIMONTE SAN GERMANO', 'G598'],
      ['PICO', 'G592'],
      ['PICINISCO', 'G591'],
      ['GUARCINO', 'E236'],
      ['FONTECHIARI', 'D682'],
      ['AMASENO', 'A256'],
      ['FONTANA LIRI', 'D667'],
      ['AUSONIA', 'A502'],
      ['SANT\'APOLLINARE', 'I302'],
      ['PIGLIO', 'G659'],
      ['SAN DONATO VAL DI COMINO', 'H824'],
      ['SAN BIAGIO SARACINISCO', 'H779'],
      ['SANT\'ELIA FIUMERAPIDO', 'I321'],
      ['CASALATTICO', 'B862'],
      ['BELMONTE CASTELLO', 'A763'],
      ['PIGNATARO INTERAMNA', 'G662'],
      ['CASTELNUOVO PARANO', 'C223'],
      ['VALLEMAIO', 'L605'],
      ['RIPI', 'H324'],
      ['VILLA SANTO STEFANO', 'I364'],
      ['PASTENA', 'G362'],
      ['FILETTINO', 'D591'],
      ['GALLINARO', 'D881'],
      ['SGURGOLA', 'I716'],
      ['SAN GIORGIO A LIRI', 'H880'],
      ['BOVILLE ERNICA', 'A720'],
      ['VEROLI', 'L780'],
      ['TRIVIGLIANO', 'L437'],
      ['CERVARO', 'C545'],
      ['AQUINO', 'A348'],
      ['SANT\'ANDREA DEL GARIGLIANO', 'I265'],
      ['ARNARA', 'A421'],
      ['PESCOSOLIDO', 'G500'],
      ['ARCE', 'A363'],
      ['CORENO AUSONIO', 'C998'],
      ['CASTROCIELO', 'C340'],
      ['COLFELICE', 'C836'],
      ['SAN VITTORE DEL LAZIO', 'I408'],
      ['FERENTINO', 'D539'],
      ['ATINA', 'A486'],
      ['TORRICE', 'L290'],
      ['COLLE SAN MAGNO', 'C870'],
      ['ACQUAFONDATA', 'A032']
    ],
    GE: [
      ['MONTEBRUNO', 'F445'],
      ['VOBBIA', 'M105'],
      ['BORZONASCA', 'B067'],
      ['SESTRI LEVANTE', 'I693'],
      ['LORSICA', 'E695'],
      ['FONTANIGORDA', 'D677'],
      ['MIGNANEGO', 'F202'],
      ['RONCO SCRIVIA', 'H536'],
      ['ZOAGLI', 'M182'],
      ['CROCEFIESCHI', 'D175'],
      ['LAVAGNA', 'E488'],
      ['CERANESI', 'C481'],
      ['CASELLA', 'B956'],
      ['MELE', 'F098'],
      ['TIGLIETO', 'L167'],
      ['BUSALLA', 'B282'],
      ['PORTOFINO', 'G913'],
      ['NE', 'F858'],
      ['BARGAGLI', 'A658'],
      ['ROVEGNO', 'H599'],
      ['CASARZA LIGURE', 'B939'],
      ['SAVIGNONE', 'I475'],
      ['ORERO', 'G093'],
      ['SERRA RICCO\'', 'I640'],
      ['ISOLA DEL CANTONE', 'E341'],
      ['COGORNO', 'C826'],
      ['COGOLETO', 'C823'],
      ['MEZZANEGO', 'F173'],
      ['FASCIA', 'D509'],
      ['USCIO', 'L507'],
      ['BOGLIASCO', 'A922'],
      ['MONEGLIA', 'F354'],
      ['PROPATA', 'H073'],
      ['LUMARZO', 'E737'],
      ['VALBREVENNA', 'L546'],
      ['SORI', 'I852'],
      ['MASONE', 'F020'],
      ['SAN COLOMBANO CERTENOLI', 'H802'],
      ['CHIAVARI', 'C621'],
      ['AVEGNO', 'A506'],
      ['NEIRONE', 'F862'],
      ['PIEVE LIGURE', 'G646'],
      ['DAVAGNA', 'D255'],
      ['RONDANINA', 'H546'],
      ['CAMOGLI', 'B490'],
      ['SANT\'OLCESE', 'I346'],
      ['CARASCO', 'B726'],
      ['SANTO STEFANO D\'AVETO', 'I368'],
      ['CAMPO LIGURE', 'B538'],
      ['MOCONESI', 'F256'],
      ['CAMPOMORONE', 'B551'],
      ['TORRIGLIA', 'L298'],
      ['TRIBOGNA', 'L416'],
      ['GORRETO', 'E109'],
      ['REZZOAGLIO', 'H258'],
      ['SANTA MARGHERITA LIGURE', 'I225'],
      ['RECCO', 'H212'],
      ['ROSSIGLIONE', 'H581'],
      ['COREGLIA LIGURE', 'C995'],
      ['ARENZANO', 'A388'],
      ['MONTOGGIO', 'F682'],
      ['LEIVI', 'E519'],
      ['FAVALE DI MALVARO', 'D512'],
      ['RAPALLO', 'H183'],
      ['CASTIGLIONE CHIAVARESE', 'C302'],
      ['GENOVA', 'D969'],
      ['CICAGNA', 'C673']
    ],
    GO: [
      ['SAN CANZIAN D\'ISONZO', 'H787'],
      ['SAN LORENZO ISONTINO', 'H964'],
      ['MARIANO DEL FRIULI', 'E952'],
      ['CORMONS', 'D014'],
      ['SAN PIER D\'ISONZO', 'I082'],
      ['RONCHI DEI LEGIONARI', 'H531'],
      ['MOSSA', 'F767'],
      ['VILLESSE', 'M043'],
      ['ROMANS D\'ISONZO', 'H514'],
      ['CAPRIVA DEL FRIULI', 'B712'],
      ['STARANZANO', 'I939'],
      ['DOLEGNA DEL COLLIO', 'D321'],
      ['GORIZIA', 'E098'],
      ['SAVOGNA D\'ISONZO', 'I479'],
      ['FARRA D\'ISONZO', 'D504'],
      ['FOGLIANO REDIPUGLIA', 'D645'],
      ['SAN FLORIANO DEL COLLIO', 'H845'],
      ['GRADISCA D\'ISONZO', 'E124'],
      ['GRADO', 'E125'],
      ['MEDEA', 'F081'],
      ['DOBERDO\' DEL LAGO', 'D312'],
      ['MORARO', 'F710'],
      ['TURRIACO', 'L474'],
      ['MONFALCONE', 'F356'],
      ['SAGRADO', 'H665']
    ],
    GR: [
      ['GAVORRANO', 'D948'],
      ['SORANO', 'I841'],
      ['MASSA MARITTIMA', 'F032'],
      ['MANCIANO', 'E875'],
      ['CIVITELLA PAGANICO', 'C782'],
      ['SCARLINO', 'I510'],
      ['MAGLIANO IN TOSCANA', 'E810'],
      ['SEGGIANO', 'I571'],
      ['ISOLA DEL GIGLIO', 'E348'],
      ['ROCCASTRADA', 'H449'],
      ['SEMPRONIANO', 'I601'],
      ['CASTIGLIONE DELLA PESCAIA', 'C310'],
      ['GROSSETO', 'E202'],
      ['MONTIERI', 'F677'],
      ['CAPALBIO', 'B646'],
      ['CASTELL\'AZZARA', 'C147'],
      ['MONTEROTONDO MARITTIMO', 'F612'],
      ['MONTE ARGENTARIO', 'F437'],
      ['CASTEL DEL PIANO', 'C085'],
      ['CAMPAGNATICO', 'B497'],
      ['SCANSANO', 'I504'],
      ['FOLLONICA', 'D656'],
      ['PITIGLIANO', 'G716'],
      ['CINIGIANO', 'C705'],
      ['ORBETELLO', 'G088'],
      ['ARCIDOSSO', 'A369'],
      ['SANTA FIORA', 'I187'],
      ['ROCCALBEGNA', 'H417']
    ],
    IM: [
      ['CASTEL VITTORIO', 'C110'],
      ['SAN BIAGIO DELLA CIMA', 'H780'],
      ['PIEVE DI TECO', 'G632'],
      ['VALLECROSIA', 'L599'],
      ['VALLEBONA', 'L596'],
      ['CARPASIO', 'B814'],
      ['SAN BARTOLOMEO AL MARE', 'H763'],
      ['IMPERIA', 'E290'],
      ['CARAVONICA', 'B734'],
      ['TAGGIA', 'L024'],
      ['BORDIGHERA', 'A984'],
      ['MONTEGROSSO PIAN LATTE', 'F528'],
      ['SEBORGA', 'I556'],
      ['BORGOMARO', 'B020'],
      ['VILLA FARALDI', 'L943'],
      ['RIVA LIGURE', 'H328'],
      ['COSTARAINERA', 'D114'],
      ['ARMO', 'A418'],
      ['TERZORIO', 'L146'],
      ['APRICALE', 'A338'],
      ['CESIO', 'C578'],
      ['BAIARDO', 'A581'],
      ['VASIA', 'L693'],
      ['SAN LORENZO AL MARE', 'H957'],
      ['BADALUCCO', 'A536'],
      ['CERIANA', 'C511'],
      ['ISOLABONA', 'E346'],
      ['DIANO SAN PIETRO', 'D298'],
      ['DIANO MARINA', 'D297'],
      ['DIANO ARENTINO', 'D293'],
      ['CERVO', 'C559'],
      ['AIROLE', 'A111'],
      ['AURIGO', 'A499'],
      ['ROCCHETTA NERVINA', 'H460'],
      ['LUCINASCO', 'E719'],
      ['POMPEIANA', 'G814'],
      ['DIANO CASTELLO', 'D296'],
      ['PONTEDASSIO', 'G840'],
      ['CHIUSAVECCHIA', 'C660'],
      ['SAN REMO', 'I138'],
      ['PIETRABRUNA', 'G607'],
      ['CASTELLARO', 'C143'],
      ['PORNASSIO', 'G890'],
      ['PERINALDO', 'G454'],
      ['PIGNA', 'G660'],
      ['VESSALICO', 'L809'],
      ['SANTO STEFANO AL MARE', 'I365'],
      ['COSIO D\'ARROSCIA', 'D087'],
      ['CHIUSANICO', 'C657'],
      ['CAMPOROSSO', 'B559'],
      ['OSPEDALETTI', 'G164'],
      ['DOLCEACQUA', 'D318'],
      ['DOLCEDO', 'D319'],
      ['REZZO', 'H257'],
      ['TRIORA', 'L430'],
      ['MOLINI DI TRIORA', 'F290'],
      ['CIPRESSA', 'C718'],
      ['AQUILA D\'ARROSCIA', 'A344'],
      ['MENDATICA', 'F123'],
      ['SOLDANO', 'I796'],
      ['BORGHETTO D\'ARROSCIA', 'A993'],
      ['PRELA\'', 'H027'],
      ['CIVEZZA', 'C755'],
      ['OLIVETTA SAN MICHELE', 'G041'],
      ['MONTALTO LIGURE', 'F406'],
      ['RANZO', 'H180'],
      ['VENTIMIGLIA', 'L741']
    ],
    IS: [
      ['ACQUAVIVA D\'ISERNIA', 'A051'],
      ['CANTALUPO NEL SANNIO', 'B630'],
      ['MONTERODUNI', 'F601'],
      ['CARPINONE', 'B830'],
      ['CAROVILLI', 'B810'],
      ['POGGIO SANNITA', 'B317'],
      ['POZZILLI', 'G954'],
      ['CASTEL SAN VINCENZO', 'C270'],
      ['LONGANO', 'E669'],
      ['PESCHE', 'G486'],
      ['RIONERO SANNITICO', 'H308'],
      ['SANTA MARIA DEL MOLISE', 'I238'],
      ['PIZZONE', 'G727'],
      ['CONCA CASALE', 'C941'],
      ['AGNONE', 'A080'],
      ['MONTENERO VAL COCCHIARA', 'F580'],
      ['VASTOGIRARDI', 'L696'],
      ['FORLI\' DEL SANNIO', 'D703'],
      ['CIVITANOVA DEL SANNIO', 'C769'],
      ['FROSOLONE', 'D811'],
      ['CERRO AL VOLTURNO', 'C534'],
      ['ROCCASICURA', 'H445'],
      ['ISERNIA', 'E335'],
      ['ROCCAMANDOLFI', 'H420'],
      ['PIETRABBONDANTE', 'G606'],
      ['MACCHIAGODENA', 'E779'],
      ['MACCHIA D\'ISERNIA', 'E778'],
      ['SESTO CAMPANO', 'I682'],
      ['CHIAUCI', 'C620'],
      ['CASTEL DEL GIUDICE', 'C082'],
      ['SAN PIETRO AVELLANA', 'I096'],
      ['CASTELVERRINO', 'C200'],
      ['CAPRACOTTA', 'B682'],
      ['BELMONTE DEL SANNIO', 'A761'],
      ['SCAPOLI', 'I507'],
      ['VENAFRO', 'L725'],
      ['SANT\'ANGELO DEL PESCO', 'I282'],
      ['MIRANDA', 'F239'],
      ['BAGNOLI DEL TRIGNO', 'A567'],
      ['CASTELPIZZUTO', 'C247'],
      ['CASTELPETROSO', 'C246'],
      ['PESCOPENNATARO', 'G497'],
      ['PESCOLANCIANO', 'G495'],
      ['FILIGNANO', 'D595'],
      ['SESSANO DEL MOLISE', 'I679'],
      ['FORNELLI', 'D715'],
      ['SANT\'ELENA SANNITA', 'B466'],
      ['PETTORANELLO DEL MOLISE', 'G523'],
      ['SANT\'AGAPITO', 'I189'],
      ['MONTAQUILA', 'F429'],
      ['ROCCHETTA A VOLTURNO', 'H458'],
      ['COLLI A VOLTURNO', 'C878']
    ],
    KR: [
      ['SAN MAURO MARCHESATO', 'I026'],
      ['CERENZIA', 'C501'],
      ['VERZINO', 'L802'],
      ['CACCURI', 'B319'],
      ['SAVELLI', 'I468'],
      ['BELVEDERE DI SPINELLO', 'A772'],
      ['CASABONA', 'B857'],
      ['SCANDALE', 'I494'],
      ['CIRO\' MARINA', 'C726'],
      ['ROCCABERNARDA', 'H383'],
      ['PALLAGORIO', 'G278'],
      ['MESORACA', 'F157'],
      ['CARFIZZI', 'B771'],
      ['CUTRO', 'D236'],
      ['SAN NICOLA DELL\'ALTO', 'I057'],
      ['ROCCA DI NETO', 'H403'],
      ['SANTA SEVERINA', 'I308'],
      ['CIRO\'', 'C725'],
      ['COTRONEI', 'D123'],
      ['CROTONE', 'D122'],
      ['CASTELSILANO', 'B968'],
      ['MELISSA', 'F108'],
      ['PETILIA POLICASTRO', 'G508'],
      ['ISOLA DI CAPO RIZZUTO', 'E339'],
      ['UMBRIATICO', 'L492'],
      ['STRONGOLI', 'I982'],
      ['CRUCOLI', 'D189']
    ],
    LC: [
      ['OGGIONO', 'G009'],
      ['VIGANO\'', 'L866'],
      ['MALGRATE', 'E858'],
      ['MONTE MARENZO', 'F561'],
      ['PARLASCO', 'G336'],
      ['PEREGO', 'G448'],
      ['MANDELLO DEL LARIO', 'E879'],
      ['CASSAGO BRIANZA', 'B996'],
      ['BRIVIO', 'B194'],
      ['VALMADRERA', 'L634'],
      ['SIRTORI', 'I761'],
      ['TACENO', 'L022'],
      ['DORIO', 'D346'],
      ['MISSAGLIA', 'F248'],
      ['PESCATE', 'G485'],
      ['MOGGIO', 'F265'],
      ['ERVE', 'D428'],
      ['CRANDOLA VALSASSINA', 'D131'],
      ['LIERNA', 'E581'],
      ['COSTA MASNAGA', 'D112'],
      ['INTROZZO', 'E308'],
      ['INTROBIO', 'E305'],
      ['DOLZAGO', 'D327'],
      ['MARGNO', 'E947'],
      ['GARLATE', 'D926'],
      ['ROVAGNATE', 'H596'],
      ['CASARGO', 'B937'],
      ['MERATE', 'F133'],
      ['LOMAGNA', 'E656'],
      ['CASTELLO DI BRIANZA', 'C187'],
      ['MOLTENO', 'F304'],
      ['NIBIONNO', 'F887'],
      ['BULCIAGO', 'B261'],
      ['PADERNO D\'ADDA', 'G218'],
      ['LECCO', 'E507'],
      ['CREMELLA', 'D143'],
      ['SUEGLIO', 'I994'],
      ['SUELLO', 'I996'],
      ['VENDROGNO', 'L731'],
      ['AIRUNO', 'A112'],
      ['GARBAGNATE MONASTERO', 'D913'],
      ['BALLABIO', 'A594'],
      ['ELLO', 'D398'],
      ['BOSISIO PARINI', 'B081'],
      ['ABBADIA LARIANA', 'A005'],
      ['OLGINATE', 'G030'],
      ['VERCURAGO', 'L751'],
      ['VERDERIO INFERIORE', 'L755'],
      ['VERDERIO SUPERIORE', 'L756'],
      ['MONTEVECCHIA', 'F657'],
      ['MONTICELLO BRIANZA', 'F674'],
      ['CORTENOVA', 'D065'],
      ['VALGREGHENTINO', 'L581'],
      ['BELLANO', 'A745'],
      ['ROGENO', 'H486'],
      ['VESTRENO', 'L813'],
      ['PERLEDO', 'G456'],
      ['SIRONE', 'I759'],
      ['IMBERSAGO', 'E287'],
      ['CASSINA VALSASSINA', 'C024'],
      ['MORTERONE', 'F758'],
      ['PASTURO', 'G368'],
      ['CREMENO', 'D145'],
      ['OSNAGO', 'G161'],
      ['CASATENOVO', 'B943'],
      ['CARENNO', 'B763'],
      ['ANNONE DI BRIANZA', 'A301'],
      ['ESINO LARIO', 'D436'],
      ['BARZAGO', 'A683'],
      ['BARZIO', 'A687'],
      ['BARZANO\'', 'A686'],
      ['CESANA BRIANZA', 'C563'],
      ['VARENNA', 'L680'],
      ['GALBIATE', 'D865'],
      ['PAGNONA', 'G241'],
      ['SANTA MARIA HOE\'', 'I243'],
      ['CERNUSCO LOMBARDONE', 'C521'],
      ['TORRE DE\' BUSI', 'L257'],
      ['COLICO', 'C839'],
      ['PREMANA', 'H028'],
      ['DERVIO', 'D280'],
      ['CIVATE', 'C752'],
      ['CALOLZIOCORTE', 'B423'],
      ['OLIVETO LARIO', 'G040'],
      ['ROBBIATE', 'G223'],
      ['TREMENICO', 'L368'],
      ['PRIMALUNA', 'H063'],
      ['OLGIATE MOLGORA', 'G026'],
      ['CALCO', 'B396'],
      ['COLLE BRIANZA', 'C851']
    ],
    LE: [
      ['CANNOLE', 'B616'],
      ['MARTANO', 'E979'],
      ['MATINO', 'F054'],
      ['PALMARIGGI', 'G285'],
      ['MONTERONI DI LECCE', 'F604'],
      ['MONTESANO SALENTINO', 'F623'],
      ['SPECCHIA', 'I887'],
      ['TAURISANO', 'L064'],
      ['BAGNOLO DEL SALENTO', 'A572'],
      ['ANDRANO', 'A281'],
      ['LIZZANELLO', 'E629'],
      ['SUPERSANO', 'L008'],
      ['CAPRARICA DI LECCE', 'B690'],
      ['RACALE', 'H147'],
      ['MIGGIANO', 'F194'],
      ['MINERVINO DI LECCE', 'F221'],
      ['SALICE SALENTINO', 'H708'],
      ['CAMPI SALENTINA', 'B506'],
      ['MAGLIE', 'E815'],
      ['CAVALLINO', 'C377'],
      ['SALVE', 'H729'],
      ['STERNATIA', 'I950'],
      ['PATU\'', 'G378'],
      ['SQUINZANO', 'I930'],
      ['SECLI\'', 'I559'],
      ['DISO', 'D305'],
      ['TIGGIANO', 'L166'],
      ['GALLIPOLI', 'D883'],
      ['NOCIGLIA', 'F916'],
      ['MELPIGNANO', 'F117'],
      ['TUGLIE', 'L462'],
      ['ORTELLE', 'G136'],
      ['ZOLLINO', 'M187'],
      ['CASARANO', 'B936'],
      ['CARMIANO', 'B792'],
      ['SOGLIANO CAVOUR', 'I780'],
      ['ARADEO', 'A350'],
      ['UGENTO', 'L484'],
      ['UGGIANO LA CHIESA', 'L485'],
      ['ALESSANO', 'A184'],
      ['ALEZIO', 'A185'],
      ['NEVIANO', 'F881'],
      ['NOVOLI', 'F970'],
      ['MURO LECCESE', 'F816'],
      ['VEGLIE', 'L711'],
      ['LECCE', 'E506'],
      ['GIUGGIANELLO', 'E053'],
      ['CASTRIGNANO DEL CAPO', 'C336'],
      ['CASTRIGNANO DE\' GRECI', 'C335'],
      ['CASTRI DI LECCE', 'C334'],
      ['BOTRUGNO', 'B086'],
      ['CALIMERA', 'B413'],
      ['SANARICA', 'H757'],
      ['COLLEPASSO', 'C865'],
      ['GUAGNANO', 'E227'],
      ['VERNOLE', 'L776'],
      ['CORSANO', 'D044'],
      ['SAN CESARIO DI LECCE', 'H793'],
      ['RUFFANO', 'H632'],
      ['CUTROFIANO', 'D237'],
      ['SANNICOLA', 'I059'],
      ['ACQUARICA DEL CAPO', 'A042'],
      ['CARPIGNANO SALENTINO', 'B822'],
      ['SAN PIETRO IN LAMA', 'I115'],
      ['CORIGLIANO D\'OTRANTO', 'D006'],
      ['SAN DONATO DI LECCE', 'H826'],
      ['MARTIGNANO', 'E984'],
      ['OTRANTO', 'G188'],
      ['PARABITA', 'G325'],
      ['SURBO', 'L011'],
      ['SURANO', 'L010'],
      ['LEVERANO', 'E563'],
      ['TREPUZZI', 'L383'],
      ['SPONGANO', 'I923'],
      ['SANTA CESAREA TERME', 'I172'],
      ['SCORRANO', 'I549'],
      ['TRICASE', 'L419'],
      ['POGGIARDO', 'G751'],
      ['MORCIANO DI LEUCA', 'F716'],
      ['NARDO\'', 'F842'],
      ['GAGLIANO DEL CAPO', 'D851'],
      ['MELISSANO', 'F109'],
      ['MELENDUGNO', 'F101'],
      ['GALATONE', 'D863'],
      ['COPERTINO', 'C978'],
      ['ARNESANO', 'A425'],
      ['LEQUILE', 'E538'],
      ['GALATINA', 'D862'],
      ['PRESICCE', 'H047'],
      ['TAVIANO', 'L074'],
      ['GIURDIGNANO', 'E061'],
      ['SOLETO', 'I800'],
      ['SAN CASSIANO', 'M264'],
      ['PORTO CESAREO', 'M263'],
      ['CASTRO', 'M261'],
      ['ALLISTE', 'A208'],
      ['CURSI', 'D223']
    ],
    LI: [
      ['PORTO AZZURRO', 'E680'],
      ['ROSIGNANO MARITTIMO', 'H570'],
      ['LIVORNO', 'E625'],
      ['CAMPIGLIA MARITTIMA', 'B509'],
      ['PORTOFERRAIO', 'G912'],
      ['RIO MARINA', 'H305'],
      ['CASTAGNETO CARDUCCI', 'C044'],
      ['CECINA', 'C415'],
      ['PIOMBINO', 'G687'],
      ['COLLESALVETTI', 'C869'],
      ['CAPOLIVERI', 'B669'],
      ['CAPRAIA ISOLA', 'B685'],
      ['SUVERETO', 'L019'],
      ['RIO NELL\'ELBA', 'H297'],
      ['BIBBONA', 'A852'],
      ['CAMPO NELL\'ELBA', 'B553'],
      ['SAN VINCENZO', 'I390'],
      ['SASSETTA', 'I454'],
      ['MARCIANA MARINA', 'E931'],
      ['MARCIANA', 'E930']
    ],
    LO: [
      ['BOFFALORA D\'ADDA', 'A919'],
      ['SORDIO', 'I848'],
      ['MALEO', 'E852'],
      ['LIVRAGA', 'E627'],
      ['MARUDO', 'E994'],
      ['SALERANO SUL LAMBRO', 'H701'],
      ['CASELLE LURANI', 'B958'],
      ['LODI', 'E648'],
      ['OSSAGO LODIGIANO', 'G171'],
      ['CERVIGNANO D\'ADDA', 'C555'],
      ['CASALPUSTERLENGO', 'B910'],
      ['CRESPIATICA', 'D159'],
      ['TURANO LODIGIANO', 'L469'],
      ['TERRANOVA DEI PASSERINI', 'L125'],
      ['GRAFFIGNANA', 'E127'],
      ['PIEVE FISSIRAGA', 'G096'],
      ['CAMAIRAGO', 'B456'],
      ['TAVAZZANO CON VILLAVESCO', 'F260'],
      ['CASALETTO LODIGIANO', 'B887'],
      ['ABBADIA CERRETO', 'A004'],
      ['MONTANASO LOMBARDO', 'F423'],
      ['SOMAGLIA', 'I815'],
      ['CORTE PALASIO', 'D068'],
      ['MASSALENGO', 'F028'],
      ['MACCASTORNA', 'E777'],
      ['FOMBIO', 'D660'],
      ['CORNEGLIANO LAUDENSE', 'D021'],
      ['CORNO GIOVINE', 'D028'],
      ['CORNOVECCHIO', 'D029'],
      ['ZELO BUON PERSICO', 'M158'],
      ['MAIRAGO', 'E840'],
      ['SAN FIORANO', 'H844'],
      ['BERTONICO', 'A811'],
      ['CASTELNUOVO BOCCA D\'ADDA', 'C228'],
      ['SANTO STEFANO LODIGIANO', 'I362'],
      ['SECUGNAGO', 'I561'],
      ['CASTIGLIONE D\'ADDA', 'C304'],
      ['VILLANOVA DEL SILLARO', 'L977'],
      ['LODI VECCHIO', 'E651'],
      ['COMAZZO', 'C917'],
      ['OSPEDALETTO LODIGIANO', 'G166'],
      ['ORIO LITTA', 'G107'],
      ['BREMBIO', 'B141'],
      ['CASELLE LANDI', 'B961'],
      ['MELETI', 'F102'],
      ['GALGAGNANO', 'D868'],
      ['BORGO SAN GIOVANNI', 'B017'],
      ['SAN ROCCO AL PORTO', 'I140'],
      ['CAVACURTA', 'C362'],
      ['MULAZZANO', 'F801'],
      ['BORGHETTO LODIGIANO', 'A995'],
      ['MERLINO', 'F149'],
      ['SAN MARTINO IN STRADA', 'I012'],
      ['SENNA LODIGIANA', 'I612'],
      ['CASTIRAGA VIDARDO', 'C329'],
      ['CODOGNO', 'C816'],
      ['CASALMAIOCCO', 'B899'],
      ['VALERA FRATTA', 'L572'],
      ['SANT\'ANGELO LODIGIANO', 'I274'],
      ['GUARDAMIGLIO', 'E238'],
      ['CAVENAGO D\'ADDA', 'C394']
    ],
    LT: [
      ['SABAUDIA', 'H647'],
      ['ROCCA MASSIMA', 'H421'],
      ['SAN FELICE CIRCEO', 'H836'],
      ['SANTI COSMA E DAMIANO', 'I339'],
      ['MINTURNO', 'F224'],
      ['CAMPODIMELE', 'B527'],
      ['SONNINO', 'I832'],
      ['NORMA', 'F937'],
      ['SPERLONGA', 'I892'],
      ['TERRACINA', 'L120'],
      ['FORMIA', 'D708'],
      ['PONZA', 'G871'],
      ['LENOLA', 'E527'],
      ['CISTERNA DI LATINA', 'C740'],
      ['ROCCASECCA DEI VOLSCI', 'H444'],
      ['PROSSEDI', 'H076'],
      ['CASTELFORTE', 'C104'],
      ['MONTE SAN BIAGIO', 'F616'],
      ['FONDI', 'D662'],
      ['CORI', 'D003'],
      ['LATINA', 'E472'],
      ['BASSIANO', 'A707'],
      ['GAETA', 'D843'],
      ['SEZZE', 'I712'],
      ['SPIGNO SATURNIA', 'I902'],
      ['ITRI', 'E375'],
      ['APRILIA', 'A341'],
      ['PONTINIA', 'G865'],
      ['SERMONETA', 'I634'],
      ['PRIVERNO', 'G698'],
      ['MAENZA', 'E798'],
      ['VENTOTENE', 'L742'],
      ['ROCCAGORGA', 'H413']
    ],
    LU: [
      ['VIAREGGIO', 'L833'],
      ['VERGEMOLI', 'L763'],
      ['SAN ROMANO IN GARFAGNANA', 'I142'],
      ['ALTOPASCIO', 'A241'],
      ['MASSAROSA', 'F035'],
      ['PORCARI', 'G882'],
      ['MINUCCIANO', 'F225'],
      ['PESCAGLIA', 'G480'],
      ['MOLAZZANA', 'F283'],
      ['FABBRICHE DI VALLICO', 'D449'],
      ['VILLA COLLEMANDINA', 'L926'],
      ['BARGA', 'A657'],
      ['GALLICANO', 'D874'],
      ['CAMAIORE', 'B455'],
      ['SERAVEZZA', 'I622'],
      ['GIUNCUGNANO', 'E059'],
      ['LUCCA', 'E715'],
      ['MONTECARLO', 'F452'],
      ['CAPANNORI', 'B648'],
      ['PIETRASANTA', 'G628'],
      ['PIEVE FOSCIANA', 'G648'],
      ['BAGNI DI LUCCA', 'A560'],
      ['STAZZEMA', 'I942'],
      ['CAMPORGIANO', 'B557'],
      ['CAREGGINE', 'B760'],
      ['SILLANO', 'I737'],
      ['BORGO A MOZZANO', 'B007'],
      ['CASTELNUOVO DI GARFAGNANA', 'C236'],
      ['VILLA BASILICA', 'L913'],
      ['FORTE DEI MARMI', 'D730'],
      ['FOSCIANDORA', 'D734'],
      ['COREGLIA ANTELMINELLI', 'C996'],
      ['VAGLI SOTTO', 'L533'],
      ['CASTIGLIONE DI GARFAGNANA', 'C303'],
      ['PIAZZA AL SERCHIO', 'G582']
    ],
    MB: [
      ['AGRATE BRIANZA', 'A087'],
      ['AICURZIO', 'A096'],
      ['ALBIATE', 'A159'],
      ['ARCORE', 'A376'],
      ['BARLASSINA', 'A668'],
      ['BELLUSCO', 'A759'],
      ['BERNAREGGIO', 'A802'],
      ['BESANA IN BRIANZA', 'A818'],
      ['BIASSONO', 'A849'],
      ['BOVISIO-MASCIAGO', 'B105'],
      ['BRIOSCO', 'B187'],
      ['BRUGHERIO', 'B212'],
      ['BURAGO DI MOLGORA', 'B272'],
      ['BUSNAGO', 'B289'],
      ['CAMPARADA', 'B501'],
      ['CAPONAGO', 'B671'],
      ['CARATE BRIANZA', 'B729'],
      ['CARNATE', 'B798'],
      ['CAVENAGO DI BRIANZA', 'C395'],
      ['CERIANO LAGHETTO', 'C512'],
      ['CESANO MADERNO', 'C566'],
      ['COGLIATE', 'C820'],
      ['CONCOREZZO', 'C952'],
      ['CORNATE D\'ADDA', 'D019'],
      ['CORREZZANA', 'D038'],
      ['DESIO', 'D286'],
      ['GIUSSANO', 'E063'],
      ['LAZZATE', 'E504'],
      ['LENTATE SUL SEVESO', 'E530'],
      ['LESMO', 'E550'],
      ['LIMBIATE', 'E591'],
      ['LISSONE', 'E617'],
      ['MACHERIO', 'E786'],
      ['MEDA', 'F078'],
      ['MEZZAGO', 'F165'],
      ['MISINTO', 'F247'],
      ['MONZA', 'F704'],
      ['MUGGI“', 'F797'],
      ['NOVA MILANESE', 'F944'],
      ['ORNAGO', 'G116'],
      ['RENATE', 'H233'],
      ['RONCELLO', 'H529'],
      ['RONCO BRIANTINO', 'H537'],
      ['SEREGNO', 'I625'],
      ['SEVESO', 'I709'],
      ['SOVICO', 'I878'],
      ['SULBIATE', 'I998'],
      ['TRIUGGIO', 'L434'],
      ['USMATE VELATE', 'L511'],
      ['VAREDO', 'L677'],
      ['VEDANO AL LAMBRO', 'L704'],
      ['VEDUGGIO CON COLZANO', 'L709'],
      ['VERANO BRIANZA', 'L744'],
      ['VILLASANTA', 'M017'],
      ['VIMERCATE', 'M052']
    ],
    MC: [
      ['MATELICA', 'F051'],
      ['LORO PICENO', 'E694'],
      ['FIORDIMONTE', 'D609'],
      ['PIEVEBOVIGLIANA', 'G637'],
      ['MONTE SAN MARTINO', 'F622'],
      ['MONTE SAN GIUSTO', 'F621'],
      ['MONTECOSARO', 'F482'],
      ['PIEVE TORINA', 'G657'],
      ['POLLENZA', 'F567'],
      ['CASTELRAIMONDO', 'C251'],
      ['SAN GINESIO', 'H876'],
      ['MORROVALLE', 'F749'],
      ['MOGLIANO', 'F268'],
      ['BELFORTE DEL CHIENTI', 'A739'],
      ['ESANATOGLIA', 'D429'],
      ['PORTO RECANATI', 'G919'],
      ['RIPE SAN GINESIO', 'H323'],
      ['CAMPOROTONDO DI FIASTRONE', 'B562'],
      ['GAGLIOLE', 'D853'],
      ['APPIGNANO', 'A334'],
      ['SERRAVALLE DI CHIENTI', 'I661'],
      ['CASTELSANTANGELO SUL NERA', 'C267'],
      ['CAMERINO', 'B474'],
      ['PETRIOLO', 'G515'],
      ['SARNANO', 'I436'],
      ['BOLOGNOLA', 'A947'],
      ['URBISAGLIA', 'L501'],
      ['POGGIO SAN VICINO', 'D566'],
      ['FIASTRA', 'D564'],
      ['SAN SEVERINO MARCHE', 'I156'],
      ['TREIA', 'L366'],
      ['GUALDO', 'E228'],
      ['CORRIDONIA', 'D042'],
      ['PENNA SAN GIOVANNI', 'G436'],
      ['MONTECASSIANO', 'F454'],
      ['COLMURANO', 'C886'],
      ['MONTELUPONE', 'F552'],
      ['POTENZA PICENA', 'F632'],
      ['MONTEFANO', 'F496'],
      ['MUCCIA', 'F793'],
      ['FIUMINATA', 'D628'],
      ['SANT\'ANGELO IN PONTANO', 'I286'],
      ['SEFRO', 'I569'],
      ['VISSO', 'M078'],
      ['TOLENTINO', 'L191'],
      ['APIRO', 'A329'],
      ['MACERATA', 'E783'],
      ['RECANATI', 'H211'],
      ['SERRAPETRONA', 'I651'],
      ['CINGOLI', 'C704'],
      ['CIVITANOVA MARCHE', 'C770'],
      ['PIORACO', 'G690'],
      ['USSITA', 'L517'],
      ['CESSAPALOMBO', 'C582'],
      ['ACQUACANINA', 'A031'],
      ['CALDAROLA', 'B398'],
      ['MONTE CAVALLO', 'F460']
    ],
    ME: [
      ['TAORMINA', 'L042'],
      ['SPADAFORA', 'I881'],
      ['SANTA TERESA DI RIVA', 'I311'],
      ['CASTELMOLA', 'C210'],
      ['TORREGROTTA', 'L271'],
      ['SAN PIERO PATTI', 'I086'],
      ['SAN PIER NICETO', 'I084'],
      ['MALFA', 'E855'],
      ['MILAZZO', 'F206'],
      ['SINAGRA', 'I747'],
      ['CAPRI LEONE', 'B695'],
      ['MANDANICI', 'E876'],
      ['BROLO', 'B198'],
      ['LIPARI', 'E606'],
      ['FURNARI', 'D825'],
      ['ROMETTA', 'H519'],
      ['MIRTO', 'F242'],
      ['SANTO STEFANO DI CAMASTRA', 'I370'],
      ['PATTI', 'G377'],
      ['BASICO\'', 'A698'],
      ['CASTELL\'UMBERTO', 'C051'],
      ['ANTILLO', 'A313'],
      ['REITANO', 'H228'],
      ['SANT\'ALESSIO SICULO', 'I215'],
      ['ALI\'', 'A194'],
      ['CASALVECCHIO SICULO', 'B918'],
      ['ROCCAVALDINA', 'H380'],
      ['SAVOCA', 'I477'],
      ['NOVARA DI SICILIA', 'F951'],
      ['UCRIA', 'L482'],
      ['BARCELLONA POZZO DI GOTTO', 'A638'],
      ['SANTA MARINA SALINA', 'I254'],
      ['CASTEL DI LUCIO', 'C094'],
      ['LENI', 'E523'],
      ['TORTORICI', 'L308'],
      ['MESSINA', 'F158'],
      ['MONGIUFFI MELIA', 'F368'],
      ['SCALETTA ZANCLEA', 'I492'],
      ['PAGLIARA', 'G234'],
      ['SANT\'AGATA DI MILITELLO', 'I199'],
      ['VENETICO', 'L735'],
      ['FRANCAVILLA DI SICILIA', 'D765'],
      ['OLIVERI', 'G036'],
      ['GIARDINI-NAXOS', 'E014'],
      ['ROCCAFIORITA', 'H405'],
      ['MAZZARRA\' SANT\'ANDREA', 'F066'],
      ['FICARRA', 'D569'],
      ['VALDINA', 'L561'],
      ['GIOIOSA MAREA', 'E043'],
      ['CAPO D\'ORLANDO', 'B666'],
      ['CAPIZZI', 'B660'],
      ['MONTAGNAREALE', 'F395'],
      ['FONDACHELLI-FANTINA', 'D661'],
      ['TERME VIGLIATORE', 'M210'],
      ['ACQUEDOLCI', 'M211'],
      ['CARONIA', 'B804'],
      ['SAN TEODORO', 'I328'],
      ['ALCARA LI FUSI', 'A177'],
      ['RACCUJA', 'H151'],
      ['FIUMEDINISI', 'D622'],
      ['MILITELLO ROSMARINO', 'F210'],
      ['SAN FILIPPO DEL MELA', 'H842'],
      ['MOTTA CAMASTRA', 'F772'],
      ['MOTTA D\'AFFERMO', 'F773'],
      ['SANTA LUCIA DEL MELA', 'I220'],
      ['SANT\'ANGELO DI BROLO', 'I283'],
      ['MALVAGNA', 'E869'],
      ['LIMINA', 'E594'],
      ['LONGI', 'E674'],
      ['GAGGI', 'D844'],
      ['MISTRETTA', 'F251'],
      ['GALLODORO', 'D885'],
      ['MOIO ALCANTARA', 'F277'],
      ['VILLAFRANCA TIRRENA', 'L950'],
      ['TRIPI', 'L431'],
      ['ITALA', 'E374'],
      ['NIZZA DI SICILIA', 'F901'],
      ['CONDRO\'', 'C956'],
      ['NASO', 'F848'],
      ['CESARO\'', 'C568'],
      ['LIBRIZZI', 'E571'],
      ['GRANITI', 'E142'],
      ['SAN SALVATORE DI FITALIA', 'I147'],
      ['FALCONE', 'D474'],
      ['TUSA', 'L478'],
      ['LETOJANNI', 'E555'],
      ['FORZA D\'AGRO\'', 'D733'],
      ['CASTROREALE', 'C347'],
      ['PIRAINO', 'G699'],
      ['PETTINEO', 'G522'],
      ['MERI\'', 'F147'],
      ['FURCI SICULO', 'D824'],
      ['SANTA DOMENICA VITTORIA', 'I184'],
      ['PACE DEL MELA', 'G209'],
      ['MONFORTE SAN GIORGIO', 'F359'],
      ['ROCCELLA VALDEMONE', 'H455'],
      ['GALATI MAMERTINO', 'D861'],
      ['SAPONARA', 'I420'],
      ['MONTALBANO ELICONA', 'F400'],
      ['SAN MARCO D\'ALUNZIO', 'H982'],
      ['TORRENOVA', 'M286'],
      ['FLORESTA', 'D635'],
      ['RODI\' MILICI', 'H479'],
      ['FRAZZANO\'', 'D793'],
      ['SAN FRATELLO', 'H850'],
      ['GUALTIERI SICAMINO\'', 'E233'],
      ['ALI\' TERME', 'A201'],
      ['ROCCALUMERA', 'H418']
    ],
    MI: [
      ['VERMEZZO', 'L768'],
      ['BERNAREGGIO', 'A802'],
      ['VIZZOLO PREDABISSI', 'M102'],
      ['SETTALA', 'I696'],
      ['SESTO SAN GIOVANNI', 'I690'],
      ['ZELO SURRIGONE', 'M160'],
      ['BRIOSCO', 'B187'],
      ['PIEVE EMANUELE', 'G634'],
      ['COLOGNO MONZESE', 'C895'],
      ['VAREDO', 'L677'],
      ['CORNATE D\'ADDA', 'D019'],
      ['CORNAREDO', 'D018'],
      ['CORMANO', 'D013'],
      ['DAIRAGO', 'D244'],
      ['CAPONAGO', 'B671'],
      ['MILANO', 'F205'],
      ['MORIMONDO', 'D033'],
      ['CORREZZANA', 'D038'],
      ['BELLUSCO', 'A759'],
      ['BELLINZAGO LOMBARDO', 'A751'],
      ['MOTTA VISCONTI', 'F783'],
      ['LOCATE DI TRIULZI', 'E639'],
      ['RONCO BRIANTINO', 'H537'],
      ['BERNATE TICINO', 'A804'],
      ['CASSINETTA DI LUGAGNANO', 'C033'],
      ['CARUGATE', 'B850'],
      ['CAMPARADA', 'B501'],
      ['ALBAIRATE', 'A127'],
      ['PANTIGLIATE', 'G316'],
      ['MAGNAGO', 'E819'],
      ['MISINTO', 'F247'],
      ['POZZO D\'ADDA', 'G955'],
      ['SEVESO', 'I709'],
      ['SETTIMO MILANESE', 'I700'],
      ['PERO', 'C013'],
      ['BESATE', 'A820'],
      ['COLTURANO', 'C908'],
      ['SEGRATE', 'I577'],
      ['TREZZANO ROSA', 'L408'],
      ['TREZZANO SUL NAVIGLIO', 'L409'],
      ['RENATE', 'H233'],
      ['PESCHIERA BORROMEO', 'G488'],
      ['DRESANO', 'D367'],
      ['CASSINA DE\' PECCHI', 'C014'],
      ['BIASSONO', 'A849'],
      ['SAN GIULIANO MILANESE', 'H930'],
      ['BASIANO', 'A697'],
      ['BASIGLIO', 'A699'],
      ['ASSAGO', 'A473'],
      ['VIGNATE', 'L883'],
      ['BUSNAGO', 'B289'],
      ['BUSCATE', 'B286'],
      ['RHO', 'H264'],
      ['CASTANO PRIMO', 'C052'],
      ['NERVIANO', 'F874'],
      ['ARLUNO', 'A413'],
      ['ORNAGO', 'G116'],
      ['MELZO', 'F119'],
      ['CERNUSCO SUL NAVIGLIO', 'C523'],
      ['AGRATE BRIANZA', 'A087'],
      ['NOSATE', 'F939'],
      ['BAREGGIO', 'A652'],
      ['GORGONZOLA', 'E094'],
      ['CASARILE', 'B938'],
      ['BUCCINASCO', 'B240'],
      ['CARNATE', 'B798'],
      ['SOLARO', 'I786'],
      ['NOVATE MILANESE', 'F955'],
      ['CORBETTA', 'C986'],
      ['CERIANO LAGHETTO', 'C512'],
      ['MESERO', 'F155'],
      ['SAN ZENONE AL LAMBRO', 'I415'],
      ['OPERA', 'G078'],
      ['ARCONATE', 'A375'],
      ['ARCORE', 'A376'],
      ['SEREGNO', 'I625'],
      ['BARANZATE', 'A618'],
      ['PIOLTELLO', 'G686'],
      ['CERRO MAGGIORE', 'C537'],
      ['COGLIATE', 'C820'],
      ['CERRO AL LAMBRO', 'C536'],
      ['LAZZATE', 'E504'],
      ['SULBIATE', 'I998'],
      ['CUGGIONO', 'D198'],
      ['GESSATE', 'D995'],
      ['GARBAGNATE MILANESE', 'D912'],
      ['BOLLATE', 'A940'],
      ['MARCALLO CON CASONE', 'E921'],
      ['VANZAGHELLO', 'L664'],
      ['VANZAGO', 'L665'],
      ['BOFFALORA SOPRA TICINO', 'A920'],
      ['RESCALDINA', 'H240'],
      ['VERNATE', 'L773'],
      ['BRESSO', 'B162'],
      ['CORSICO', 'D045'],
      ['CUSANO MILANINO', 'D231'],
      ['CANEGRATE', 'B593'],
      ['BOVISIO-MASCIAGO', 'B105'],
      ['CARPIANO', 'B820'],
      ['LAINATE', 'E415'],
      ['VAPRIO D\'ADDA', 'L667'],
      ['SAN COLOMBANO AL LAMBRO', 'H803'],
      ['ZIBIDO SAN GIACOMO', 'M176'],
      ['SOVICO', 'I878'],
      ['SENAGO', 'I602'],
      ['MASATE', 'F003'],
      ['ROSATE', 'H560'],
      ['SAN DONATO MILANESE', 'H827'],
      ['MUGGIO\'', 'F797'],
      ['TRIUGGIO', 'L434'],
      ['OSSONA', 'G181'],
      ['BUSTO GAROLFO', 'B301'],
      ['GUDO VISCONTI', 'E258'],
      ['BESANA IN BRIANZA', 'A818'],
      ['LISSONE', 'E617'],
      ['VILLA CORTESE', 'L928'],
      ['VIMERCATE', 'M052'],
      ['VIMODRONE', 'M053'],
      ['ALBIATE', 'A159'],
      ['RONCELLO', 'H529'],
      ['LIMBIATE', 'E591'],
      ['CASOREZZO', 'B989'],
      ['CARATE BRIANZA', 'B729'],
      ['MONZA', 'F704'],
      ['SANTO STEFANO TICINO', 'I361'],
      ['SEDRIANO', 'I566'],
      ['MAGENTA', 'E801'],
      ['GAGGIANO', 'D845'],
      ['POZZUOLO MARTESANA', 'G965'],
      ['SAN GIORGIO SU LEGNANO', 'H884'],
      ['CASSANO D\'ADDA', 'C003'],
      ['POGLIANO MILANESE', 'G772'],
      ['MEDIGLIA', 'F084'],
      ['LACCHIARELLA', 'E395'],
      ['VILLASANTA', 'M017'],
      ['TRIBIANO', 'L415'],
      ['TREZZO SULL\'ADDA', 'L411'],
      ['BINASCO', 'A872'],
      ['BUBBIANO', 'B235'],
      ['BUSSERO', 'B292'],
      ['CISLIANO', 'C733'],
      ['AICURZIO', 'A096'],
      ['MACHERIO', 'E786'],
      ['CONCOREZZO', 'C952'],
      ['TRUCCAZZANO', 'L454'],
      ['BARLASSINA', 'A668'],
      ['PAULLO', 'G385'],
      ['CESANO MADERNO', 'C566'],
      ['CESANO BOSCONE', 'C565'],
      ['CESATE', 'C569'],
      ['INVERUNO', 'E313'],
      ['INZAGO', 'E317'],
      ['PARABIAGO', 'G324'],
      ['MELEGNANO', 'F100'],
      ['ROBECCO SUL NAVIGLIO', 'H373'],
      ['ROBECCHETTO CON INDUNO', 'H371'],
      ['CAMBIAGO', 'B461'],
      ['TURBIGO', 'L471'],
      ['LESMO', 'E550'],
      ['PESSANO CON BORNAGO', 'G502'],
      ['CINISELLO BALSAMO', 'C707'],
      ['NOVA MILANESE', 'F944'],
      ['GREZZAGO', 'E170'],
      ['VITTUONE', 'M091'],
      ['CALVIGNASCO', 'B448'],
      ['LENTATE SUL SEVESO', 'E530'],
      ['SAN VITTORE OLONA', 'I409'],
      ['PREGNANA MILANESE', 'H026'],
      ['BURAGO DI MOLGORA', 'B272'],
      ['ARESE', 'A389'],
      ['NOVIGLIO', 'F968'],
      ['ROZZANO', 'H623'],
      ['OZZERO', 'G206'],
      ['VEDUGGIO CON COLZANO', 'L709'],
      ['VEDANO AL LAMBRO', 'L704'],
      ['LEGNANO', 'E514'],
      ['LISCATE', 'E610'],
      ['MEZZAGO', 'F165'],
      ['BRUGHERIO', 'B212'],
      ['USMATE VELATE', 'L511'],
      ['ABBIATEGRASSO', 'A010'],
      ['PADERNO DUGNANO', 'G220'],
      ['GIUSSANO', 'E063'],
      ['RODANO', 'H470'],
      ['DESIO', 'D286'],
      ['CAVENAGO DI BRIANZA', 'C395'],
      ['VERANO BRIANZA', 'L744'],
      ['CUSAGO', 'D229'],
      ['MEDA', 'F078']
    ],
    MN: [
      ['CANNETO SULL\'OGLIO', 'B612'],
      ['CASTEL GOFFREDO', 'C118'],
      ['BOZZOLO', 'B110'],
      ['GAZOLDO DEGLI IPPOLITI', 'D949'],
      ['QUINGENTOLE', 'H129'],
      ['VIRGILIO', 'H123'],
      ['PIEVE DI CORIANO', 'G633'],
      ['CERESARA', 'C502'],
      ['BAGNOLO SAN VITO', 'A575'],
      ['SCHIVENOGLIA', 'I532'],
      ['ROVERBELLA', 'H604'],
      ['QUISTELLO', 'H143'],
      ['SUZZARA', 'L020'],
      ['VILLIMPENTA', 'M044'],
      ['MAGNACAVALLO', 'E818'],
      ['SAN GIACOMO DELLE SEGNATE', 'H870'],
      ['VILLA POMA', 'F804'],
      ['MOGLIA', 'F267'],
      ['CASTEL D\'ARIO', 'C076'],
      ['REVERE', 'H248'],
      ['ASOLA', 'A470'],
      ['PORTO MANTOVANO', 'G917'],
      ['BIGARELLO', 'A866'],
      ['MONZAMBANO', 'F705'],
      ['SAN GIOVANNI DEL DOSSO', 'H912'],
      ['CASALROMANO', 'B911'],
      ['RIVAROLO MANTOVANO', 'H342'],
      ['MANTOVA', 'E897'],
      ['SAN MARTINO DALL\'ARGINE', 'I005'],
      ['FELONICA', 'D529'],
      ['GUIDIZZOLO', 'E261'],
      ['GOITO', 'E078'],
      ['MARCARIA', 'E922'],
      ['POMPONESCO', 'G816'],
      ['CASTIGLIONE DELLE STIVIERE', 'C312'],
      ['CAVRIANA', 'C406'],
      ['GAZZUOLO', 'D959'],
      ['MARMIROLO', 'E962'],
      ['SABBIONETA', 'H652'],
      ['MARIANA MANTOVANA', 'E949'],
      ['PEGOGNAGA', 'G417'],
      ['SAN BENEDETTO PO', 'H771'],
      ['RODIGO', 'H481'],
      ['OSTIGLIA', 'G186'],
      ['RONCOFERRARO', 'H541'],
      ['CASTELBELFORTE', 'C059'],
      ['SUSTINENTE', 'L015'],
      ['DOSOLO', 'D351'],
      ['SAN GIORGIO DI MANTOVA', 'H883'],
      ['MEDOLE', 'F086'],
      ['POGGIO RUSCO', 'G753'],
      ['COMMESSAGGIO', 'C930'],
      ['CASALMORO', 'B901'],
      ['CASALOLDO', 'B907'],
      ['BORGOFORTE', 'B011'],
      ['BORGOFRANCO SUL PO', 'B013'],
      ['REDONDESCO', 'H218'],
      ['GONZAGA', 'E089'],
      ['CURTATONE', 'D227'],
      ['CASTELLUCCHIO', 'C195'],
      ['PONTI SUL MINCIO', 'G862'],
      ['SERMIDE', 'I632'],
      ['VIADANA', 'L826'],
      ['MOTTEGGIANA', 'B012'],
      ['SERRAVALLE A PO', 'I662'],
      ['SOLFERINO', 'I801'],
      ['ACQUANEGRA SUL CHIESE', 'A038'],
      ['CARBONARA DI PO', 'B739'],
      ['VOLTA MANTOVANA', 'M125'],
      ['PIUBEGA', 'G717']
    ],
    MO: [
      ['SAN POSSIDONIO', 'I128'],
      ['FIORANO MODENESE', 'D607'],
      ['FANANO', 'D486'],
      ['MONTECRETO', 'F484'],
      ['CARPI', 'B819'],
      ['LAMA MOCOGNO', 'E426'],
      ['SAN FELICE SUL PANARO', 'H835'],
      ['SAN PROSPERO', 'I133'],
      ['ZOCCA', 'M183'],
      ['MONTEFIORINO', 'F503'],
      ['FIUMALBO', 'D617'],
      ['MIRANDOLA', 'F240'],
      ['BASTIGLIA', 'A713'],
      ['RIOLUNATO', 'H303'],
      ['VIGNOLA', 'L885'],
      ['CAMPOSANTO', 'B566'],
      ['NONANTOLA', 'F930'],
      ['PALAGANO', 'G250'],
      ['PAVULLO NEL FRIGNANO', 'G393'],
      ['CAVEZZO', 'C398'],
      ['SAVIGNANO SUL PANARO', 'I473'],
      ['GUIGLIA', 'E264'],
      ['POLINAGO', 'G789'],
      ['MARANELLO', 'E904'],
      ['MARANO SUL PANARO', 'E905'],
      ['FRASSINORO', 'D783'],
      ['CASTELFRANCO EMILIA', 'C107'],
      ['SAN CESARIO SUL PANARO', 'H794'],
      ['SESTOLA', 'I689'],
      ['PIEVEPELAGO', 'G649'],
      ['RAVARINO', 'H195'],
      ['CASTELNUOVO RANGONE', 'C242'],
      ['CAMPOGALLIANO', 'B539'],
      ['MODENA', 'F257'],
      ['MEDOLLA', 'F087'],
      ['CASTELVETRO DI MODENA', 'C287'],
      ['SPILAMBERTO', 'I903'],
      ['FINALE EMILIA', 'D599'],
      ['CONCORDIA SULLA SECCHIA', 'C951'],
      ['FORMIGINE', 'D711'],
      ['SASSUOLO', 'I462'],
      ['NOVI DI MODENA', 'F966'],
      ['SERRAMAZZONI', 'F357'],
      ['BOMPORTO', 'A959'],
      ['PRIGNANO SULLA SECCHIA', 'H061'],
      ['MONTESE', 'F642'],
      ['SOLIERA', 'I802']
    ],
    MS: [
      ['ZERI', 'M169'],
      ['CARRARA', 'B832'],
      ['BAGNONE', 'A576'],
      ['PODENZANA', 'G746'],
      ['CASOLA IN LUNIGIANA', 'B979'],
      ['VILLAFRANCA IN LUNIGIANA', 'L946'],
      ['PONTREMOLI', 'G870'],
      ['MONTIGNOSO', 'F679'],
      ['MASSA', 'F023'],
      ['AULLA', 'A496'],
      ['FIVIZZANO', 'D629'],
      ['TRESANA', 'L386'],
      ['FILATTIERA', 'D590'],
      ['COMANO', 'C914'],
      ['FOSDINOVO', 'D735'],
      ['MULAZZO', 'F802'],
      ['LICCIANA NARDI', 'E574']
    ],
    MT: [
      ['SAN MAURO FORTE', 'I029'],
      ['GROTTOLE', 'E213'],
      ['MATERA', 'F052'],
      ['GARAGUSO', 'D909'],
      ['MIGLIONICO', 'F201'],
      ['BERNALDA', 'A801'],
      ['FERRANDINA', 'D547'],
      ['STIGLIANO', 'I954'],
      ['ALIANO', 'A196'],
      ['ROTONDELLA', 'H591'],
      ['IRSINA', 'E326'],
      ['NOVA SIRI', 'A942'],
      ['OLIVETO LUCANO', 'G037'],
      ['POLICORO', 'G786'],
      ['SCANZANO JONICO', 'M256'],
      ['GORGOGLIONE', 'E093'],
      ['COLOBRARO', 'C888'],
      ['MONTESCAGLIOSO', 'F637'],
      ['CIRIGLIANO', 'C723'],
      ['SAN GIORGIO LUCANO', 'H888'],
      ['TRICARICO', 'L418'],
      ['CRACO', 'D128'],
      ['SALANDRA', 'H687'],
      ['GRASSANO', 'E147'],
      ['PISTICCI', 'G712'],
      ['TURSI', 'L477'],
      ['VALSINNI', 'D513'],
      ['ACCETTURA', 'A017'],
      ['CALCIANO', 'B391'],
      ['POMARICO', 'G806'],
      ['MONTALBANO JONICO', 'F399']
    ],
    NA: [
      ['CAIVANO', 'B371'],
      ['CARBONARA DI NOLA', 'B740'],
      ['ANACAPRI', 'A268'],
      ['ROCCARAINOLA', 'H433'],
      ['SOMMA VESUVIANA', 'I820'],
      ['VILLARICCA', 'G309'],
      ['PALMA CAMPANIA', 'G283'],
      ['MASSA LUBRENSE', 'F030'],
      ['QUALIANO', 'H101'],
      ['MONTE DI PROCIDA', 'F488'],
      ['PIMONTE', 'G670'],
      ['SAVIANO', 'I469'],
      ['CAPRI', 'B696'],
      ['OTTAVIANO', 'G190'],
      ['CASORIA', 'B990'],
      ['STRIANO', 'I978'],
      ['CRISPANO', 'D170'],
      ['POGGIOMARINO', 'G762'],
      ['ARZANO', 'A455'],
      ['SAN GIORGIO A CREMANO', 'H892'],
      ['COMIZIANO', 'C929'],
      ['ERCOLANO', 'H243'],
      ['SAN GIUSEPPE VESUVIANO', 'H931'],
      ['LIVERI', 'E620'],
      ['CARDITO', 'B759'],
      ['VICO EQUENSE', 'L845'],
      ['CAMPOSANO', 'B565'],
      ['TERZIGNO', 'L142'],
      ['MELITO DI NAPOLI', 'F111'],
      ['TUFINO', 'L460'],
      ['ISCHIA', 'E329'],
      ['FORIO', 'D702'],
      ['CASTELLO DI CISTERNA', 'C188'],
      ['NAPOLI', 'F839'],
      ['TORRE ANNUNZIATA', 'L245'],
      ['CIMITILE', 'C697'],
      ['BARANO D\'ISCHIA', 'A617'],
      ['CALVIZZANO', 'B452'],
      ['MARIGLIANO', 'E955'],
      ['MARIGLIANELLA', 'E954'],
      ['GIUGLIANO IN CAMPANIA', 'E054'],
      ['BRUSCIANO', 'B227'],
      ['GRAGNANO', 'E131'],
      ['POMIGLIANO D\'ARCO', 'G812'],
      ['POMPEI', 'G813'],
      ['MARANO DI NAPOLI', 'E906'],
      ['PROCIDA', 'H072'],
      ['FRATTAMAGGIORE', 'D789'],
      ['SAN SEBASTIANO AL VESUVIO', 'I151'],
      ['ACERRA', 'A024'],
      ['GRUMO NEVANO', 'E224'],
      ['CASTELLAMMARE DI STABIA', 'C129'],
      ['VOLLA', 'M115'],
      ['SAN PAOLO BEL SITO', 'I073'],
      ['AGEROLA', 'A068'],
      ['AFRAGOLA', 'A064'],
      ['QUARTO', 'H114'],
      ['SANT\'ANTONIO ABATE', 'I300'],
      ['SORRENTO', 'I862'],
      ['MUGNANO DI NAPOLI', 'F799'],
      ['CASOLA DI NAPOLI', 'B980'],
      ['SANT\'ANTIMO', 'I293'],
      ['SAN GENNARO VESUVIANO', 'H860'],
      ['VISCIANO', 'M072'],
      ['CERCOLA', 'C495'],
      ['SANTA MARIA LA CARITA\'', 'M273'],
      ['POZZUOLI', 'G964'],
      ['SCISCIANO', 'I540'],
      ['CASAVATORE', 'B946'],
      ['PORTICI', 'G902'],
      ['SAN VITALIANO', 'I391'],
      ['SANT\'AGNELLO', 'I208'],
      ['CASALNUOVO DI NAPOLI', 'B905'],
      ['NOLA', 'F924'],
      ['SERRARA FONTANA', 'I652'],
      ['SANT\'ANASTASIA', 'I262'],
      ['LETTERE', 'E557'],
      ['CASAMARCIANO', 'B922'],
      ['CASANDRINO', 'B925'],
      ['CASAMICCIOLA TERME', 'B924'],
      ['BACOLI', 'A535'],
      ['BOSCOTRECASE', 'B077'],
      ['BOSCOREALE', 'B076'],
      ['TORRE DEL GRECO', 'L259'],
      ['META', 'F162'],
      ['TRECASE', 'M280'],
      ['MASSA DI SOMMA', 'M289'],
      ['LACCO AMENO', 'E396'],
      ['PIANO DI SORRENTO', 'G568'],
      ['FRATTAMINORE', 'D790'],
      ['POLLENA TROCCHIA', 'G795'],
      ['CICCIANO', 'C675']
    ],
    NO: [
      ['BOCA', 'A911'],
      ['AMENO', 'A264'],
      ['SAN MAURIZIO D\'OPAGLIO', 'I025'],
      ['PELLA', 'G421'],
      ['SIZZANO', 'I767'],
      ['ARONA', 'A429'],
      ['VARALLO POMBIA', 'L670'],
      ['MANDELLO VITTA', 'E880'],
      ['BELLINZAGO NOVARESE', 'A752'],
      ['SUNO', 'L007'],
      ['MIASINO', 'F191'],
      ['ROMENTINO', 'H518'],
      ['GARGALLO', 'D921'],
      ['VINZAGLIO', 'M062'],
      ['CERANO', 'C483'],
      ['GATTICO', 'D937'],
      ['BIANDRATE', 'A844'],
      ['COMIGNAGO', 'C926'],
      ['MEINA', 'F093'],
      ['TORNACO', 'L223'],
      ['DIVIGNANO', 'D309'],
      ['VICOLUNGO', 'L847'],
      ['ARMENO', 'A414'],
      ['AGRATE CONTURBIA', 'A088'],
      ['NEBBIUNO', 'F859'],
      ['BARENGO', 'A653'],
      ['ORTA SAN GIULIO', 'G134'],
      ['GALLIATE', 'D872'],
      ['GOZZANO', 'E120'],
      ['NOVARA', 'F952'],
      ['CAMERI', 'B473'],
      ['TERDOBBIATE', 'L104'],
      ['BORGO TICINO', 'B043'],
      ['COLAZZA', 'C829'],
      ['CALTIGNAGA', 'B431'],
      ['VAPRIO D\'AGOGNA', 'L668'],
      ['CASALEGGIO NOVARA', 'B883'],
      ['BOGOGNO', 'A929'],
      ['MARANO TICINO', 'E907'],
      ['OLEGGIO', 'G019'],
      ['MASSINO VISCONTI', 'F047'],
      ['SILLAVENGO', 'I736'],
      ['SAN NAZZARO SESIA', 'I052'],
      ['FONTANETO D\'AGOGNA', 'D675'],
      ['SORISO', 'I857'],
      ['CARPIGNANO SESIA', 'B823'],
      ['CUREGGIO', 'D216'],
      ['SAN PIETRO MOSEZZO', 'I116'],
      ['CASTELLAZZO NOVARESE', 'C149'],
      ['LANDIONA', 'E436'],
      ['FARA NOVARESE', 'D492'],
      ['CASTELLETTO SOPRA TICINO', 'C166'],
      ['CASALBELTRAME', 'B864'],
      ['LESA', 'E544'],
      ['MEZZOMERICO', 'F188'],
      ['BRIONA', 'B183'],
      ['GARBAGNA NOVARESE', 'D911'],
      ['VESPOLATE', 'L808'],
      ['CRESSA', 'D162'],
      ['ROMAGNANO SESIA', 'H502'],
      ['MAGGIORA', 'E803'],
      ['POGNO', 'G775'],
      ['NIBBIOLA', 'F886'],
      ['PARUZZARO', 'G349'],
      ['VERUNO', 'L798'],
      ['SOZZAGO', 'I880'],
      ['INVORIO', 'E314'],
      ['BORGOMANERO', 'B019'],
      ['BORGOLAVEZZARO', 'B016'],
      ['GRANOZZO CON MONTICELLO', 'E143'],
      ['RECETTO', 'H213'],
      ['MOMO', 'F317'],
      ['DORMELLETTO', 'D347'],
      ['CAVAGLIETTO', 'C364'],
      ['CAVAGLIO D\'AGOGNA', 'C365'],
      ['CASALVOLONE', 'B920'],
      ['PRATO SESIA', 'H001'],
      ['GRIGNASCO', 'E177'],
      ['PISANO', 'G703'],
      ['PETTENASCO', 'G520'],
      ['TRECATE', 'L356'],
      ['BOLZANO NOVARESE', 'A953'],
      ['CASALINO', 'B897'],
      ['OLEGGIO CASTELLO', 'G020'],
      ['BRIGA NOVARESE', 'B176'],
      ['POMBIA', 'G809'],
      ['GHEMME', 'E001'],
      ['CAVALLIRIO', 'C378']
    ],
    NU: [
      ['GAVOI', 'D947'],
      ['BORTIGALI', 'B062'],
      ['LACONI', 'E400'],
      ['SINDIA', 'I748'],
      ['LANUSEI', 'E441'],
      ['SUNI', 'L006'],
      ['OTTANA', 'G191'],
      ['PERDASDEFOGU', 'G445'],
      ['MAMOIADA', 'E874'],
      ['BELVI', 'A776'],
      ['SEUI', 'I706'],
      ['SEULO', 'I707'],
      ['GERGEI', 'D982'],
      ['ARZANA', 'A454'],
      ['OSINI', 'G158'],
      ['OSIDDA', 'G154'],
      ['MODOLO', 'F261'],
      ['LODINE', 'E649'],
      ['LOCERI', 'E644'],
      ['LODE\'', 'E647'],
      ['LOCULI', 'E646'],
      ['TRIEI', 'L423'],
      ['TIANA', 'L160'],
      ['ESTERZILI', 'D443'],
      ['OROSEI', 'G119'],
      ['TONARA', 'L202'],
      ['TERTENIA', 'L140'],
      ['GAIRO', 'D859'],
      ['BIRORI', 'A880'],
      ['NORAGUGUME', 'F933'],
      ['SERRI', 'I668'],
      ['IRGOLI', 'E323'],
      ['BUDONI', 'B248'],
      ['BOSA', 'B068'],
      ['ORGOSOLO', 'G097'],
      ['TORTOLI\'', 'A355'],
      ['BORORE', 'B056'],
      ['ONIFAI', 'G070'],
      ['ONIFERI', 'G071'],
      ['NUORO', 'F979'],
      ['OLZAI', 'G058'],
      ['MONTRESTA', 'F698'],
      ['BOLOTANA', 'A948'],
      ['JERZU', 'E387'],
      ['URZULEI', 'L506'],
      ['OLIENA', 'G031'],
      ['LULA', 'E736'],
      ['SADALI', 'H659'],
      ['SORGONO', 'I851'],
      ['AUSTIS', 'A503'],
      ['FONNI', 'D665'],
      ['FLUSSIO', 'D640'],
      ['ATZARA', 'A492'],
      ['SAN TEODORO', 'I329'],
      ['ELINI', 'D395'],
      ['SINISCOLA', 'I751'],
      ['ILBONO', 'E283'],
      ['TALANA', 'L036'],
      ['ORTUERI', 'G146'],
      ['ORUNE', 'G147'],
      ['DUALCHI', 'D376'],
      ['GALTELLI', 'D888'],
      ['BAUNEI', 'A722'],
      ['MAGOMADAS', 'E825'],
      ['TINNURA', 'L172'],
      ['SILANUS', 'I730'],
      ['BITTI', 'A895'],
      ['VILLAGRANDE STRISAILI', 'L953'],
      ['ESCOLCA', 'D431'],
      ['ESCALAPLANO', 'D430'],
      ['TORPE\'', 'L231'],
      ['TETI', 'L153'],
      ['GADONI', 'D842'],
      ['POSADA', 'G929'],
      ['MACOMER', 'E788'],
      ['BARI SARDO', 'A663'],
      ['ARITZO', 'A407'],
      ['ORROLI', 'G122'],
      ['OROTELLI', 'G120'],
      ['SARULE', 'I448'],
      ['DORGALI', 'D345'],
      ['ISILI', 'E336'],
      ['ORANI', 'G084'],
      ['ULASSAI', 'L489'],
      ['ONANI', 'G064'],
      ['OVODDA', 'G201'],
      ['GIRASOLE', 'E049'],
      ['LEI', 'E517'],
      ['USSASSAI', 'L514'],
      ['OLLOLAI', 'G044'],
      ['NURRI', 'F986'],
      ['NURALLAO', 'F982'],
      ['NURAGUS', 'F981'],
      ['LOTZORAI', 'E700'],
      ['CARDEDU', 'M285'],
      ['SAGAMA', 'H661'],
      ['VILLANOVATULO', 'L992'],
      ['DESULO', 'D287'],
      ['GENONI', 'D968'],
      ['MEANA SARDO', 'F073']
    ],
    OR: [
      ['MARRUBIU', 'E972'],
      ['MASULLAS', 'F050'],
      ['CUGLIERI', 'D200'],
      ['PALMAS ARBOREA', 'G286'],
      ['ZERFALIU', 'M168'],
      ['ULA\' TIRSO', 'L488'],
      ['CABRAS', 'B314'],
      ['MILIS', 'F208'],
      ['SIMALA', 'I742'],
      ['SIMAXIS', 'I743'],
      ['SINI', 'I749'],
      ['MORGONGIORI', 'F727'],
      ['TRESNURAGHES', 'L393'],
      ['VILLA SANT\'ANTONIO', 'I298'],
      ['TADASUNI', 'L023'],
      ['ALBAGIARA', 'A126'],
      ['SANTU LUSSURGIU', 'I374'],
      ['PAU', 'G379'],
      ['SIAPICCIA', 'I721'],
      ['ASSOLO', 'A477'],
      ['BUSACHI', 'B281'],
      ['BARATILI SAN PIETRO', 'A621'],
      ['ORISTANO', 'G113'],
      ['GONNOSNO\'', 'D585'],
      ['RIOLA SARDO', 'H301'],
      ['NORBELLO', 'F934'],
      ['BARESSA', 'A655'],
      ['FORDONGIANUS', 'D695'],
      ['TERRALBA', 'L122'],
      ['ARBOREA', 'A357'],
      ['ALES', 'A180'],
      ['NUGHEDU SANTA VITTORIA', 'F974'],
      ['BARADILI', 'A614'],
      ['BONARCADO', 'A960'],
      ['SENEGHE', 'I605'],
      ['SENIS', 'I609'],
      ['SAN VERO MILIS', 'I384'],
      ['USELLUS', 'L508'],
      ['ABBASANTA', 'A007'],
      ['POMPU', 'G817'],
      ['CURCURIS', 'D214'],
      ['TRAMATZA', 'L321'],
      ['SAMUGHEO', 'H756'],
      ['SORRADILE', 'I861'],
      ['ZEDDIANI', 'M153'],
      ['SIRIS', 'I757'],
      ['SCANO DI MONTIFERRO', 'I503'],
      ['SODDI\'', 'I778'],
      ['SEDILO', 'I564'],
      ['SIAMANNA', 'I718'],
      ['SIAMAGGIORE', 'I717'],
      ['BAULADU', 'A721'],
      ['BIDONI\'', 'A856'],
      ['RUINAS', 'F271'],
      ['MOGORELLA', 'F270'],
      ['MOGORO', 'F272'],
      ['NEONELI', 'F867'],
      ['VILLAURBANA', 'M030'],
      ['AIDOMAGGIORE', 'A097'],
      ['NARBOLIA', 'F840'],
      ['SANTA GIUSTA', 'I205'],
      ['PAULILATINO', 'G384'],
      ['VILLANOVA TRUSCHEDU', 'L991'],
      ['GONNOSTRAMATZA', 'E088'],
      ['GONNOSCODINA', 'E087'],
      ['SOLARUSSA', 'I791'],
      ['URAS', 'L496'],
      ['ARDAULI', 'A380'],
      ['SENNARIOLO', 'I613'],
      ['VILLA VERDE', 'A609'],
      ['BORONEDDU', 'B055'],
      ['OLLASTRA', 'G043'],
      ['NURECI', 'F985'],
      ['NURACHI', 'F980'],
      ['ASUNI', 'A480'],
      ['SAN NICOLO\' D\'ARCIDANO', 'A368'],
      ['GHILARZA', 'E004'],
      ['ALLAI', 'A204']
    ],
    PA: [
      ['SAN MAURO CASTELVERDE', 'I028'],
      ['VICARI', 'L837'],
      ['CASTELLANA SICULA', 'C135'],
      ['CEFALU\'', 'C421'],
      ['CEFALA\' DIANA', 'C420'],
      ['TRAPPETO', 'L332'],
      ['TRABIA', 'L317'],
      ['CACCAMO', 'B315'],
      ['SCILLATO', 'I538'],
      ['SCIARA', 'I534'],
      ['GANGI', 'D907'],
      ['MISILMERI', 'F246'],
      ['BAUCINA', 'A719'],
      ['CASTELDACCIA', 'C074'],
      ['BALESTRATE', 'A592'],
      ['SAN GIUSEPPE JATO', 'H933'],
      ['CINISI', 'C708'],
      ['BISACQUINO', 'A882'],
      ['CONTESSA ENTELLINA', 'C968'],
      ['PALERMO', 'G273'],
      ['PETRALIA SOTTANA', 'G511'],
      ['PETRALIA SOPRANA', 'G510'],
      ['CIMINNA', 'C696'],
      ['CASTELBUONO', 'C067'],
      ['MARINEO', 'E957'],
      ['ALIA', 'A195'],
      ['CALTAVUTURO', 'B430'],
      ['BOLOGNETTA', 'A946'],
      ['GODRANO', 'E074'],
      ['GIULIANA', 'E055'],
      ['ALTOFONTE', 'A239'],
      ['GERACI SICULO', 'D977'],
      ['GIARDINELLO', 'E013'],
      ['PRIZZI', 'H070'],
      ['FICARAZZI', 'D567'],
      ['SAN CIPIRELLO', 'H797'],
      ['ROCCAMENA', 'H422'],
      ['ROCCAPALUMBA', 'H428'],
      ['CAPACI', 'B645'],
      ['CORLEONE', 'D009'],
      ['MONTEMAGGIORE BELSITO', 'F553'],
      ['LASCARI', 'E459'],
      ['TORRETTA', 'L282'],
      ['MONTELEPRE', 'F544'],
      ['BELMONTE MEZZAGNO', 'A764'],
      ['BAGHERIA', 'A546'],
      ['MEZZOJUSO', 'F184'],
      ['VALLEDOLMO', 'L603'],
      ['CAMPOFELICE DI ROCCELLA', 'B532'],
      ['CAMPOFELICE DI FITALIA', 'B533'],
      ['CAMPOFIORITO', 'B535'],
      ['CERDA', 'C496'],
      ['SANTA CRISTINA GELA', 'I174'],
      ['SCLAFANI BAGNI', 'I541'],
      ['CAMPOREALE', 'B556'],
      ['PARTINICO', 'G348'],
      ['ISOLA DELLE FEMMINE', 'E350'],
      ['VILLAFRATI', 'L951'],
      ['TERRASINI', 'L131'],
      ['VILLABATE', 'L916'],
      ['GRATTERI', 'E149'],
      ['ISNELLO', 'E337'],
      ['TERMINI IMERESE', 'L112'],
      ['CARINI', 'B780'],
      ['PALAZZO ADRIANO', 'G263'],
      ['MONREALE', 'F377'],
      ['BORGETTO', 'A991'],
      ['CASTRONOVO DI SICILIA', 'C344'],
      ['SANTA FLAVIA', 'I188'],
      ['PIANA DEGLI ALBANESI', 'G543'],
      ['USTICA', 'L519'],
      ['BOMPIETRO', 'A958'],
      ['CHIUSA SCLAFANI', 'C654'],
      ['ALTAVILLA MILICIA', 'A229'],
      ['COLLESANO', 'C871'],
      ['POLIZZI GENEROSA', 'G792'],
      ['POLLINA', 'G797'],
      ['VENTIMIGLIA DI SICILIA', 'L740'],
      ['BLUFI', 'M268'],
      ['ALIMINUSA', 'A203'],
      ['ALIMENA', 'A202'],
      ['LERCARA FRIDDI', 'E541']
    ],
    PC: [
      ['CORTE BRUGNATELLA', 'D054'],
      ['ZIANO PIACENTINO', 'L848'],
      ['ZERBA', 'M165'],
      ['ALSENO', 'A223'],
      ['CADEO', 'B332'],
      ['CARPANETO PIACENTINO', 'B812'],
      ['OTTONE', 'G195'],
      ['FIORENZUOLA D\'ARDA', 'D611'],
      ['BESENZONE', 'A823'],
      ['PODENZANO', 'G747'],
      ['MORFASSO', 'F724'],
      ['BORGONOVO VAL TIDONE', 'B025'],
      ['GOSSOLENGO', 'E114'],
      ['ROTTOFRENO', 'H593'],
      ['PECORARA', 'G399'],
      ['CAMINATA', 'B479'],
      ['CERIGNALE', 'C513'],
      ['PONTENURE', 'G852'],
      ['PIACENZA', 'G535'],
      ['PIANELLO VAL TIDONE', 'G557'],
      ['FARINI', 'D502'],
      ['GRAGNANO TREBBIENSE', 'E132'],
      ['SARMATO', 'I434'],
      ['SAN PIETRO IN CERRO', 'G788'],
      ['TRAVO', 'L348'],
      ['VILLANOVA SULL\'ARDA', 'L980'],
      ['VERNASCA', 'L772'],
      ['GAZZOLA', 'D958'],
      ['BOBBIO', 'A909'],
      ['MONTICELLI D\'ONGINA', 'F671'],
      ['CORTEMAGGIORE', 'D061'],
      ['CAORSO', 'B643'],
      ['AGAZZANO', 'A067'],
      ['CASTELL\'ARQUATO', 'C145'],
      ['BETTOLA', 'A831'],
      ['SAN GIORGIO PIACENTINO', 'H887'],
      ['CASTEL SAN GIOVANNI', 'C261'],
      ['NIBBIANO', 'F885'],
      ['CASTELVETRO PIACENTINO', 'C288'],
      ['VIGOLZONE', 'L897'],
      ['RIVERGARO', 'H350'],
      ['GROPPARELLO', 'E196'],
      ['PIOZZANO', 'G696'],
      ['COLI', 'C838'],
      ['PONTE DELL\'OLIO', 'G842'],
      ['CALENDASCO', 'B405'],
      ['LUGAGNANO VAL D\'ARDA', 'E726'],
      ['FERRIERE', 'D555']
    ],
    PD: [
      ['SAN PIETRO VIMINARIO', 'I120'],
      ['VO', 'M103'],
      ['LOREGGIA', 'E684'],
      ['CANDIANA', 'B589'],
      ['SELVAZZANO DENTRO', 'I595'],
      ['SAN PIETRO IN GU', 'I107'],
      ['AGNA', 'A075'],
      ['MASSANZAGO', 'F033'],
      ['FONTANIVA', 'D679'],
      ['SANT\'ELENA', 'I319'],
      ['TORREGLIA', 'L270'],
      ['MASERA\' DI PADOVA', 'F011'],
      ['MASI', 'F013'],
      ['PERNUMIA', 'G461'],
      ['ALBIGNASEGO', 'A161'],
      ['VESCOVANA', 'L805'],
      ['CASALE DI SCODOSIA', 'B877'],
      ['SALETTO', 'H705'],
      ['VILLA DEL CONTE', 'L934'],
      ['BATTAGLIA TERME', 'A714'],
      ['SANT\'URBANO', 'I375'],
      ['MONTEGROTTO TERME', 'F529'],
      ['CAMPODARSEGO', 'B524'],
      ['ARZERGRANDE', 'A458'],
      ['SAN GIORGIO IN BOSCO', 'H897'],
      ['SAN GIORGIO DELLE PERTICHE', 'H893'],
      ['STANGHELLA', 'I938'],
      ['MEGLIADINO SAN FIDENZIO', 'F091'],
      ['MEGLIADINO SAN VITALE', 'F092'],
      ['CASTELBALDO', 'C057'],
      ['VILLAFRANCA PADOVANA', 'L947'],
      ['CAMPOSAMPIERO', 'B563'],
      ['CAMPO SAN MARTINO', 'B564'],
      ['CASALSERUGO', 'B912'],
      ['CONSELVE', 'C964'],
      ['SANT\'ANGELO DI PIOVE DI SACCO', 'I275'],
      ['ARQUA\' PETRARCA', 'A434'],
      ['ARRE', 'A438'],
      ['CARMIGNANO DI BRENTA', 'B795'],
      ['GALLIERA VENETA', 'D879'],
      ['VIGONZA', 'L900'],
      ['BARBONA', 'A637'],
      ['TEOLO', 'L100'],
      ['SAONARA', 'I418'],
      ['CITTADELLA', 'C743'],
      ['BAONE', 'A613'],
      ['VEGGIANO', 'L710'],
      ['PONTELONGO', 'G850'],
      ['PONTE SAN NICOLO\'', 'G855'],
      ['PIOMBINO DESE', 'G688'],
      ['PIACENZA D\'ADIGE', 'G534'],
      ['RUBANO', 'H625'],
      ['ABANO TERME', 'A001'],
      ['TREBASELEGHE', 'L349'],
      ['GAZZO PADOVANO', 'D956'],
      ['MONSELICE', 'F382'],
      ['BOARA PISANI', 'A906'],
      ['CORREZZOLA', 'D040'],
      ['SACCOLONGO', 'H655'],
      ['BOVOLENTA', 'B106'],
      ['CADONEGHE', 'B345'],
      ['VIGHIZZOLO D\'ESTE', 'L878'],
      ['BAGNOLI DI SOPRA', 'A568'],
      ['ANGUILLARA VENETA', 'A296'],
      ['CARTURA', 'B848'],
      ['SANTA MARGHERITA D\'ADIGE', 'I226'],
      ['LIMENA', 'E592'],
      ['CAMPODORO', 'B531'],
      ['TOMBOLO', 'L199'],
      ['GALZIGNANO TERME', 'D889'],
      ['POZZONOVO', 'G963'],
      ['ESTE', 'D442'],
      ['VILLANOVA DI CAMPOSAMPIERO', 'L979'],
      ['TRIBANO', 'L414'],
      ['OSPEDALETTO EUGANEO', 'G167'],
      ['VIGODARZERE', 'L892'],
      ['CERVARESE SANTA CROCE', 'C544'],
      ['BORGORICCO', 'B031'],
      ['CARCERI', 'B749'],
      ['VILLA ESTENSE', 'L937'],
      ['SANTA GIUSTINA IN COLLE', 'I207'],
      ['TERRASSA PADOVANA', 'L132'],
      ['CINTO EUGANEO', 'C713'],
      ['GRANZE', 'E146'],
      ['GRANTORTO', 'E145'],
      ['SOLESINO', 'I799'],
      ['DUE CARRARE', 'M300'],
      ['URBANA', 'L497'],
      ['PIOVE DI SACCO', 'G693'],
      ['MERLARA', 'F148'],
      ['NOVENTA PADOVANA', 'F962'],
      ['ROVOLON', 'H622'],
      ['LEGNARO', 'E515'],
      ['CODEVIGO', 'C812'],
      ['MESTRINO', 'F161'],
      ['BRUGINE', 'B213'],
      ['PADOVA', 'G224'],
      ['LOZZO ATESTINO', 'E709'],
      ['PONSO', 'G823'],
      ['SAN MARTINO DI LUPARI', 'I008'],
      ['POLVERARA', 'G802'],
      ['MONTAGNANA', 'F394'],
      ['PIAZZOLA SUL BRENTA', 'G587'],
      ['CURTAROLO', 'D226']
    ],
    PE: [
      ['CUGNOLI', 'D201'],
      ['CORVARA', 'D078'],
      ['MONTEBELLO DI BERTONA', 'F441'],
      ['SANT\'EUFEMIA A MAIELLA', 'I332'],
      ['BRITTOLI', 'B193'],
      ['MOSCUFO', 'F765'],
      ['ALANNO', 'A120'],
      ['SAN VALENTINO IN ABRUZZO CITERIORE', 'I376'],
      ['PESCARA', 'G482'],
      ['TOCCO DA CASAURIA', 'L186'],
      ['VICOLI', 'L846'],
      ['VILLA CELIERA', 'L922'],
      ['MANOPPELLO', 'E892'],
      ['TORRE DE\' PASSERI', 'L263'],
      ['POPOLI', 'G878'],
      ['SERRAMONACESCA', 'I649'],
      ['CATIGNANO', 'C354'],
      ['BOLOGNANO', 'A945'],
      ['PIANELLA', 'G555'],
      ['FARINDOLA', 'D501'],
      ['ABBATEGGIO', 'A008'],
      ['CEPAGATTI', 'C474'],
      ['LORETO APRUTINO', 'E691'],
      ['ROCCAMORICE', 'H425'],
      ['PENNE', 'G438'],
      ['CARPINETO DELLA NORA', 'B827'],
      ['PIETRANICO', 'G621'],
      ['ROSCIANO', 'H562'],
      ['ELICE', 'D394'],
      ['CAPPELLE SUL TAVO', 'B681'],
      ['SALLE', 'H715'],
      ['CARAMANICO TERME', 'B722'],
      ['PESCOSANSONESCO', 'G499'],
      ['CASTIGLIONE A CASAURIA', 'C308'],
      ['SPOLTORE', 'I922'],
      ['SCAFA', 'I482'],
      ['BUSSI SUL TIRINO', 'B294'],
      ['NOCCIANO', 'F908'],
      ['TURRIVALIGNANI', 'L475'],
      ['LETTOMANOPPELLO', 'E558'],
      ['CIVITAQUANA', 'C771'],
      ['CIVITELLA CASANOVA', 'C779'],
      ['CITTA\' SANT\'ANGELO', 'C750'],
      ['MONTESILVANO', 'F646'],
      ['COLLECORVINO', 'C853'],
      ['PICCIANO', 'G589']
    ],
    PG: [
      ['PIETRALUNGA', 'G618'],
      ['MARSCIANO', 'E975'],
      ['MONTE SANTA MARIA TIBERINA', 'F629'],
      ['FOLIGNO', 'D653'],
      ['VALTOPINA', 'L653'],
      ['TREVI', 'L397'],
      ['CASTEL RITALDI', 'C252'],
      ['CAMPELLO SUL CLITUNNO', 'B504'],
      ['BASTIA UMBRA', 'A710'],
      ['TODI', 'L188'],
      ['SIGILLO', 'I727'],
      ['SAN GIUSTINO', 'H935'],
      ['ASSISI', 'A475'],
      ['PASSIGNANO SUL TRASIMENO', 'G359'],
      ['NOCERA UMBRA', 'F911'],
      ['NORCIA', 'F935'],
      ['TUORO SUL TRASIMENO', 'L466'],
      ['PRECI', 'H015'],
      ['CITTA\' DELLA PIEVE', 'C744'],
      ['CITTA\' DI CASTELLO', 'C745'],
      ['CITERNA', 'C742'],
      ['PACIANO', 'G212'],
      ['FOSSATO DI VICO', 'D745'],
      ['GIANO DELL\'UMBRIA', 'E012'],
      ['FRATTA TODINA', 'D787'],
      ['UMBERTIDE', 'D786'],
      ['CANNARA', 'B609'],
      ['GUALDO CATTANEO', 'E229'],
      ['COLLAZZONE', 'C845'],
      ['SELLANO', 'I585'],
      ['MONTE CASTELLO DI VIBIO', 'F456'],
      ['PIEGARO', 'G601'],
      ['MASSA MARTANA', 'F024'],
      ['DERUTA', 'D279'],
      ['PERUGIA', 'G478'],
      ['MONTEFALCO', 'F492'],
      ['SCHEGGIA E PASCELUPO', 'I522'],
      ['SCHEGGINO', 'I523'],
      ['MONTELEONE DI SPOLETO', 'F540'],
      ['VALLO DI NERA', 'L627'],
      ['GUBBIO', 'E256'],
      ['PANICALE', 'G308'],
      ['BETTONA', 'A832'],
      ['BEVAGNA', 'A835'],
      ['CERRETO DI SPOLETO', 'C527'],
      ['MAGIONE', 'E805'],
      ['CASTIGLIONE DEL LAGO', 'C309'],
      ['SPOLETO', 'I921'],
      ['CASCIA', 'B948'],
      ['POGGIODOMO', 'G758'],
      ['COSTACCIARO', 'D108'],
      ['TORGIANO', 'L216'],
      ['SANT\'ANATOLIA DI NARCO', 'I263'],
      ['SPELLO', 'I888'],
      ['GUALDO TADINO', 'E230'],
      ['CORCIANO', 'C990'],
      ['MONTONE', 'F685'],
      ['LISCIANO NICCONE', 'E613'],
      ['VALFABBRICA', 'L573']
    ],
    PI: [
      ['CASTELFRANCO DI SOTTO', 'C113'],
      ['MONTEVERDI MARITTIMO', 'F661'],
      ['CASCIANA TERME', 'A559'],
      ['LORENZANA', 'E688'],
      ['SAN MINIATO', 'I046'],
      ['CASTELLINA MARITTIMA', 'C174'],
      ['CASALE MARITTIMO', 'B878'],
      ['CASCINA', 'B950'],
      ['SANTA MARIA A MONTE', 'I232'],
      ['BIENTINA', 'A864'],
      ['SANTA LUCE', 'I217'],
      ['PALAIA', 'G254'],
      ['PECCIOLI', 'G395'],
      ['ORCIANO PISANO', 'G090'],
      ['VICOPISANO', 'L850'],
      ['MONTECATINI VAL DI CECINA', 'F458'],
      ['CHIANNI', 'C609'],
      ['LAJATICO', 'E413'],
      ['CAPANNOLI', 'B647'],
      ['LARI', 'E455'],
      ['BUTI', 'B303'],
      ['SAN GIULIANO TERME', 'A562'],
      ['CASTELNUOVO VAL DI CECINA', 'C244'],
      ['CRESPINA', 'D160'],
      ['SANTA CROCE SULL\'ARNO', 'I177'],
      ['RIPARBELLA', 'H319'],
      ['TERRICCIOLA', 'L138'],
      ['PISA', 'G702'],
      ['MONTOPOLI IN VAL D\'ARNO', 'F686'],
      ['VECCHIANO', 'L702'],
      ['PONTEDERA', 'G843'],
      ['VOLTERRA', 'M126'],
      ['FAUGLIA', 'D510'],
      ['GUARDISTALLO', 'E250'],
      ['PONSACCO', 'G822'],
      ['CALCINAIA', 'B392'],
      ['CALCI', 'B390'],
      ['MONTESCUDAIO', 'F640'],
      ['POMARANCE', 'G804']
    ],
    PN: [
      ['FANNA', 'D487'],
      ['FONTANAFREDDA', 'D670'],
      ['AVIANO', 'A516'],
      ['CASTELNOVO DEL FRIULI', 'C217'],
      ['PORDENONE', 'G888'],
      ['PORCIA', 'G886'],
      ['VALVASONE', 'L657'],
      ['ANDREIS', 'A283'],
      ['SAN QUIRINO', 'I136'],
      ['FRISANCO', 'D804'],
      ['ARZENE', 'A456'],
      ['SAN GIORGIO DELLA RICHINVELDA', 'H891'],
      ['PASIANO DI PORDENONE', 'G353'],
      ['BUDOIA', 'B247'],
      ['SAN VITO AL TAGLIAMENTO', 'I403'],
      ['ARBA', 'A354'],
      ['AZZANO DECIMO', 'A530'],
      ['PRAVISDOMINI', 'H010'],
      ['VITO D\'ASIO', 'M085'],
      ['SEQUALS', 'I621'],
      ['PINZANO AL TAGLIAMENTO', 'G680'],
      ['PRATA DI PORDENONE', 'G994'],
      ['SAN MARTINO AL TAGLIAMENTO', 'H999'],
      ['POLCENIGO', 'G780'],
      ['TRAVESIO', 'L347'],
      ['CHIONS', 'C640'],
      ['ERTO E CASSO', 'D426'],
      ['CANEVA', 'B598'],
      ['SACILE', 'H657'],
      ['TRAMONTI DI SOTTO', 'L325'],
      ['TRAMONTI DI SOPRA', 'L324'],
      ['SESTO AL REGHENA', 'I686'],
      ['ZOPPOLA', 'M190'],
      ['CLAUZETTO', 'C791'],
      ['CLAUT', 'C790'],
      ['MORSANO AL TAGLIAMENTO', 'F750'],
      ['MEDUNO', 'F089'],
      ['CASARSA DELLA DELIZIA', 'B940'],
      ['SPILIMBERGO', 'I904'],
      ['MONTEREALE VALCELLINA', 'F596'],
      ['CAVASSO NUOVO', 'C385'],
      ['BARCIS', 'A640'],
      ['FIUME VENETO', 'D621'],
      ['MANIAGO', 'E889'],
      ['CORDOVADO', 'C993'],
      ['CORDENONS', 'C991'],
      ['VIVARO', 'M096'],
      ['CIMOLAIS', 'C699'],
      ['BRUGNERA', 'B215'],
      ['ROVEREDO IN PIANO', 'H609'],
      ['VAJONT', 'M265']
    ],
    PO: [
      ['CARMIGNANO', 'B794'],
      ['PRATO', 'G999'],
      ['VERNIO', 'L775'],
      ['CANTAGALLO', 'B626'],
      ['MONTEMURLO', 'F572'],
      ['POGGIO A CAIANO', 'G754'],
      ['VAIANO', 'L537']
    ],
    PR: [
      ['PELLEGRINO PARMENSE', 'G424'],
      ['SORAGNA', 'I840'],
      ['SORBOLO', 'I845'],
      ['FONTANELLATO', 'D673'],
      ['VARANO DE\' MELEGARI', 'L672'],
      ['SISSA', 'I763'],
      ['BORE', 'A987'],
      ['SALSOMAGGIORE TERME', 'H720'],
      ['COLORNO', 'C904'],
      ['TIZZANO VAL PARMA', 'L183'],
      ['BEDONIA', 'A731'],
      ['NOCETO', 'F914'],
      ['TERENZO', 'E548'],
      ['LESIGNANO DE\' BAGNI', 'E547'],
      ['BORGO VAL DI TARO', 'B042'],
      ['FORNOVO DI TARO', 'D728'],
      ['ROCCABIANCA', 'H384'],
      ['MEZZANI', 'F174'],
      ['MONCHIO DELLE CORTI', 'F340'],
      ['POLESINE PARMENSE', 'G783'],
      ['TRAVERSETOLO', 'L346'],
      ['TORNOLO', 'L229'],
      ['SAN SECONDO PARMENSE', 'I153'],
      ['MONTECHIARUGOLO', 'F473'],
      ['FONTEVIVO', 'D685'],
      ['BERCETO', 'A788'],
      ['PALANZANO', 'G255'],
      ['FELINO', 'D526'],
      ['ZIBELLO', 'M174'],
      ['LANGHIRANO', 'E438'],
      ['CORNIGLIO', 'D026'],
      ['VALMOZZOLA', 'L641'],
      ['ALBARETO', 'A138'],
      ['NEVIANO DEGLI ARDUINI', 'F882'],
      ['MEDESANO', 'F082'],
      ['SOLIGNANO', 'I803'],
      ['COMPIANO', 'C934'],
      ['SALA BAGANZA', 'H682'],
      ['BUSSETO', 'B293'],
      ['VARSI', 'L689'],
      ['BARDI', 'A646'],
      ['PARMA', 'G337'],
      ['FIDENZA', 'B034'],
      ['TRECASALI', 'L354'],
      ['CALESTANO', 'B408'],
      ['TORRILE', 'L299'],
      ['COLLECCHIO', 'C852']
    ],
    PT: [
      ['AGLIANA', 'A071'],
      ['CHIESINA UZZANESE', 'C631'],
      ['PIEVE A NIEVOLE', 'G636'],
      ['QUARRATA', 'H109'],
      ['SAMBUCA PISTOIESE', 'H744'],
      ['SERRAVALLE PISTOIESE', 'I660'],
      ['UZZANO', 'L522'],
      ['PONTE BUGGIANESE', 'G833'],
      ['MONTALE', 'F410'],
      ['MONSUMMANO TERME', 'F384'],
      ['MARLIANA', 'E960'],
      ['CUTIGLIANO', 'D235'],
      ['MASSA E COZZILE', 'F025'],
      ['LAMPORECCHIO', 'E432'],
      ['LARCIANO', 'E451'],
      ['MONTECATINI TERME', 'A561'],
      ['PESCIA', 'G491'],
      ['PISTOIA', 'G713'],
      ['PITEGLIO', 'G715'],
      ['BUGGIANO', 'B251'],
      ['ABETONE', 'A012'],
      ['SAN MARCELLO PISTOIESE', 'H980']
    ],
    PU: [
      ['LUNANO', 'E743'],
      ['SANT\'ANGELO IN VADO', 'I287'],
      ['CANTIANO', 'B636'],
      ['CAGLI', 'B352'],
      ['FANO', 'D488'],
      ['CARPEGNA', 'B816'],
      ['SALTARA', 'H721'],
      ['FRONTINO', 'D807'],
      ['MONTE GRIMANO TERME', 'F524'],
      ['MAIOLO', 'E838'],
      ['URBANIA', 'L498'],
      ['BORGO PACE', 'B026'],
      ['MONTE PORZIO', 'F589'],
      ['MERCATINO CONCA', 'F136'],
      ['NOVAFELTRIA', 'F137'],
      ['MERCATELLO SUL METAURO', 'F135'],
      ['SAN LORENZO IN CAMPO', 'H958'],
      ['BARCHI', 'A639'],
      ['PETRIANO', 'G514'],
      ['PIOBBICO', 'G682'],
      ['PIAGGE', 'G537'],
      ['GABICCE MARE', 'D836'],
      ['FOSSOMBRONE', 'D749'],
      ['FERMIGNANO', 'D541'],
      ['MONDAVIO', 'F347'],
      ['MONDOLFO', 'F348'],
      ['PIANDIMELETO', 'G551'],
      ['MONTECOPIOLO', 'F478'],
      ['MONTECICCARDO', 'F474'],
      ['PENNABILLI', 'G433'],
      ['MONTECALVO IN FOGLIA', 'F450'],
      ['MONTEMAGGIORE AL METAURO', 'F555'],
      ['PEGLIO', 'G416'],
      ['SAN COSTANZO', 'H809'],
      ['CASTELDELCI', 'C080'],
      ['PIETRARUBBIA', 'G627'],
      ['PESARO', 'G479'],
      ['MONTEFELCINO', 'F497'],
      ['AUDITORE', 'A493'],
      ['BELFORTE ALL\'ISAURO', 'A740'],
      ['TAVOLETO', 'L078'],
      ['PERGOLA', 'G453'],
      ['SANT\'IPPOLITO', 'I344'],
      ['CARTOCETO', 'B846'],
      ['SANT\'ANGELO IN LIZZOLA', 'I285'],
      ['TALAMELLO', 'L034'],
      ['MONTELABBATE', 'F533'],
      ['URBINO', 'L500'],
      ['SAN GIORGIO DI PESARO', 'H886'],
      ['GRADARA', 'E122'],
      ['ISOLA DEL PIANO', 'E351'],
      ['SASSOCORVARO', 'I459'],
      ['APECCHIO', 'A327'],
      ['MACERATA FELTRIA', 'E785'],
      ['SERRUNGARINA', 'I670'],
      ['SANT\'AGATA FELTRIA', 'I201'],
      ['MOMBAROCCIO', 'F310'],
      ['SERRA SANT\'ABBONDIO', 'I654'],
      ['SASSOFELTRIO', 'I460'],
      ['FRONTONE', 'D808'],
      ['ORCIANO DI PESARO', 'G089'],
      ['SAN LEO', 'H949'],
      ['COLBORDOLO', 'C830'],
      ['FRATTE ROSA', 'D791'],
      ['ACQUALAGNA', 'A035'],
      ['MONTE CERIGNONE', 'F467'],
      ['TAVULLIA', 'L081']
    ],
    PV: [
      ['CANNETO PAVESE', 'B613'],
      ['BRALLO DI PREGOLA', 'B117'],
      ['MONTEBELLO DELLA BATTAGLIA', 'F440'],
      ['CARBONARA AL TICINO', 'B741'],
      ['MONTECALVO VERSIGGIA', 'F449'],
      ['VOGHERA', 'M109'],
      ['PIETRA DE\' GIORGI', 'G612'],
      ['SOMMO', 'I825'],
      ['CANDIA LOMELLINA', 'B587'],
      ['SEMIANA', 'I599'],
      ['SANNAZZARO DE\' BURGONDI', 'I048'],
      ['CHIGNOLO PO', 'C637'],
      ['ZENEVREDO', 'M162'],
      ['ZERBO', 'M166'],
      ['BEREGUARDO', 'A792'],
      ['BADIA PAVESE', 'A538'],
      ['PIEVE DEL CAIRO', 'G639'],
      ['PIEVE ALBIGNOLA', 'G635'],
      ['VALLE LOMELLINA', 'L593'],
      ['ZERBOLO\'', 'M167'],
      ['CASTELLETTO DI BRANDUZZO', 'C157'],
      ['CORNALE', 'D017'],
      ['SAN DAMIANO AL COLLE', 'H814'],
      ['PIEVE PORTO MORONE', 'G650'],
      ['CASTELNOVETTO', 'C213'],
      ['ROSASCO', 'H559'],
      ['VALVERDE', 'L659'],
      ['PINAROLO PO', 'G671'],
      ['ROGNANO', 'H491'],
      ['MARZANO', 'E999'],
      ['OTTOBIANO', 'G194'],
      ['GAMBOLO\'', 'D901'],
      ['SAN GENESIO ED UNITI', 'H859'],
      ['ZINASCO', 'M180'],
      ['CASSOLNOVO', 'C038'],
      ['LINAROLO', 'E600'],
      ['LIRIO', 'E608'],
      ['DORNO', 'D348'],
      ['VALLE SALIMBENE', 'L617'],
      ['BASTIDA PANCARANA', 'A712'],
      ['BASTIDA DE\' DOSSI', 'A711'],
      ['BATTUDA', 'A718'],
      ['LOMELLO', 'E662'],
      ['CERANOVA', 'C484'],
      ['CASEI GEROLA', 'B954'],
      ['GAMBARANA', 'D892'],
      ['NICORVO', 'F891'],
      ['BASCAPE\'', 'A690'],
      ['TRAVACO\' SICCOMARIO', 'I236'],
      ['SANTA MARGHERITA DI STAFFORA', 'I230'],
      ['BORGO PRIOLO', 'B028'],
      ['CASTEGGIO', 'C053'],
      ['CASTANA', 'C050'],
      ['PIZZALE', 'G720'],
      ['MONTU\' BECCARIA', 'F701'],
      ['CAMPOSPINOSO', 'B567'],
      ['TROMELLO', 'L449'],
      ['TRIVOLZIO', 'L440'],
      ['CERVESINA', 'C551'],
      ['GARLASCO', 'D925'],
      ['SPESSA', 'I894'],
      ['TORRE DE\' NEGRI', 'L262'],
      ['VARZI', 'L690'],
      ['GALLIAVOLA', 'D873'],
      ['GRAVELLONA LOMELLINA', 'E152'],
      ['ZEME', 'M161'],
      ['CASTELLO D\'AGOGNA', 'C184'],
      ['PALESTRO', 'G275'],
      ['CORANA', 'C982'],
      ['ROBBIO', 'H369'],
      ['BARBIANELLO', 'A634'],
      ['BORGARELLO', 'A989'],
      ['CECIMA', 'C414'],
      ['SAN ZENONE AL PO', 'I416'],
      ['TORRE D\'ISOLA', 'L269'],
      ['VIDIGULFO', 'L854'],
      ['VELEZZO LOMELLINA', 'L716'],
      ['PONTE NIZZA', 'G851'],
      ['CILAVEGNA', 'C686'],
      ['CIGOGNOLA', 'C684'],
      ['MEZZANINO', 'F175'],
      ['MEZZANA BIGLI', 'F170'],
      ['MEZZANA RABATTONE', 'F171'],
      ['SIZIANO', 'E265'],
      ['GODIASCO', 'E072'],
      ['TORREVECCHIA PIA', 'L285'],
      ['BOSNASCO', 'B082'],
      ['OLIVA GESSI', 'G032'],
      ['ROVESCALA', 'H614'],
      ['BRONI', 'B201'],
      ['BREME', 'B142'],
      ['GENZONE', 'D973'],
      ['MONTALTO PAVESE', 'F417'],
      ['VAL DI NIZZA', 'L562'],
      ['RETORBIDO', 'H246'],
      ['VILLANOVA D\'ARDENGHI', 'L983'],
      ['LUNGAVILLA', 'B387'],
      ['SCALDASOLE', 'I487'],
      ['SAN CIPRIANO PO', 'H799'],
      ['RUINO', 'H637'],
      ['CANEVINO', 'B599'],
      ['MONTICELLI PAVESE', 'F670'],
      ['CORTEOLONA', 'D067'],
      ['VOLPARA', 'M119'],
      ['CURA CARPIGNANO', 'B824'],
      ['SANTA MARIA DELLA VERSA', 'I237'],
      ['RIVANAZZANO', 'H336'],
      ['LANDRIANO', 'E437'],
      ['LANGOSCO', 'E439'],
      ['VIGEVANO', 'L872'],
      ['MONTESCANO', 'F638'],
      ['PORTALBERA', 'G895'],
      ['ZAVATTARELLO', 'M150'],
      ['ZECCONE', 'M152'],
      ['BELGIOIOSO', 'A741'],
      ['VERRETTO', 'L784'],
      ['VERRUA PO', 'L788'],
      ['LARDIRAGO', 'E454'],
      ['ALBUZZANO', 'A175'],
      ['ALBONESE', 'A171'],
      ['STRADELLA', 'I968'],
      ['RONCARO', 'H527'],
      ['PANCARANA', 'G304'],
      ['CASORATE PRIMO', 'B988'],
      ['MIRADOLO TERME', 'F238'],
      ['MORTARA', 'F754'],
      ['VISTARINO', 'M079'],
      ['ALBAREDO ARNABOLDI', 'A134'],
      ['ROMAGNESE', 'H505'],
      ['MAGHERNO', 'E804'],
      ['FILIGHERA', 'D594'],
      ['SAN MARTINO SICCOMARIO', 'I014'],
      ['CORVINO SAN QUIRICO', 'D081'],
      ['SAN GIORGIO DI LOMELLINA', 'H885'],
      ['SANTA CRISTINA E BISSONE', 'I175'],
      ['MORNICO LOSANA', 'F739'],
      ['MEDE', 'F080'],
      ['ALAGNA', 'A118'],
      ['PARONA', 'G342'],
      ['CASATISMA', 'B945'],
      ['SILVANO PIETRA', 'I739'],
      ['SANT\'ALESSIO CON VIALONE', 'I213'],
      ['COZZO', 'D127'],
      ['CERTOSA DI PAVIA', 'C541'],
      ['TORRAZZA COSTE', 'L237'],
      ['BORGORATTO MORMOROLO', 'B030'],
      ['BORGO SAN SIRO', 'B038'],
      ['CONFIENZA', 'C958'],
      ['COSTA DE\' NOBILI', 'D109'],
      ['TROVO', 'L453'],
      ['SANTA GIULETTA', 'I203'],
      ['PAVIA', 'G388'],
      ['INVERNO E MONTELEONE', 'E310'],
      ['GROPELLO CAIROLI', 'E195'],
      ['SARTIRANA LOMELLINA', 'I447'],
      ['VILLA BISCOSSI', 'L917'],
      ['COPIANO', 'C979'],
      ['ROBECCO PAVESE', 'H375'],
      ['REDAVALLE', 'H216'],
      ['BAGNARIA', 'A550'],
      ['CAVA MANARA', 'C360'],
      ['CERETTO LOMELLINA', 'C508'],
      ['CERGNAGO', 'C509'],
      ['GOLFERENZO', 'E081'],
      ['CASANOVA LONATI', 'B929'],
      ['MENCONICO', 'F122'],
      ['FORTUNAGO', 'D732'],
      ['ROCCA DE\' GIORGI', 'H396'],
      ['CALVIGNANO', 'B447'],
      ['TORRE BERETTI E CASTELLARO', 'L250'],
      ['TORRE D\'ARESE', 'L256'],
      ['BORNASCO', 'B051'],
      ['ARENA PO', 'A387'],
      ['REA', 'H204'],
      ['VALEGGIO', 'L568'],
      ['CODEVILLA', 'C813'],
      ['ROCCA SUSELLA', 'H450'],
      ['SUARDI', 'B014'],
      ['FRASCAROLO', 'D771'],
      ['VELLEZZO BELLINI', 'L720'],
      ['GERENZAGO', 'D980'],
      ['BRESSANA BOTTARONE', 'B159'],
      ['GIUSSAGO', 'E062'],
      ['TORRICELLA VERZATE', 'L292'],
      ['MARCIGNAGO', 'E934'],
      ['OLEVANO DI LOMELLINA', 'G021'],
      ['VILLANTERIO', 'L994'],
      ['SANT\'ANGELO LOMELLINA', 'I276'],
      ['MONTESEGALE', 'F644'],
      ['FERRERA ERBOGNONE', 'D552']
    ],
    PZ: [
      ['RUVO DEL MONTE', 'H646'],
      ['RUOTI', 'H641'],
      ['CARBONE', 'B743'],
      ['CHIAROMONTE', 'C619'],
      ['SATRIANO DI LUCANIA', 'G614'],
      ['PIETRAGALLA', 'G616'],
      ['SANT\'ANGELO LE FRATTE', 'I288'],
      ['MARSICOVETERE', 'E977'],
      ['MARSICO NUOVO', 'E976'],
      ['CANCELLARA', 'B580'],
      ['LAGONEGRO', 'E409'],
      ['CORLETO PERTICARA', 'D010'],
      ['AVIGLIANO', 'A519'],
      ['SAN FELE', 'H831'],
      ['MONTEMILONE', 'F568'],
      ['MISSANELLO', 'F249'],
      ['LAURIA', 'E483'],
      ['LAURENZANA', 'E482'],
      ['TITO', 'L181'],
      ['CASTELSARACENO', 'C271'],
      ['CAMPOMAGGIORE', 'B549'],
      ['TOLVE', 'L197'],
      ['NOEPOLI', 'F917'],
      ['SPINOSO', 'I917'],
      ['ARMENTO', 'A415'],
      ['RIONERO IN VULTURE', 'H307'],
      ['SASSO DI CASTALDA', 'I457'],
      ['RIVELLO', 'H348'],
      ['FORENZA', 'D696'],
      ['ROTONDA', 'H590'],
      ['TERRANOVA DI POLLINO', 'L126'],
      ['GALLICCHIO', 'D876'],
      ['MURO LUCANO', 'F817'],
      ['BARAGIANO', 'A615'],
      ['BANZI', 'A612'],
      ['VENOSA', 'L738'],
      ['SAN MARTINO D\'AGRI', 'H994'],
      ['FRANCAVILLA IN SINNI', 'D766'],
      ['GENZANO DI LUCANIA', 'D971'],
      ['SAN SEVERINO LUCANO', 'I157'],
      ['ACERENZA', 'A020'],
      ['GRUMENTO NOVA', 'E221'],
      ['GINESTRA', 'E033'],
      ['SAN CHIRICO NUOVO', 'H795'],
      ['SAN CHIRICO RAPARO', 'H796'],
      ['ROCCANOVA', 'H426'],
      ['PICERNO', 'G590'],
      ['CASTELGRANDE', 'C120'],
      ['TRAMUTOLA', 'L326'],
      ['VIETRI DI POTENZA', 'L859'],
      ['SAN COSTANTINO ALBANESE', 'H808'],
      ['PIETRAPERTOSA', 'G623'],
      ['SANT\'ARCANGELO', 'I305'],
      ['MASCHITO', 'F006'],
      ['FARDELLA', 'D497'],
      ['VIGGIANO', 'L874'],
      ['VIGGIANELLO', 'L873'],
      ['BELLA', 'A743'],
      ['CASTELMEZZANO', 'C209'],
      ['MONTEMURRO', 'F573'],
      ['PIGNOLA', 'G663'],
      ['LATRONICO', 'E474'],
      ['BRINDISI MONTAGNA', 'B181'],
      ['POTENZA', 'G942'],
      ['RAPONE', 'H187'],
      ['RAPOLLA', 'H186'],
      ['SAVOIA DI LUCANIA', 'H730'],
      ['LAVELLO', 'E493'],
      ['ALBANO DI LUCANIA', 'A131'],
      ['PESCOPAGANO', 'G496'],
      ['FILIANO', 'D593'],
      ['CASTELLUCCIO SUPERIORE', 'C201'],
      ['CERSOSIMO', 'C539'],
      ['EPISCOPIA', 'D414'],
      ['GUARDIA PERTICARA', 'E246'],
      ['NEMOLI', 'F866'],
      ['TRIVIGNO', 'L439'],
      ['MOLITERNO', 'F295'],
      ['ANZI', 'A321'],
      ['BARILE', 'A666'],
      ['SAN PAOLO ALBANESE', 'B906'],
      ['MELFI', 'F104'],
      ['RIPACANDIDA', 'H312'],
      ['OPPIDO LUCANO', 'G081'],
      ['CASTELLUCCIO INFERIORE', 'C199'],
      ['PALAZZO SAN GERVASIO', 'G261'],
      ['CALVERA', 'B443'],
      ['CALVELLO', 'B440'],
      ['CASTRONUOVO DI SANT\'ANDREA', 'C345'],
      ['VAGLIO BASILICATA', 'L532'],
      ['SENISE', 'I610'],
      ['BALVANO', 'A604'],
      ['SARCONI', 'I426'],
      ['ABRIOLA', 'A013'],
      ['TRECCHINA', 'L357'],
      ['ATELLA', 'A482'],
      ['BRIENZA', 'B173'],
      ['PATERNO', 'M269'],
      ['MARATEA', 'E919'],
      ['TEANA', 'L082']
    ],
    RA: [
      ['RUSSI', 'H642'],
      ['BAGNARA DI ROMAGNA', 'A551'],
      ['BRISIGHELLA', 'B188'],
      ['RIOLO TERME', 'H302'],
      ['CERVIA', 'C553'],
      ['CONSELICE', 'C963'],
      ['SOLAROLO', 'I787'],
      ['SANT\'AGATA SUL SANTERNO', 'I196'],
      ['RAVENNA', 'H199'],
      ['LUGO', 'E730'],
      ['CASTEL BOLOGNESE', 'C065'],
      ['MASSA LOMBARDA', 'F029'],
      ['BAGNACAVALLO', 'A547'],
      ['CASOLA VALSENIO', 'B982'],
      ['COTIGNOLA', 'D121'],
      ['FAENZA', 'D458'],
      ['ALFONSINE', 'A191'],
      ['FUSIGNANO', 'D829']
    ],
    RC: [
      ['CANOLO', 'B617'],
      ['GROTTERIA', 'E212'],
      ['CALANNA', 'B379'],
      ['BRANCALEONE', 'B118'],
      ['GIFFONE', 'E025'],
      ['PALMI', 'G288'],
      ['SAN PIETRO DI CARIDA\'', 'I102'],
      ['AGNANA CALABRA', 'A077'],
      ['LAGANADI', 'E402'],
      ['DELIANUOVA', 'D268'],
      ['VARAPODIO', 'L673'],
      ['FEROLETO DELLA CHIESA', 'D545'],
      ['TAURIANOVA', 'L063'],
      ['ROSARNO', 'H558'],
      ['SANT\'EUFEMIA D\'ASPROMONTE', 'I333'],
      ['MARTONE', 'E993'],
      ['SCILLA', 'I537'],
      ['SCIDO', 'I536'],
      ['SAN PROCOPIO', 'I132'],
      ['MAMMOLA', 'E873'],
      ['FIUMARA', 'D619'],
      ['CARAFFA DEL BIANCO', 'B718'],
      ['SANTO STEFANO IN ASPROMONTE', 'I371'],
      ['STIGNANO', 'I955'],
      ['STILO', 'I956'],
      ['SIDERNO', 'I725'],
      ['BIANCO', 'A843'],
      ['STAITI', 'I936'],
      ['RIACE', 'H265'],
      ['PLACANICA', 'G729'],
      ['ANTONIMINA', 'A314'],
      ['REGGIO DI CALABRIA', 'H224'],
      ['SANT\'ALESSIO IN ASPROMONTE', 'I214'],
      ['SAN FERDINANDO', 'M277'],
      ['MELITO DI PORTO SALVO', 'F112'],
      ['MONASTERACE', 'F324'],
      ['SAN LUCA', 'H970'],
      ['PAZZANO', 'G394'],
      ['TERRANOVA SAPPO MINULIO', 'L127'],
      ['PALIZZI', 'G277'],
      ['MOLOCHIO', 'F301'],
      ['SAN LORENZO', 'H959'],
      ['SAMO', 'H013'],
      ['CITTANOVA', 'C747'],
      ['CIMINA\'', 'C695'],
      ['MARINA DI GIOIOSA IONICA', 'E956'],
      ['MONTEBELLO IONICO', 'D746'],
      ['SANT\'AGATA DEL BIANCO', 'I198'],
      ['SEMINARA', 'I600'],
      ['GERACE', 'D975'],
      ['LOCRI', 'D976'],
      ['ROCCAFORTE DEL GRECO', 'H408'],
      ['MAROPATI', 'E968'],
      ['GIOIOSA IONICA', 'E044'],
      ['GIOIA TAURO', 'E041'],
      ['CANDIDONI', 'B591'],
      ['SAN ROBERTO', 'I139'],
      ['ROCCELLA IONICA', 'H456'],
      ['CAMINI', 'B481'],
      ['BENESTARE', 'A780'],
      ['AFRICO', 'A065'],
      ['CARDETO', 'B756'],
      ['ROGHUDI', 'H489'],
      ['SINOPOLI', 'I753'],
      ['SANT\'ILARIO DELLO IONIO', 'I341'],
      ['BAGALADI', 'A544'],
      ['LAUREANA DI BORRELLO', 'E479'],
      ['MOTTA SAN GIOVANNI', 'F779'],
      ['CAMPO CALABRO', 'B516'],
      ['COSOLETO', 'D089'],
      ['SAN GIORGIO MORGETO', 'H889'],
      ['SANTA CRISTINA D\'ASPROMONTE', 'I176'],
      ['VILLA SAN GIOVANNI', 'M018'],
      ['CARERI', 'B766'],
      ['PORTIGLIOLA', 'G905'],
      ['BIVONGI', 'A897'],
      ['CAULONIA', 'C285'],
      ['ANOIA', 'A303'],
      ['BRUZZANO ZEFFIRIO', 'B234'],
      ['CASIGNANA', 'B966'],
      ['PLATI\'', 'G735'],
      ['CONDOFURI', 'C954'],
      ['RIZZICONI', 'H359'],
      ['SAN GIOVANNI DI GERACE', 'H903'],
      ['MELICUCCO', 'F106'],
      ['MELICUCCA\'', 'F105'],
      ['CINQUEFRONDI', 'C710'],
      ['BAGNARA CALABRA', 'A552'],
      ['SERRATA', 'I656'],
      ['OPPIDO MAMERTINA', 'G082'],
      ['ARDORE', 'A385'],
      ['GALATRO', 'D864'],
      ['BOVA', 'B097'],
      ['BOVA MARINA', 'B099'],
      ['BOVALINO', 'B098'],
      ['POLISTENA', 'G791'],
      ['FERRUZZANO', 'D557']
    ],
    RE: [
      ['SAN POLO D\'ENZA', 'I123'],
      ['VIANO', 'L831'],
      ['QUATTRO CASTELLA', 'H122'],
      ['RAMISETO', 'G654'],
      ['CASTELNOVO DI SOTTO', 'C218'],
      ['CASTELNOVO NE\' MONTI', 'C219'],
      ['ALBINEA', 'A162'],
      ['CORREGGIO', 'D037'],
      ['BAGNOLO IN PIANO', 'A573'],
      ['CAMPEGINE', 'B502'],
      ['GATTATICO', 'D934'],
      ['VILLA MINOZZO', 'L969'],
      ['LIGONCHIO', 'E585'],
      ['BUSANA', 'B283'],
      ['REGGIO NELL\'EMILIA', 'H223'],
      ['REGGIOLO', 'H225'],
      ['BAISO', 'A586'],
      ['BORETTO', 'A988'],
      ['TOANO', 'L184'],
      ['SCANDIANO', 'I496'],
      ['RUBIERA', 'H628'],
      ['SAN MARTINO IN RIO', 'I011'],
      ['CANOSSA', 'C669'],
      ['COLLAGNA', 'C840'],
      ['CARPINETI', 'B825'],
      ['CASTELLARANO', 'C141'],
      ['LUZZARA', 'E772'],
      ['CADELBOSCO DI SOPRA', 'B328'],
      ['CAMPAGNOLA EMILIA', 'B499'],
      ['SANT\'ILARIO D\'ENZA', 'I342'],
      ['CAVRIAGO', 'C405'],
      ['POVIGLIO', 'G947'],
      ['RIO SALICETO', 'H298'],
      ['ROLO', 'H500'],
      ['BIBBIANO', 'A850'],
      ['CASINA', 'B967'],
      ['VETTO', 'L815'],
      ['FABBRICO', 'D450'],
      ['NOVELLARA', 'F960'],
      ['VEZZANO SUL CROSTOLO', 'L820'],
      ['GUASTALLA', 'E253'],
      ['BRESCELLO', 'B156'],
      ['CASALGRANDE', 'B893'],
      ['GUALTIERI', 'E232'],
      ['MONTECCHIO EMILIA', 'F463']
    ],
    RG: [
      ['CHIARAMONTE GULFI', 'C612'],
      ['RAGUSA', 'H163'],
      ['SCICLI', 'I535'],
      ['POZZALLO', 'G953'],
      ['COMISO', 'C927'],
      ['ISPICA', 'E366'],
      ['VITTORIA', 'M088'],
      ['GIARRATANA', 'E016'],
      ['MONTEROSSO ALMO', 'F610'],
      ['SANTA CROCE CAMERINA', 'I178'],
      ['ACATE', 'A014'],
      ['MODICA', 'F258']
    ],
    RI: [
      ['MONTEBUONO', 'F446'],
      ['LONGONE SABINO', 'E681'],
      ['CANTALUPO IN SABINA', 'B631'],
      ['CASTEL DI TORA', 'C098'],
      ['TARANO', 'L046'],
      ['VARCO SABINO', 'L676'],
      ['TURANIA', 'G507'],
      ['MICIGLIANO', 'F193'],
      ['RIETI', 'H282'],
      ['BORBONA', 'A981'],
      ['MAGLIANO SABINA', 'E812'],
      ['POZZAGLIA SABINA', 'G951'],
      ['POGGIO MOIANO', 'G764'],
      ['POGGIO NATIVO', 'G765'],
      ['POGGIO MIRTETO', 'G763'],
      ['STIMIGLIANO', 'I959'],
      ['MORRO REATINO', 'F746'],
      ['TOFFIA', 'L189'],
      ['SCANDRIGLIA', 'I499'],
      ['CASPERIA', 'A472'],
      ['ANTRODOCO', 'A315'],
      ['CONCERVIANO', 'C946'],
      ['NESPOLO', 'F876'],
      ['BORGOROSE', 'B008'],
      ['POSTA', 'G934'],
      ['CONTIGLIANO', 'C969'],
      ['CASAPROTA', 'B934'],
      ['PETRELLA SALTO', 'G513'],
      ['CITTAREALE', 'C749'],
      ['CITTADUCALE', 'C746'],
      ['ROCCA SINIBALDA', 'H446'],
      ['PAGANICO SABINO', 'G232'],
      ['MONTASOLA', 'F430'],
      ['MARCETELLI', 'E927'],
      ['FIAMIGNANO', 'D560'],
      ['VACONE', 'L525'],
      ['FRASSO SABINO', 'D785'],
      ['COLLALTO SABINO', 'C841'],
      ['ROCCANTICA', 'H427'],
      ['ORVINIO', 'B595'],
      ['CANTALICE', 'B627'],
      ['SELCI', 'I581'],
      ['FORANO', 'D689'],
      ['FARA IN SABINA', 'D493'],
      ['AMATRICE', 'A258'],
      ['MONTE SAN GIOVANNI IN SABINA', 'F619'],
      ['COLLI SUL VELINO', 'C880'],
      ['MONTENERO SABINO', 'F579'],
      ['TORRI IN SABINA', 'L286'],
      ['MONTELEONE SABINO', 'F541'],
      ['BELMONTE IN SABINA', 'A765'],
      ['CASTELNUOVO DI FARFA', 'C224'],
      ['PESCOROCCHIANO', 'G498'],
      ['POGGIO SAN LORENZO', 'G770'],
      ['LABRO', 'E393'],
      ['POGGIO CATINO', 'G757'],
      ['POGGIO BUSTONE', 'G756'],
      ['COTTANELLO', 'D124'],
      ['CASTEL SANT\'ANGELO', 'C268'],
      ['ASCREA', 'A464'],
      ['RIVODUTRI', 'H354'],
      ['GRECCIO', 'E160'],
      ['CONFIGNI', 'C959'],
      ['MOMPEO', 'F319'],
      ['BORGO VELINO', 'A996'],
      ['LEONESSA', 'E535'],
      ['SALISANO', 'H713'],
      ['MONTOPOLI DI SABINA', 'F687'],
      ['ACCUMOLI', 'A019'],
      ['TORRICELLA IN SABINA', 'L293'],
      ['COLLEVECCHIO', 'C876'],
      ['COLLE DI TORA', 'C857'],
      ['COLLEGIOVE', 'C859']
    ],
    RM: [
      ['SAN POLO DEI CAVALIERI', 'I125'],
      ['CASTEL GANDOLFO', 'C116'],
      ['BRACCIANO', 'B114'],
      ['CIVITELLA SAN PAOLO', 'C784'],
      ['GAVIGNANO', 'D945'],
      ['ROCCA PRIORA', 'H432'],
      ['CANTERANO', 'B635'],
      ['MANDELA', 'B632'],
      ['MARINO', 'E958'],
      ['ZAGAROLO', 'M141'],
      ['LARIANO', 'M207'],
      ['SAMBUCI', 'H745'],
      ['GORGA', 'E091'],
      ['ROIATE', 'H494'],
      ['CASTELNUOVO DI PORTO', 'C237'],
      ['PERCILE', 'G444'],
      ['VALMONTONE', 'L639'],
      ['SANT\'ORESTE', 'I352'],
      ['TORRITA TIBERINA', 'L302'],
      ['RIGNANO FLAMINIO', 'H288'],
      ['MONTEFLAVIO', 'F504'],
      ['MAGLIANO ROMANO', 'E813'],
      ['VALLEPIETRA', 'L611'],
      ['COLONNA', 'C900'],
      ['RIANO', 'H267'],
      ['SEGNI', 'I573'],
      ['TREVIGNANO ROMANO', 'L401'],
      ['TIVOLI', 'L182'],
      ['CERVETERI', 'C552'],
      ['AGOSTA', 'A084'],
      ['ROCCA CANTERANO', 'H387'],
      ['PISONIANO', 'G704'],
      ['NAZZANO', 'F857'],
      ['CASAPE', 'B932'],
      ['GALLICANO NEL LAZIO', 'D875'],
      ['CASTEL SAN PIETRO ROMANO', 'C266'],
      ['FORMELLO', 'D707'],
      ['LANUVIO', 'C767'],
      ['PALESTRINA', 'G274'],
      ['CAMERATA NUOVA', 'B472'],
      ['PONZANO ROMANO', 'G874'],
      ['SANTA MARINELLA', 'I255'],
      ['MORICONE', 'F730'],
      ['MORLUPO', 'F734'],
      ['CERRETO LAZIALE', 'C518'],
      ['VICOVARO', 'L851'],
      ['ARCINAZZO ROMANO', 'A370'],
      ['VELLETRI', 'L719'],
      ['ROCCA SANTO STEFANO', 'H441'],
      ['SUBIACO', 'I992'],
      ['GUIDONIA MONTECELIO', 'E263'],
      ['MONTORIO ROMANO', 'F692'],
      ['FIUMICINO', 'M297'],
      ['JENNE', 'E382'],
      ['MARCELLINA', 'E924'],
      ['ROVIANO', 'H618'],
      ['POLI', 'G784'],
      ['GENZANO DI ROMA', 'D972'],
      ['POMEZIA', 'G811'],
      ['RIOFREDDO', 'H300'],
      ['CIAMPINO', 'M272'],
      ['ALLUMIERE', 'A210'],
      ['ROCCA DI CAVE', 'H401'],
      ['ROCCA DI PAPA', 'H404'],
      ['MANZIANA', 'E900'],
      ['MARANO EQUO', 'E908'],
      ['MAZZANO ROMANO', 'F064'],
      ['FIANO ROMANO', 'D561'],
      ['MONTECOMPATRI', 'F477'],
      ['SACROFANO', 'H658'],
      ['PALOMBARA SABINA', 'G293'],
      ['GROTTAFERRATA', 'E204'],
      ['CARPINETO ROMANO', 'B828'],
      ['CAPENA', 'B649'],
      ['AFFILE', 'A062'],
      ['MONTEROTONDO', 'F611'],
      ['LADISPOLI', 'M212'],
      ['ARDEA', 'M213'],
      ['NEMI', 'F865'],
      ['BELLEGRA', 'A749'],
      ['ANGUILLARA SABAZIA', 'A297'],
      ['CASTEL MADAMA', 'C203'],
      ['SAN CESAREO', 'M295'],
      ['CAPRANICA PRENESTINA', 'B687'],
      ['MONTELIBRETTI', 'F545'],
      ['CAMPAGNANO DI ROMA', 'B496'],
      ['VALLINFREDA', 'L625'],
      ['SANT\'ANGELO ROMANO', 'I284'],
      ['NEROLA', 'F871'],
      ['MONTELANICO', 'F534'],
      ['ALBANO LAZIALE', 'A132'],
      ['ROMA', 'H501'],
      ['TOLFA', 'L192'],
      ['NETTUNO', 'F880'],
      ['ARSOLI', 'A446'],
      ['ARTENA', 'A449'],
      ['CINETO ROMANO', 'C702'],
      ['ANTICOLI CORRADO', 'A309'],
      ['CANALE MONTERANO', 'B576'],
      ['GERANO', 'D978'],
      ['CERVARA DI ROMA', 'C543'],
      ['ANZIO', 'A323'],
      ['MONTE PORZIO CATONE', 'F590'],
      ['ARICCIA', 'A401'],
      ['LICENZA', 'E576'],
      ['FILACCIANO', 'D586'],
      ['MENTANA', 'F127'],
      ['CIVITAVECCHIA', 'C773'],
      ['FONTE NUOVA', 'M309'],
      ['VIVARO ROMANO', 'M095'],
      ['SAN GREGORIO DA SASSOLA', 'H942'],
      ['SAN VITO ROMANO', 'I400'],
      ['SARACINESCO', 'I424'],
      ['FRASCATI', 'D773'],
      ['LABICO', 'E392'],
      ['OLEVANO ROMANO', 'G022'],
      ['CAVE', 'C390'],
      ['GENAZZANO', 'D964'],
      ['CICILIANO', 'C677'],
      ['COLLEFERRO', 'C858'],
      ['ROCCAGIOVINE', 'H411']
    ],
    RN: [
      ['RIMINI', 'H294'],
      ['MONTEFIORE CONCA', 'F502'],
      ['MISANO ADRIATICO', 'F244'],
      ['SALUDECIO', 'H724'],
      ['MONTEGRIDOLFO', 'F523'],
      ['TORRIANA', 'I550'],
      ['RICCIONE', 'H274'],
      ['CATTOLICA', 'C357'],
      ['MONTE COLOMBO', 'F476'],
      ['VERUCCHIO', 'L797'],
      ['CORIANO', 'D004'],
      ['SAN CLEMENTE', 'H801'],
      ['MONDAINO', 'F346'],
      ['SANTARCANGELO DI ROMAGNA', 'I304'],
      ['BELLARIA-IGEA MARINA', 'A747'],
      ['POGGIO BERNI', 'G755'],
      ['SAN GIOVANNI IN MARIGNANO', 'H921'],
      ['MORCIANO DI ROMAGNA', 'F715'],
      ['MONTESCUDO', 'F641'],
      ['GEMMANO', 'D961']
    ],
    RO: [
      ['ADRIA', 'A059'],
      ['GAVELLO', 'D942'],
      ['LOREO', 'E689'],
      ['CANDA', 'B582'],
      ['LUSIA', 'E761'],
      ['BERGANTINO', 'A795'],
      ['BADIA POLESINE', 'A539'],
      ['ROSOLINA', 'H573'],
      ['CEREGNANO', 'C500'],
      ['CASTELNOVO BARIANO', 'C215'],
      ['BAGNOLO DI PO', 'A574'],
      ['PINCARA', 'G673'],
      ['TAGLIO DI PO', 'L026'],
      ['STIENTA', 'I953'],
      ['VILLAMARZANA', 'L967'],
      ['MELARA', 'F095'],
      ['ARQUA\' POLESINE', 'A435'],
      ['BOSARO', 'B069'],
      ['CORBOLA', 'C987'],
      ['LENDINARA', 'E522'],
      ['OCCHIOBELLO', 'F994'],
      ['CALTO', 'B432'],
      ['PONTECCHIO POLESINE', 'G836'],
      ['SAN MARTINO DI VENEZZE', 'H996'],
      ['POLESELLA', 'G782'],
      ['FICAROLO', 'D568'],
      ['FRATTA POLESINE', 'D788'],
      ['CASTELGUGLIELMO', 'C122'],
      ['CASTELMASSA', 'C207'],
      ['PAPOZZE', 'G323'],
      ['GAIBA', 'D855'],
      ['CRESPINO', 'D161'],
      ['GUARDA VENETA', 'E240'],
      ['VILLADOSE', 'L939'],
      ['CANARO', 'B578'],
      ['PORTO VIRO', 'G926'],
      ['PORTO TOLLE', 'G923'],
      ['SAN BELLINO', 'H768'],
      ['SALARA', 'H689'],
      ['COSTA DI ROVIGO', 'D105'],
      ['ARIANO NEL POLESINE', 'A400'],
      ['PETTORAZZA GRIMANI', 'G525'],
      ['ROVIGO', 'H620'],
      ['FRASSINELLE POLESINE', 'D776'],
      ['VILLANOVA MARCHESANA', 'L988'],
      ['VILLANOVA DEL GHEBBO', 'L985'],
      ['TRECENTA', 'L359'],
      ['FIESSO UMBERTIANO', 'D577'],
      ['CENESELLI', 'C461'],
      ['GIACCIANO CON BARUCHELLA', 'E008']
    ],
    SA: [
      ['RUTINO', 'H644'],
      ['BRACIGLIANO', 'B115'],
      ['GIFFONI VALLE PIANA', 'E027'],
      ['GIFFONI SEI CASALI', 'E026'],
      ['ROCCAPIEMONTE', 'H431'],
      ['SAN RUFO', 'I143'],
      ['PELLEZZANO', 'G426'],
      ['LUSTRA', 'E767'],
      ['CAGGIANO', 'B351'],
      ['CELLE DI BULGHERIA', 'C444'],
      ['VIETRI SUL MARE', 'L860'],
      ['MONTESANO SULLA MARCELLANA', 'F625'],
      ['MONTECORVINO PUGLIANO', 'F480'],
      ['MONTECORVINO ROVELLA', 'F481'],
      ['CORLETO MONFORTE', 'D011'],
      ['SANT\'EGIDIO DEL MONTE ALBINO', 'I317'],
      ['SAN PIETRO AL TANAGRO', 'I089'],
      ['STELLA CILENTO', 'G887'],
      ['VALVA', 'L656'],
      ['BELLOSGUARDO', 'A756'],
      ['CASTELNUOVO CILENTO', 'C231'],
      ['CASTELNUOVO DI CONZA', 'C235'],
      ['OTTATI', 'G192'],
      ['PERDIFUMO', 'G447'],
      ['MINORI', 'F223'],
      ['SALERNO', 'H703'],
      ['CASTEL SAN GIORGIO', 'C259'],
      ['MONTEFORTE CILENTO', 'F507'],
      ['ALBANELLA', 'A128'],
      ['MAGLIANO VETERE', 'E814'],
      ['FISCIANO', 'D615'],
      ['BATTIPAGLIA', 'A717'],
      ['SAN VALENTINO TORIO', 'I377'],
      ['ROCCADASPIDE', 'H394'],
      ['LAURITO', 'E486'],
      ['LAURINO', 'E485'],
      ['LAUREANA CILENTO', 'E480'],
      ['CERASO', 'C485'],
      ['CASELLE IN PITTARI', 'B959'],
      ['MAIORI', 'E839'],
      ['PRAIANO', 'G976'],
      ['SIANO', 'I720'],
      ['AMALFI', 'A251'],
      ['ISPANI', 'E365'],
      ['NOCERA INFERIORE', 'F912'],
      ['NOCERA SUPERIORE', 'F913'],
      ['CONCA DEI MARINI', 'C940'],
      ['BARONISSI', 'A674'],
      ['POSTIGLIONE', 'G939'],
      ['SASSANO', 'I451'],
      ['PISCIOTTA', 'G707'],
      ['SAN MANGO PIEMONTE', 'H977'],
      ['SANT\'ANGELO A FASANELLA', 'I278'],
      ['BUCCINO', 'B242'],
      ['MERCATO SAN SEVERINO', 'F138'],
      ['CORBARA', 'C984'],
      ['CAMEROTA', 'B476'],
      ['SERRAMEZZANA', 'I648'],
      ['SANTA MARINA', 'I253'],
      ['ALFANO', 'A186'],
      ['BUONABITACOLO', 'B266'],
      ['SANZA', 'I410'],
      ['RICIGLIANO', 'H277'],
      ['PIAGGINE', 'G538'],
      ['FELITTO', 'D527'],
      ['PAGANI', 'G230'],
      ['CUCCARO VETERE', 'D195'],
      ['CALVANICO', 'B437'],
      ['PONTECAGNANO FAIANO', 'G834'],
      ['RAVELLO', 'H198'],
      ['ALTAVILLA SILENTINA', 'A230'],
      ['CASALETTO SPARTANO', 'B888'],
      ['SAN CIPRIANO PICENTINO', 'H800'],
      ['SARNO', 'I438'],
      ['OLIVETO CITRA', 'G039'],
      ['SAN MARZANO SUL SARNO', 'I019'],
      ['CENTOLA', 'C470'],
      ['TEGGIANO', 'D292'],
      ['FUTANI', 'D832'],
      ['CANNALONGA', 'B608'],
      ['SAN MAURO LA BRUCA', 'I032'],
      ['SAN MAURO CILENTO', 'I031'],
      ['OGLIASTRO CILENTO', 'G011'],
      ['ACERNO', 'A023'],
      ['MONTECORICE', 'F479'],
      ['GIOI', 'E037'],
      ['SICIGNANO DEGLI ALBURNI', 'M253'],
      ['SCAFATI', 'I483'],
      ['SCALA', 'I486'],
      ['SACCO', 'H654'],
      ['PALOMONTE', 'G292'],
      ['CASTELLABATE', 'C125'],
      ['TORTORELLA', 'L306'],
      ['CAPACCIO', 'B644'],
      ['TRAMONTI', 'L323'],
      ['MONTE SAN GIACOMO', 'F618'],
      ['SANT\'ARSENIO', 'I307'],
      ['PERTOSA', 'G476'],
      ['ROSCIGNO', 'H564'],
      ['CAMPAGNA', 'B492'],
      ['AULETTA', 'A495'],
      ['ANGRI', 'A294'],
      ['ROFRANO', 'H485'],
      ['BELLIZZI', 'M294'],
      ['CASALBUONO', 'B868'],
      ['EBOLI', 'D390'],
      ['VALLO DELLA LUCANIA', 'L628'],
      ['STIO', 'I960'],
      ['VIBONATI', 'L835'],
      ['SALVITELLE', 'H732'],
      ['LAVIANO', 'E498'],
      ['ROMAGNANO AL MONTE', 'H503'],
      ['CASTIGLIONE DEL GENOVESI', 'C306'],
      ['CASTEL SAN LORENZO', 'C262'],
      ['MORIGERATI', 'F731'],
      ['CAMPORA', 'B555'],
      ['MOIO DELLA CIVITELLA', 'F278'],
      ['CASTELCIVITA', 'C069'],
      ['AGROPOLI', 'A091'],
      ['ASCEA', 'A460'],
      ['SALA CONSILINA', 'H683'],
      ['TORRACA', 'L233'],
      ['SALENTO', 'H686'],
      ['SAN GIOVANNI A PIRO', 'H907'],
      ['SESSA CILENTO', 'I677'],
      ['ORRIA', 'G121'],
      ['TORCHIARA', 'L212'],
      ['PERITO', 'G455'],
      ['POSITANO', 'G932'],
      ['AQUARA', 'A343'],
      ['CONTRONE', 'C973'],
      ['CONTURSI TERME', 'C974'],
      ['SANTOMENNA', 'I260'],
      ['CAVA DE\' TIRRENI', 'C361'],
      ['PETINA', 'G509'],
      ['TORRE ORSAIA', 'L274'],
      ['SAN GREGORIO MAGNO', 'H943'],
      ['FURORE', 'D826'],
      ['OMIGNANO', 'G063'],
      ['NOVI VELIA', 'F967'],
      ['MONTANO ANTILIA', 'F426'],
      ['VALLE DELL\'ANGELO', 'G540'],
      ['SAPRI', 'I422'],
      ['CETARA', 'C584'],
      ['PADULA', 'G226'],
      ['SERRE', 'I666'],
      ['ATRANI', 'A487'],
      ['ATENA LUCANA', 'A484'],
      ['GIUNGANO', 'E060'],
      ['COLLIANO', 'C879'],
      ['PRIGNANO CILENTO', 'H062'],
      ['CASAL VELINO', 'B895'],
      ['OLEVANO SUL TUSCIANO', 'G023'],
      ['POLLA', 'G793'],
      ['POLLICA', 'G796'],
      ['TRENTINARA', 'L377'],
      ['CICERALE', 'C676'],
      ['ROCCAGLORIOSA', 'H412']
    ],
    SI: [
      ['MONTERONI D\'ARBIA', 'F605'],
      ['CASTELLINA IN CHIANTI', 'C172'],
      ['SAN QUIRICO D\'ORCIA', 'I135'],
      ['SAN GIMIGNANO', 'H875'],
      ['SIENA', 'I726'],
      ['SAN GIOVANNI D\'ASSO', 'H911'],
      ['BUONCONVENTO', 'B269'],
      ['TORRITA DI SIENA', 'L303'],
      ['MURLO', 'F815'],
      ['ABBADIA SAN SALVATORE', 'A006'],
      ['CASTIGLIONE D\'ORCIA', 'C313'],
      ['SOVICILLE', 'I877'],
      ['CHIUSDINO', 'C661'],
      ['CHIUSI', 'C662'],
      ['SAN CASCIANO DEI BAGNI', 'H790'],
      ['COLLE DI VAL D\'ELSA', 'C847'],
      ['MONTICIANO', 'F676'],
      ['CHIANCIANO TERME', 'C608'],
      ['PIENZA', 'G602'],
      ['RADICOFANI', 'H156'],
      ['RADICONDOLI', 'H157'],
      ['RADDA IN CHIANTI', 'H153'],
      ['CASTELNUOVO BERARDENGA', 'C227'],
      ['TREQUANDA', 'L384'],
      ['CETONA', 'C587'],
      ['CASOLE D\'ELSA', 'B984'],
      ['POGGIBONSI', 'G752'],
      ['SINALUNGA', 'A468'],
      ['ASCIANO', 'A461'],
      ['MONTEPULCIANO', 'F592'],
      ['MONTERIGGIONI', 'F598'],
      ['GAIOLE IN CHIANTI', 'D858'],
      ['SARTEANO', 'I445'],
      ['PIANCASTAGNAIO', 'G547'],
      ['MONTALCINO', 'F402'],
      ['RAPOLANO TERME', 'H185']
    ],
    SO: [
      ['VALDIDENTRO', 'L557'],
      ['TOVO DI SANT\'AGATA', 'L316'],
      ['SONDRIO', 'I829'],
      ['SONDALO', 'I828'],
      ['TRAONA', 'L330'],
      ['FORCOLA', 'D694'],
      ['DELEBIO', 'D266'],
      ['ROGOLO', 'H493'],
      ['LIVIGNO', 'E621'],
      ['LANZADA', 'E443'],
      ['TRESIVIO', 'L392'],
      ['CASPOGGIO', 'B993'],
      ['VAL MASINO', 'L638'],
      ['BEMA', 'A777'],
      ['CIVO', 'C785'],
      ['GROSIO', 'E200'],
      ['COLORINA', 'C903'],
      ['BIANZONE', 'A848'],
      ['VERVIO', 'L799'],
      ['DUBINO', 'D377'],
      ['MELLO', 'F115'],
      ['POSTALESIO', 'G937'],
      ['CINO', 'C709'],
      ['APRICA', 'A337'],
      ['GORDONA', 'E090'],
      ['MANTELLO', 'E896'],
      ['VILLA DI CHIAVENNA', 'L907'],
      ['VILLA DI TIRANO', 'L908'],
      ['CASTELLO DELL\'ACQUA', 'C186'],
      ['NOVATE MEZZOLA', 'F956'],
      ['TORRE DI SANTA MARIA', 'L244'],
      ['MADESIMO', 'E342'],
      ['MESE', 'F153'],
      ['BORMIO', 'B049'],
      ['PRATA CAMPORTACCIO', 'G993'],
      ['FUSINE', 'D830'],
      ['GEROLA ALTA', 'D990'],
      ['PIANTEDO', 'G572'],
      ['PIATEDA', 'G576'],
      ['VALDISOTTO', 'L563'],
      ['ANDALO VALTELLINO', 'A273'],
      ['POGGIRIDENTI', 'G431'],
      ['GROSOTTO', 'E201'],
      ['CAIOLO', 'B366'],
      ['BERBENNO DI VALTELLINA', 'A787'],
      ['CEDRASCO', 'C418'],
      ['PEDESINA', 'G410'],
      ['CHIESA IN VALMALENCO', 'C628'],
      ['CHIAVENNA', 'C623'],
      ['SAMOLACO', 'H752'],
      ['TARTANO', 'L056'],
      ['RASURA', 'H192'],
      ['DAZIO', 'D258'],
      ['ALBOSAGGIA', 'A172'],
      ['SAN GIACOMO FILIPPO', 'H868'],
      ['TALAMONA', 'L035'],
      ['CAMPODOLCINO', 'B530'],
      ['CERCINO', 'C493'],
      ['ALBAREDO PER SAN MARCO', 'A135'],
      ['COSIO VALTELLINO', 'D088'],
      ['CHIURO', 'C651'],
      ['SPRIANA', 'I928'],
      ['TIRANO', 'L175'],
      ['MORBEGNO', 'F712'],
      ['FAEDO VALTELLINO', 'D456'],
      ['PIURO', 'G718'],
      ['BUGLIO IN MONTE', 'B255'],
      ['MENAROLA', 'F121'],
      ['SERNIO', 'I636'],
      ['ARDENNO', 'A382'],
      ['CASTIONE ANDEVENNO', 'C325'],
      ['LOVERO', 'E705'],
      ['PONTE IN VALTELLINA', 'G829'],
      ['VALFURVA', 'L576'],
      ['VERCEIA', 'L749'],
      ['MONTAGNA IN VALTELLINA', 'F393'],
      ['MAZZO DI VALTELLINA', 'F070'],
      ['TEGLIO', 'L084']
    ],
    SP: [
      ['AMEGLIA', 'A261'],
      ['MONTEROSSO AL MARE', 'F609'],
      ['CARRODANO', 'B839'],
      ['CARRO', 'B838'],
      ['DEIVA MARINA', 'D265'],
      ['FOLLO', 'D655'],
      ['LA SPEZIA', 'E463'],
      ['LEVANTO', 'E560'],
      ['RIOMAGGIORE', 'H304'],
      ['ARCOLA', 'A373'],
      ['BONASSOLA', 'A961'],
      ['SESTA GODANO', 'E070'],
      ['ROCCHETTA DI VARA', 'H461'],
      ['CALICE AL CORNOVIGLIO', 'B410'],
      ['VERNAZZA', 'L774'],
      ['ZIGNAGO', 'M177'],
      ['RICCO\' DEL GOLFO DI SPEZIA', 'H275'],
      ['MAISSANA', 'E842'],
      ['PIGNONE', 'G664'],
      ['SANTO STEFANO DI MAGRA', 'I363'],
      ['BEVERINO', 'A836'],
      ['CASTELNUOVO MAGRA', 'C240'],
      ['ORTONOVO', 'G143'],
      ['PORTOVENERE', 'G925'],
      ['VEZZANO LIGURE', 'L819'],
      ['SARZANA', 'I449'],
      ['BORGHETTO DI VARA', 'A992'],
      ['FRAMURA', 'D758'],
      ['VARESE LIGURE', 'L681'],
      ['BRUGNATO', 'B214'],
      ['BOLANO', 'A932'],
      ['LERICI', 'E542']
    ],
    SR: [
      ['ROSOLINI', 'H574'],
      ['BUSCEMI', 'B287'],
      ['SOLARINO', 'I785'],
      ['PACHINO', 'G211'],
      ['FERLA', 'D540'],
      ['FRANCOFONTE', 'D768'],
      ['PRIOLO GARGALLO', 'M279'],
      ['PORTOPALO DI CAPO PASSERO', 'M257'],
      ['AVOLA', 'A522'],
      ['SORTINO', 'I864'],
      ['AUGUSTA', 'A494'],
      ['CASSARO', 'C006'],
      ['BUCCHERI', 'B237'],
      ['MELILLI', 'F107'],
      ['CARLENTINI', 'B787'],
      ['NOTO', 'F943'],
      ['PALAZZOLO ACREIDE', 'G267'],
      ['LENTINI', 'E532'],
      ['SIRACUSA', 'I754'],
      ['CANICATTINI BAGNI', 'B603'],
      ['FLORIDIA', 'D636']
    ],
    SS: [
      ['LUOGOSANTO', 'E747'],
      ['CALANGIANUS', 'B378'],
      ['MONTI', 'F667'],
      ['CHIARAMONTI', 'C613'],
      ['BORTIGIADAS', 'B063'],
      ['SEMESTENE', 'I598'],
      ['LAERRU', 'E401'],
      ['SANTA TERESA GALLURA', 'I312'],
      ['LA MADDALENA', 'E425'],
      ['MONTELEONE ROCCA DORIA', 'F542'],
      ['ANELA', 'A287'],
      ['MARTIS', 'E992'],
      ['BESSUDE', 'A827'],
      ['CASTELSARDO', 'C272'],
      ['ARZACHENA', 'A453'],
      ['OSILO', 'G156'],
      ['OSCHIRI', 'G153'],
      ['PATTADA', 'G376'],
      ['TISSI', 'L180'],
      ['PUTIFIGARI', 'H095'],
      ['PLOAGHE', 'G740'],
      ['TRINITA\' D\'AGULTU E VIGNOLA', 'L428'],
      ['OSSI', 'G178'],
      ['ALGHERO', 'A192'],
      ['SASSARI', 'I452'],
      ['MUROS', 'F818'],
      ['PALAU', 'G258'],
      ['TULA', 'L464'],
      ['BUDDUSO\'', 'B246'],
      ['BULTEI', 'B264'],
      ['BULZI', 'B265'],
      ['BORUTTA', 'B064'],
      ['ARDARA', 'A379'],
      ['NULE', 'F976'],
      ['NULVI', 'F977'],
      ['NUGHEDU SAN NICOLO\'', 'F975'],
      ['CARGEGHE', 'B772'],
      ['ALA\' DEI SARDI', 'A115'],
      ['ERULA', 'M292'],
      ['STINTINO', 'M290'],
      ['USINI', 'L509'],
      ['URI', 'L503'],
      ['MORES', 'F721'],
      ['GIAVE', 'E019'],
      ['GOLFO ARANCI', 'M274'],
      ['LOIRI PORTO SAN PAOLO', 'M275'],
      ['SANT\'ANTONIO DI GALLURA', 'M276'],
      ['MARA', 'E902'],
      ['OLBIA', 'G015'],
      ['BONO', 'A977'],
      ['BONNANARO', 'A976'],
      ['VIDDALBA', 'M259'],
      ['TEMPIO PAUSANIA', 'L093'],
      ['LURAS', 'E752'],
      ['CHEREMULE', 'C600'],
      ['BERCHIDDA', 'A789'],
      ['BENETUTTI', 'A781'],
      ['AGGIUS', 'A069'],
      ['BADESI', 'M214'],
      ['SORSO', 'I863'],
      ['PERFUGAS', 'G450'],
      ['AGLIENTU', 'H848'],
      ['ILLORAI', 'E285'],
      ['VALLEDORIA', 'L604'],
      ['SEDINI', 'I565'],
      ['ROMANA', 'H507'],
      ['POZZOMAGGIORE', 'G962'],
      ['ESPORLATU', 'D441'],
      ['TERGU', 'M282'],
      ['SILIGO', 'I732'],
      ['TORRALBA', 'L235'],
      ['ITTIRI', 'E377'],
      ['ITTIREDDU', 'E376'],
      ['THIESI', 'L158'],
      ['BOTTIDDA', 'B094'],
      ['PORTO TORRES', 'G924'],
      ['COSSOINE', 'D100'],
      ['PADRU', 'M301'],
      ['BURGOS', 'B276'],
      ['OZIERI', 'G203'],
      ['SENNORI', 'I614'],
      ['BONORVA', 'A978'],
      ['BANARI', 'A606'],
      ['CODRONGIANOS', 'C818'],
      ['OLMEDO', 'G046'],
      ['PADRIA', 'G225'],
      ['VILLANOVA MONTELEONE', 'L989'],
      ['SANTA MARIA COGHINAS', 'M284'],
      ['FLORINAS', 'D637'],
      ['TELTI', 'L088']
    ],
    SV: [
      ['TOVO SAN GIACOMO', 'L315'],
      ['PALLARE', 'G281'],
      ['QUILIANO', 'H126'],
      ['CELLE LIGURE', 'C443'],
      ['BERGEGGI', 'A796'],
      ['FINALE LIGURE', 'D600'],
      ['DEGO', 'D264'],
      ['ALBISSOLA MARINA', 'A165'],
      ['ALBISOLA SUPERIORE', 'A166'],
      ['VEZZI PORTIO', 'L823'],
      ['ALBENGA', 'A145'],
      ['MIOGLIA', 'F226'],
      ['ALASSIO', 'A122'],
      ['MAGLIOLO', 'E816'],
      ['GARLENDA', 'D927'],
      ['CASTELVECCHIO DI ROCCA BARBENA', 'C276'],
      ['RIALTO', 'H266'],
      ['OSIGLIA', 'G155'],
      ['COSSERIA', 'D095'],
      ['PLODIO', 'G741'],
      ['BORGIO VEREZZI', 'B005'],
      ['CERIALE', 'C510'],
      ['BORMIDA', 'B048'],
      ['ONZO', 'G076'],
      ['MURIALDO', 'F813'],
      ['ORCO FEGLINO', 'D522'],
      ['VENDONE', 'L730'],
      ['BALESTRINO', 'A593'],
      ['CALIZZANO', 'B416'],
      ['VADO LIGURE', 'L528'],
      ['SAVONA', 'I480'],
      ['ANDORA', 'A278'],
      ['ERLI', 'D424'],
      ['MASSIMINO', 'F046'],
      ['CAIRO MONTENOTTE', 'B369'],
      ['CASTELBIANCO', 'C063'],
      ['PIETRA LIGURE', 'G605'],
      ['VARAZZE', 'L675'],
      ['LAIGUEGLIA', 'E414'],
      ['URBE', 'L499'],
      ['MILLESIMO', 'F213'],
      ['CISANO SUL NEVA', 'C729'],
      ['MALLARE', 'E860'],
      ['ZUCCARELLO', 'M197'],
      ['STELLA', 'I946'],
      ['STELLANELLO', 'I947'],
      ['ORTOVERO', 'G144'],
      ['TOIRANO', 'L190'],
      ['LOANO', 'E632'],
      ['VILLANOVA D\'ALBENGA', 'L975'],
      ['SPOTORNO', 'I926'],
      ['ALTARE', 'A226'],
      ['TESTICO', 'L152'],
      ['CARCARE', 'B748'],
      ['NASINO', 'F847'],
      ['SASSELLO', 'I453'],
      ['NOLI', 'F926'],
      ['BARDINETO', 'A647'],
      ['ARNASCO', 'A422'],
      ['CASANOVA LERRONE', 'B927'],
      ['PONTINVREA', 'G866'],
      ['BORGHETTO SANTO SPIRITO', 'A999'],
      ['PIANA CRIXIA', 'G542'],
      ['ROCCAVIGNALE', 'H452'],
      ['CALICE LIGURE', 'B409'],
      ['GIUSTENICE', 'E064'],
      ['GIUSVALLA', 'E066'],
      ['CENGIO', 'C463'],
      ['BOISSANO', 'A931']
    ],
    TA: [
      ['CASTELLANETA', 'C136'],
      ['TARANTO', 'L049'],
      ['AVETRANA', 'A514'],
      ['MANDURIA', 'E882'],
      ['SAVA', 'I467'],
      ['MARUGGIO', 'E995'],
      ['MOTTOLA', 'F784'],
      ['MONTEMESOLA', 'F563'],
      ['LATERZA', 'E469'],
      ['CRISPIANO', 'D171'],
      ['PALAGIANELLO', 'G251'],
      ['PALAGIANO', 'G252'],
      ['MONTEPARANO', 'F587'],
      ['FAGGIANO', 'D463'],
      ['PULSANO', 'H090'],
      ['SAN MARZANO DI SAN GIUSEPPE', 'I018'],
      ['ROCCAFORZATA', 'H409'],
      ['GINOSA', 'E036'],
      ['GROTTAGLIE', 'E205'],
      ['MASSAFRA', 'F027'],
      ['CAROSINO', 'B808'],
      ['LIZZANO', 'E630'],
      ['STATTE', 'M298'],
      ['MONTEIASI', 'F531'],
      ['SAN GIORGIO IONICO', 'H882'],
      ['MARTINA FRANCA', 'E986'],
      ['LEPORANO', 'E537'],
      ['FRAGAGNANO', 'D754'],
      ['TORRICELLA', 'L294']
    ],
    TE: [
      ['CELLINO ATTANASIO', 'C449'],
      ['TOSSICIA', 'L314'],
      ['CIVITELLA DEL TRONTO', 'C781'],
      ['CORTINO', 'D076'],
      ['VALLE CASTELLANA', 'L597'],
      ['FANO ADRIANO', 'D489'],
      ['SILVI', 'I741'],
      ['MOSCIANO SANT\'ANGELO', 'F764'],
      ['MONTEFINO', 'F500'],
      ['CROGNALETO', 'D179'],
      ['ALBA ADRIATICA', 'A125'],
      ['COLONNELLA', 'C901'],
      ['MORRO D\'ORO', 'F747'],
      ['ISOLA DEL GRAN SASSO D\'ITALIA', 'E343'],
      ['BASCIANO', 'A692'],
      ['TORANO NUOVO', 'L207'],
      ['BISENTI', 'A885'],
      ['ROSETO DEGLI ABRUZZI', 'F585'],
      ['PINETO', 'F831'],
      ['CERMIGNANO', 'C517'],
      ['TERAMO', 'L103'],
      ['GIULIANOVA', 'E058'],
      ['ROCCA SANTA MARIA', 'H440'],
      ['MONTORIO AL VOMANO', 'F690'],
      ['COLLEDARA', 'C311'],
      ['CORROPOLI', 'D043'],
      ['ANCARANO', 'A270'],
      ['CASTELLALTO', 'C128'],
      ['PENNA SANT\'ANDREA', 'G437'],
      ['TORTORETO', 'L307'],
      ['PIETRACAMELA', 'G608'],
      ['CANZANO', 'B640'],
      ['SANT\'EGIDIO ALLA VIBRATA', 'I318'],
      ['CASTELLI', 'C169'],
      ['BELLANTE', 'A746'],
      ['MARTINSICURO', 'E989'],
      ['SANT\'OMERO', 'I348'],
      ['CAMPLI', 'B515'],
      ['NERETO', 'F870'],
      ['ARSITA', 'A445'],
      ['CASTEL CASTAGNA', 'C040'],
      ['CASTIGLIONE MESSER RAIMONDO', 'C316'],
      ['CONTROGUERRA', 'C972'],
      ['NOTARESCO', 'F942'],
      ['CASTILENTI', 'C322'],
      ['ATRI', 'A488'],
      ['TORRICELLA SICURA', 'L295']
    ],
    TN: [
      ['VALDA', 'L550'],
      ['SANT\'ORSOLA TERME', 'I354'],
      ['VERMIGLIO', 'L769'],
      ['BERSONE', 'A808'],
      ['BOCENAGO', 'A916'],
      ['AMBLAR', 'A260'],
      ['CUNEVO', 'D206'],
      ['SAN MICHELE ALL\'ADIGE', 'I042'],
      ['PELUGO', 'G429'],
      ['PELLIZZANO', 'G428'],
      ['TERZOLAS', 'L145'],
      ['BREGUZZO', 'B135'],
      ['GARNIGA TERME', 'D928'],
      ['CADERZONE', 'B335'],
      ['ZAMBANA', 'M142'],
      ['PIEVE TESINO', 'G656'],
      ['CASTELNUOVO', 'C216'],
      ['DAONE', 'D248'],
      ['DAMBEL', 'D246'],
      ['DAIANO', 'D243'],
      ['TASSULLO', 'L060'],
      ['VERVO\'', 'L800'],
      ['RONZONE', 'H552'],
      ['MALE\'', 'E850'],
      ['RAGOLI', 'H162'],
      ['FOLGARIA', 'D651'],
      ['LIVO', 'E624'],
      ['CAPRIANA', 'B697'],
      ['RONCHI VALSUGANA', 'H532'],
      ['RABBI', 'H146'],
      ['SIROR', 'I760'],
      ['LUSERNA', 'E757'],
      ['STREMBO', 'I975'],
      ['STRIGNO', 'I979'],
      ['CARZANO', 'B856'],
      ['LASINO', 'E461'],
      ['ROMENO', 'H517'],
      ['CAVALESE', 'C372'],
      ['CASTELLO TESINO', 'C194'],
      ['DORSINO', 'D349'],
      ['POZZA DI FASSA', 'G950'],
      ['BESENELLO', 'A821'],
      ['SEGONZANO', 'I576'],
      ['CAMPODENNO', 'B525'],
      ['DRENA', 'D365'],
      ['MOENA', 'F263'],
      ['BEZZECCA', 'A839'],
      ['BEDOLLO', 'A730'],
      ['RONCEGNO', 'H528'],
      ['MORI', 'F728'],
      ['SCURELLE', 'I554'],
      ['VILLA RENDENA', 'M006'],
      ['BASELGA DI PINE\'', 'A694'],
      ['OSSANA', 'G173'],
      ['AVIO', 'A520'],
      ['VIGNOLA FALESINA', 'L886'],
      ['DIMARO', 'D302'],
      ['TIARNO DI SOTTO', 'L163'],
      ['TIARNO DI SOPRA', 'L162'],
      ['MOLINA DI LEDRO', 'F286'],
      ['DRO', 'D371'],
      ['BIENO', 'A863'],
      ['CONCEI', 'C944'],
      ['CIMEGO', 'C694'],
      ['LEVICO TERME', 'E565'],
      ['TON', 'L200'],
      ['TONADICO', 'L201'],
      ['TESERO', 'L147'],
      ['BORGO VALSUGANA', 'B006'],
      ['GRIGNO', 'E178'],
      ['NAVE SAN ROCCO', 'F853'],
      ['FAI DELLA PAGANELLA', 'D468'],
      ['SPIAZZO', 'I899'],
      ['TERRAGNOLO', 'L121'],
      ['VATTARO', 'L697'],
      ['VIGO RENDENA', 'L903'],
      ['GRAUNO', 'E150'],
      ['CASTEL CONDINO', 'C183'],
      ['CASTELLO-MOLINA DI FIEMME', 'C189'],
      ['NANNO', 'F837'],
      ['NAGO-TORBOLE', 'F835'],
      ['MOLVENO', 'F307'],
      ['TERLAGO', 'L107'],
      ['SANZENO', 'I411'],
      ['PREDAZZO', 'H018'],
      ['ARCO', 'A372'],
      ['PADERGNONE', 'G214'],
      ['BONDONE', 'A968'],
      ['BONDO', 'A967'],
      ['PINZOLO', 'G681'],
      ['MEZZANO', 'F176'],
      ['PREORE', 'H039'],
      ['LAVIS', 'E500'],
      ['RUMO', 'H639'],
      ['MONCLASSICO', 'F341'],
      ['ALA', 'A116'],
      ['PREZZO', 'H057'],
      ['SARNONICO', 'I439'],
      ['ROVERETO', 'H612'],
      ['CAVIZZANA', 'C400'],
      ['MAZZIN', 'F068'],
      ['FIAVE\'', 'D565'],
      ['CEMBRA', 'C452'],
      ['CASTELFONDO', 'C103'],
      ['GRUMES', 'E222'],
      ['CALAVINO', 'B386'],
      ['CALCERANICA AL LAGO', 'B389'],
      ['BLEGGIO SUPERIORE', 'A902'],
      ['BLEGGIO INFERIORE', 'A901'],
      ['ANDALO', 'A274'],
      ['SORAGA', 'I839'],
      ['RUFFRE\'', 'H634'],
      ['MASSIMENO', 'F045'],
      ['TELVE DI SOPRA', 'L090'],
      ['TENNO', 'L097'],
      ['TENNA', 'L096'],
      ['PALU\' DEL FERSINA', 'G296'],
      ['CAGNO\'', 'B360'],
      ['CALLIANO', 'B419'],
      ['LONA LASES', 'E664'],
      ['VOLANO', 'M113'],
      ['VARENA', 'L678'],
      ['PEJO', 'G419'],
      ['TRAMBILENO', 'L322'],
      ['TRANSACQUA', 'L329'],
      ['FONDO', 'D663'],
      ['ZIANO DI FIEMME', 'M173'],
      ['SAMONE', 'H754'],
      ['SOVER', 'I871'],
      ['DENNO', 'D273'],
      ['VALLARSA', 'L588'],
      ['PIEVE DI BONO', 'G641'],
      ['PIEVE DI LEDRO', 'G644'],
      ['VEZZANO', 'L821'],
      ['ROVERE\' DELLA LUNA', 'H607'],
      ['DARE\'', 'D250'],
      ['ALDENO', 'A178'],
      ['RONCONE', 'H545'],
      ['PERGINE VALSUGANA', 'G452'],
      ['CIS', 'C727'],
      ['STORO', 'I964'],
      ['CAMPITELLO DI FASSA', 'B514'],
      ['VIGOLO VATTARO', 'L896'],
      ['TRES', 'L385'],
      ['IMER', 'E288'],
      ['ALBIANO', 'A158'],
      ['PANCHIA\'', 'G305'],
      ['MALOSCO', 'E866'],
      ['BRENTONICO', 'B153'],
      ['MEZZOLOMBARDO', 'F187'],
      ['MEZZOCORONA', 'F183'],
      ['BRIONE', 'B185'],
      ['ZUCLO', 'M198'],
      ['CARANO', 'B723'],
      ['SMARANO', 'I772'],
      ['CLES', 'C794'],
      ['CLOZ', 'C797'],
      ['STENICO', 'I949'],
      ['LAVARONE', 'E492'],
      ['TAIO', 'L033'],
      ['ROMALLO', 'H506'],
      ['SFRUZ', 'I714'],
      ['LOMASO', 'E658'],
      ['SPORMAGGIORE', 'I924'],
      ['SPORMINORE', 'I925'],
      ['LARDARO', 'E452'],
      ['OSPEDALETTO', 'G168'],
      ['CIMONE', 'C700'],
      ['TIONE DI TRENTO', 'L174'],
      ['VILLA LAGARINA', 'L957'],
      ['COMMEZZADURA', 'C931'],
      ['RIVA DEL GARDA', 'H330'],
      ['REVO\'', 'H254'],
      ['CANAZEI', 'B579'],
      ['CANAL SAN BOVO', 'B577'],
      ['VIGO DI FASSA', 'L893'],
      ['IVANO FRACENA', 'E378'],
      ['DON', 'D336'],
      ['FIERA DI PRIMIERO', 'D572'],
      ['CONDINO', 'C953'],
      ['TUENNO', 'L457'],
      ['CAVARENO', 'C380'],
      ['TORCEGNO', 'L211'],
      ['TERRES', 'L137'],
      ['FAEDO', 'D457'],
      ['FORNACE', 'D714'],
      ['CINTE TESINO', 'C712'],
      ['VILLA AGNEDO', 'L910'],
      ['NOMI', 'F929'],
      ['NOGAREDO', 'F920'],
      ['SAN LORENZO IN BANALE', 'H966'],
      ['SPERA', 'I889'],
      ['ISERA', 'E334'],
      ['BOSENTINO', 'B078'],
      ['CARISOLO', 'B783'],
      ['RONZO-CHIENIS', 'M303'],
      ['NOVALEDO', 'F947'],
      ['COREDO', 'C994'],
      ['PRASO', 'G989'],
      ['MONTAGNE', 'F396'],
      ['CIVEZZANO', 'C756'],
      ['GIOVO', 'E048'],
      ['MEZZANA', 'F168'],
      ['LISIGNAGO', 'E614'],
      ['FAVER', 'D516'],
      ['FRASSILONGO', 'D775'],
      ['CROVIANA', 'D188'],
      ['CALDONAZZO', 'B404'],
      ['CALDES', 'B400'],
      ['BRESIMO', 'B158'],
      ['GIUSTINO', 'E065'],
      ['FLAVON', 'D631'],
      ['FIEROZZO', 'D573'],
      ['VALFLORIANA', 'L575'],
      ['SAGRON MIS', 'H666'],
      ['CENTA SAN NICOLO\'', 'C467'],
      ['TRENTO', 'L378'],
      ['CAVEDINE', 'C393'],
      ['CAVEDAGO', 'C392'],
      ['POMAROLO', 'G808'],
      ['BOLBENO', 'A933'],
      ['BREZ', 'B165'],
      ['TELVE', 'L089']
    ],
    TO: [
      ['VAL DELLA TORRE', 'L555'],
      ['SAN MAURIZIO CANAVESE', 'I024'],
      ['SAN PONSO', 'I126'],
      ['VIALFRE\'', 'L830'],
      ['GRUGLIASCO', 'E216'],
      ['ALBIANO D\'IVREA', 'A157'],
      ['BOBBIO PELLICE', 'A910'],
      ['CHIANOCCO', 'C610'],
      ['GIAVENO', 'E020'],
      ['SAN CARLO CANAVESE', 'H789'],
      ['LORANZE\'', 'E683'],
      ['MATTIE', 'F058'],
      ['MATHI', 'F053'],
      ['CUORGNE\'', 'D208'],
      ['CUMIANA', 'D202'],
      ['CANDIA CANAVESE', 'B588'],
      ['CANTOIRA', 'B637'],
      ['AGLIE\'', 'A074'],
      ['CASTELLAMONTE', 'C133'],
      ['TRAUSELLA', 'L338'],
      ['LUSIGLIE\'', 'E763'],
      ['CAFASSE', 'B350'],
      ['QUINCINETTO', 'H127'],
      ['QUASSOLO', 'H120'],
      ['SESTRIERE', 'I692'],
      ['FIORANO CANAVESE', 'D608'],
      ['ALPIGNANO', 'A222'],
      ['QUAGLIUZZO', 'H100'],
      ['MASSELLO', 'F041'],
      ['AVIGLIANA', 'A518'],
      ['CERESOLE REALE', 'C505'],
      ['SPARONE', 'I886'],
      ['ROBASSOMERO', 'H367'],
      ['LA LOGGIA', 'E423'],
      ['TAVAGNASCO', 'L066'],
      ['PEROSA ARGENTINA', 'G463'],
      ['PEROSA CANAVESE', 'G462'],
      ['PERRERO', 'G465'],
      ['RORA\'', 'H554'],
      ['ROURE', 'H555'],
      ['PINO TORINESE', 'G678'],
      ['PINEROLO', 'G674'],
      ['PINASCA', 'G672'],
      ['ROLETTO', 'H498'],
      ['ANDRATE', 'A282'],
      ['GROSCAVALLO', 'E199'],
      ['LANZO TORINESE', 'E445'],
      ['SCIOLZE', 'I539'],
      ['SAN RAFFAELE CIMENA', 'I137'],
      ['OULX', 'G196'],
      ['RONCO CANAVESE', 'H539'],
      ['SANGANO', 'H855'],
      ['CARAVINO', 'B733'],
      ['STRAMBINO', 'I970'],
      ['SCARMAGNO', 'I511'],
      ['ROMANO CANAVESE', 'H511'],
      ['MAGLIONE', 'E817'],
      ['SAUZE D\'OULX', 'I466'],
      ['SETTIMO ROTTARO', 'I701'],
      ['SETTIMO VITTONE', 'I702'],
      ['SETTIMO TORINESE', 'I703'],
      ['SAN GILLIO', 'H873'],
      ['GERMAGNANO', 'D983'],
      ['FRONT', 'D805'],
      ['LAURIANO', 'E484'],
      ['VIRLE PIEMONTE', 'M069'],
      ['VINOVO', 'M060'],
      ['CERCENASCO', 'C487'],
      ['GASSINO TORINESE', 'D933'],
      ['AIRASCA', 'A109'],
      ['OSASIO', 'G152'],
      ['OSASCO', 'G151'],
      ['CASELETTE', 'B955'],
      ['CASCINETTE D\'IVREA', 'B953'],
      ['COSSANO CANAVESE', 'D092'],
      ['PRALORMO', 'G979'],
      ['PRALI', 'G978'],
      ['PRAGELATO', 'G973'],
      ['SAN GIORGIO CANAVESE', 'H890'],
      ['LOMBRIASCO', 'E661'],
      ['LOMBARDORE', 'E660'],
      ['BEINASCO', 'A734'],
      ['BALME', 'A599'],
      ['SAN GIUSTO CANAVESE', 'H936'],
      ['VILLARBASSE', 'M002'],
      ['VILLAR FOCCHIARDO', 'M007'],
      ['VILLAREGGIA', 'M004'],
      ['ISSIGLIO', 'E368'],
      ['BUSANO', 'B284'],
      ['BORGONE SUSA', 'B024'],
      ['BORGOMASINO', 'B021'],
      ['VILLAFRANCA PIEMONTE', 'L948'],
      ['VILLASTELLONE', 'M027'],
      ['TROFARELLO', 'L445'],
      ['BARONE CANAVESE', 'A673'],
      ['LEVONE', 'E566'],
      ['INGRIA', 'E301'],
      ['BORGIALLO', 'B003'],
      ['NONE', 'F931'],
      ['SALASSA', 'H691'],
      ['RIVAROLO CANAVESE', 'H340'],
      ['RIVAROSSA', 'H344'],
      ['REANO', 'H207'],
      ['MONASTERO DI LANZO', 'F327'],
      ['BARDONECCHIA', 'A651'],
      ['PECCO', 'G396'],
      ['PAVONE CANAVESE', 'G392'],
      ['PECETTO TORINESE', 'G398'],
      ['BALANGERO', 'A587'],
      ['BAIRO', 'A584'],
      ['VAUDA CANAVESE', 'L698'],
      ['CARMAGNOLA', 'B791'],
      ['CHIOMONTE', 'C639'],
      ['GRAVERE', 'E154'],
      ['SANT\'AMBROGIO DI TORINO', 'I258'],
      ['MORIONDO TORINESE', 'F733'],
      ['LEMIE', 'E520'],
      ['TORRE CANAVESE', 'L247'],
      ['ISOLABELLA', 'E345'],
      ['FROSSASCO', 'D812'],
      ['VIDRACCO', 'L857'],
      ['VAIE', 'L538'],
      ['FORNO CANAVESE', 'D725'],
      ['ROCCA CANAVESE', 'H386'],
      ['VISTRORIO', 'M080'],
      ['PIOBESI TORINESE', 'G684'],
      ['SCALENGHE', 'I490'],
      ['PRATIGLIONE', 'G997'],
      ['BROSSO', 'B205'],
      ['BROZOLO', 'B209'],
      ['FELETTO', 'D524'],
      ['CUCEGLIO', 'D197'],
      ['CALUSO', 'B435'],
      ['ALA DI STURA', 'A117'],
      ['SAN MARTINO CANAVESE', 'H997'],
      ['BOLLENGO', 'A941'],
      ['BALDISSERO TORINESE', 'A591'],
      ['BALDISSERO CANAVESE', 'A590'],
      ['PIANEZZA', 'G559'],
      ['COASSOLO TORINESE', 'C801'],
      ['COAZZE', 'C803'],
      ['TRAVERSELLA', 'L345'],
      ['MONTALENGHE', 'F411'],
      ['MONTALTO DORA', 'F420'],
      ['FAVRIA', 'D520'],
      ['ALMESE', 'A218'],
      ['COLLERETTO GIACOSA', 'C868'],
      ['COLLEGNO', 'C860'],
      ['COLLERETTO CASTELNUOVO', 'C867'],
      ['MAZZE\'', 'F067'],
      ['FIANO', 'D562'],
      ['FRASSINETTO', 'D781'],
      ['RIBORDONE', 'H270'],
      ['CANISCHIO', 'B605'],
      ['SAN MAURO TORINESE', 'I030'],
      ['OGLIANICO', 'G010'],
      ['SAN SECONDO DI PINEROLO', 'I154'],
      ['SAN SEBASTIANO DA PO', 'I152'],
      ['VILLANOVA CANAVESE', 'L982'],
      ['VEROLENGO', 'L779'],
      ['MONTEU DA PO', 'F651'],
      ['CHIVASSO', 'C665'],
      ['VOLVERA', 'M133'],
      ['ANDEZENO', 'A275'],
      ['RUEGLIO', 'H631'],
      ['CANDIOLO', 'B592'],
      ['VICO CANAVESE', 'L548'],
      ['CANTALUPA', 'B628'],
      ['GROSSO', 'E203'],
      ['LUSERNETTA', 'E759'],
      ['LUSERNA SAN GIOVANNI', 'E758'],
      ['GARZIGLIANA', 'D931'],
      ['CHIALAMBERTO', 'C604'],
      ['AZEGLIO', 'A525'],
      ['TRANA', 'L327'],
      ['BRANDIZZO', 'B121'],
      ['CORIO', 'D008'],
      ['SAN COLOMBANO BELMONTE', 'H804'],
      ['CHIESANUOVA', 'C629'],
      ['CHIAVERANO', 'C624'],
      ['CHIERI', 'C627'],
      ['RIVARA', 'H338'],
      ['SAMONE', 'H753'],
      ['SAN PIETRO VAL LEMINA', 'I090'],
      ['PERTUSIO', 'G477'],
      ['CARIGNANO', 'B777'],
      ['VALPERGA', 'L644'],
      ['SAN DIDERO', 'H820'],
      ['ANGROGNA', 'A295'],
      ['SAN BENIGNO CANAVESE', 'H775'],
      ['SANTENA', 'I327'],
      ['LOCANA', 'E635'],
      ['CASALBORGONE', 'B867'],
      ['VESTIGNE\'', 'L811'],
      ['RONDISSONE', 'H547'],
      ['BUTTIGLIERA ALTA', 'B305'],
      ['FOGLIZZO', 'D646'],
      ['VALLO TORINESE', 'L629'],
      ['SAN FRANCESCO AL CAMPO', 'H847'],
      ['CIRIE\'', 'C722'],
      ['STRAMBINELLO', 'I969'],
      ['SUSA', 'L013'],
      ['MARENTINO', 'E941'],
      ['VALPRATO SOANA', 'B510'],
      ['CAMPIGLIONE FENILE', 'B512'],
      ['VIGONE', 'L898'],
      ['BRUSASCO', 'B225'],
      ['PANCALIERI', 'G303'],
      ['MEZZENILE', 'F182'],
      ['SAN GERMANO CHISONE', 'H862'],
      ['SALZA DI PINEROLO', 'H734'],
      ['SANT\'ANTONINO DI SUSA', 'I296'],
      ['CLAVIERE', 'C793'],
      ['CASTELNUOVO NIGRA', 'C241'],
      ['VISCHE', 'M071'],
      ['CERES', 'C497'],
      ['DRUENTO', 'D373'],
      ['CASTIGLIONE TORINESE', 'C307'],
      ['CAPRIE', 'B705'],
      ['BIBIANA', 'A853'],
      ['POIRINO', 'G777'],
      ['NICHELINO', 'F889'],
      ['LA CASSA', 'E394'],
      ['VILLAR PELLICE', 'M013'],
      ['VILLAR PEROSA', 'M014'],
      ['TRAVES', 'L340'],
      ['CAREMA', 'B762'],
      ['PORTE', 'G900'],
      ['CASTAGNETO PO', 'C045'],
      ['RIVALBA', 'H333'],
      ['RIVA PRESSO CHIERI', 'H337'],
      ['RIVALTA DI TORINO', 'H335'],
      ['EXILLES', 'D433'],
      ['VERRUA SAVOIA', 'L787'],
      ['ORIO CANAVESE', 'G109'],
      ['BRUZOLO', 'B232'],
      ['SALBERTRAND', 'H684'],
      ['CASELLE TORINESE', 'B960'],
      ['TORRAZZA PIEMONTE', 'L238'],
      ['IVREA', 'E379'],
      ['BUSSOLENO', 'B297'],
      ['CAVOUR', 'C404'],
      ['RIVOLI', 'H355'],
      ['CASTAGNOLE PIEMONTE', 'C048'],
      ['NOASCA', 'F906'],
      ['MACELLO', 'E782'],
      ['CONDOVE', 'C955'],
      ['MONCALIERI', 'F335'],
      ['SAN GIORIO DI SUSA', 'H900'],
      ['ARIGNANO', 'A405'],
      ['PAVAROLO', 'G387'],
      ['CESANA TORINESE', 'C564'],
      ['TORINO', 'L219'],
      ['INVERSO PINASCA', 'E311'],
      ['BORGOFRANCO D\'IVREA', 'B015'],
      ['CINZANO', 'C715'],
      ['CINTANO', 'C711'],
      ['NOLE', 'F925'],
      ['NOMAGLIO', 'F927'],
      ['PIVERONE', 'G719'],
      ['MOMBELLO DI TORINO', 'F315'],
      ['MOMPANTERO', 'F318'],
      ['CAMBIANO', 'B462'],
      ['ROSTA', 'H583'],
      ['CAVAGNOLO', 'C369'],
      ['LESSOLO', 'E551'],
      ['PESSINETTO', 'G505'],
      ['TORRE PELLICE', 'L277'],
      ['SAUZE DI CESANA', 'I465'],
      ['BOSCONERO', 'B075'],
      ['ORBASSANO', 'G087'],
      ['NOVALESA', 'F948'],
      ['PALAZZO CANAVESE', 'G262'],
      ['VIU\'', 'M094'],
      ['BORGARO TORINESE', 'A990'],
      ['BARBANIA', 'A625'],
      ['ALICE SUPERIORE', 'A199'],
      ['PIOSSASCO', 'G691'],
      ['PISCINA', 'G705'],
      ['MERCENASCO', 'F140'],
      ['PRAMOLLO', 'G982'],
      ['PRAROSTINO', 'G986'],
      ['PRASCORSANO', 'G988'],
      ['BUROLO', 'B279'],
      ['BURIASCO', 'B278'],
      ['FENESTRELLE', 'D532'],
      ['RUBIANA', 'H627'],
      ['OZEGNA', 'G202'],
      ['MONTANARO', 'F422'],
      ['VARISELLA', 'L685'],
      ['BANCHETTE', 'A607'],
      ['LEINI', 'E518'],
      ['PARELLA', 'G330'],
      ['MEUGLIANO', 'F164'],
      ['BRUINO', 'B216'],
      ['USSEGLIO', 'L516'],
      ['USSEAUX', 'L515'],
      ['VENARIA REALE', 'L727'],
      ['VENAUS', 'L726'],
      ['PONT CANAVESE', 'G826'],
      ['MONTALDO TORINESE', 'F407'],
      ['CHIUSA DI SAN MICHELE', 'C655'],
      ['GIVOLETTO', 'E067'],
      ['ALPETTE', 'A221'],
      ['VALGIOIE', 'L578'],
      ['VILLAR DORA', 'L999'],
      ['LUGNACCO', 'E727'],
      ['BRICHERASIO', 'B171'],
      ['POMARETTO', 'G805'],
      ['CICONIO', 'C679'],
      ['VOLPIANO', 'M122'],
      ['GIAGLIONE', 'E009'],
      ['SALERANO CANAVESE', 'H702'],
      ['MEANA DI SUSA', 'F074'],
      ['MONCENISIO', 'D553']
    ],
    TP: [
      ['GIBELLINA', 'E023'],
      ['MARSALA', 'E974'],
      ['CASTELLAMMARE DEL GOLFO', 'C130'],
      ['TRAPANI', 'L331'],
      ['VALDERICE', 'G319'],
      ['PANTELLERIA', 'G315'],
      ['POGGIOREALE', 'G767'],
      ['CAMPOBELLO DI MAZARA', 'B521'],
      ['BUSETO PALIZZOLO', 'B288'],
      ['VITA', 'M081'],
      ['MAZARA DEL VALLO', 'F061'],
      ['CALATAFIMI', 'B385'],
      ['ERICE', 'D423'],
      ['CUSTONACI', 'D234'],
      ['ALCAMO', 'A176'],
      ['SANTA NINFA', 'I291'],
      ['PARTANNA', 'G347'],
      ['CASTELVETRANO', 'C286'],
      ['SALAPARUTA', 'H688'],
      ['SAN VITO LO CAPO', 'I407'],
      ['PACECO', 'G208'],
      ['FAVIGNANA', 'D518'],
      ['PETROSINO', 'M281'],
      ['SALEMI', 'H700']
    ],
    TR: [
      ['CASTEL GIORGIO', 'C117'],
      ['AMELIA', 'A262'],
      ['PORANO', 'G881'],
      ['SAN GEMINI', 'H857'],
      ['BASCHI', 'A691'],
      ['ARRONE', 'A439'],
      ['ALVIANO', 'A242'],
      ['ATTIGLIANO', 'A490'],
      ['SAN VENANZO', 'I381'],
      ['AVIGLIANO UMBRO', 'M258'],
      ['ACQUASPARTA', 'A045'],
      ['PENNA IN TEVERINA', 'G432'],
      ['MONTECASTRILLI', 'F457'],
      ['OTRICOLI', 'G189'],
      ['MONTELEONE D\'ORVIETO', 'F543'],
      ['MONTEFRANCO', 'F510'],
      ['MONTEGABBIONE', 'F513'],
      ['ORVIETO', 'G148'],
      ['PARRANO', 'G344'],
      ['GUARDEA', 'E241'],
      ['CASTEL VISCARDO', 'C289'],
      ['NARNI', 'F844'],
      ['FABRO', 'D454'],
      ['TERNI', 'L117'],
      ['CALVI DELL\'UMBRIA', 'B446'],
      ['FERENTILLO', 'D538'],
      ['STRONCONE', 'I981'],
      ['GIOVE', 'E045'],
      ['FICULLE', 'D570'],
      ['POLINO', 'G790'],
      ['LUGNANO IN TEVERINA', 'E729'],
      ['MONTECCHIO', 'F462'],
      ['ALLERONA', 'A207']
    ],
    TS: [
      ['DUINO-AURISINA', 'D383'],
      ['TRIESTE', 'L424'],
      ['MUGGIA', 'F795'],
      ['SGONICO', 'I715'],
      ['SAN DORLIGO DELLA VALLE', 'D324'],
      ['MONRUPINO', 'F378']
    ],
    TV: [
      ['SAN POLO DI PIAVE', 'I124'],
      ['CASTELFRANCO VENETO', 'C111'],
      ['MONTEBELLUNA', 'F443'],
      ['CHIARANO', 'C614'],
      ['GIAVERA DEL MONTELLO', 'E021'],
      ['SAN BIAGIO DI CALLALTA', 'H781'],
      ['SAN PIETRO DI FELETTO', 'I103'],
      ['ZENSON DI PIAVE', 'M163'],
      ['LORIA', 'E692'],
      ['PEDEROBBA', 'G408'],
      ['FONTANELLE', 'D674'],
      ['MASERADA SUL PIAVE', 'F012'],
      ['CAPPELLA MAGGIORE', 'B678'],
      ['FOLLINA', 'D654'],
      ['CORNUDA', 'D030'],
      ['CASALE SUL SILE', 'B879'],
      ['MIANE', 'F190'],
      ['SALGAREDA', 'H706'],
      ['RIESE PIO X', 'H280'],
      ['VILLORBA', 'M048'],
      ['SEGUSINO', 'I578'],
      ['CRESPANO DEL GRAPPA', 'D157'],
      ['TREVISO', 'L407'],
      ['TREVIGNANO', 'L402'],
      ['VOLPAGO DEL MONTELLO', 'M118'],
      ['MOGLIANO VENETO', 'F269'],
      ['CASTELCUCCO', 'C073'],
      ['MORGANO', 'F725'],
      ['MORIAGO DELLA BATTAGLIA', 'F729'],
      ['ASOLO', 'A471'],
      ['NERVESA DELLA BATTAGLIA', 'F872'],
      ['REFRONTOLO', 'H220'],
      ['ORMELLE', 'G115'],
      ['SILEA', 'F116'],
      ['POSSAGNO', 'G933'],
      ['GORGO AL MONTICANO', 'E092'],
      ['BORSO DEL GRAPPA', 'B061'],
      ['PONZANO VENETO', 'G875'],
      ['SAN ZENONE DEGLI EZZELINI', 'I417'],
      ['MONFUMO', 'F360'],
      ['VITTORIO VENETO', 'M089'],
      ['CIMADOLMO', 'C689'],
      ['ODERZO', 'F999'],
      ['GODEGA DI SANT\'URBANO', 'E071'],
      ['ALTIVOLE', 'A237'],
      ['SAN VENDEMIANO', 'I382'],
      ['FARRA DI SOLIGO', 'D505'],
      ['SARMEDE', 'I435'],
      ['VALDOBBIADENE', 'L565'],
      ['COLLE UMBERTO', 'C848'],
      ['QUINTO DI TREVISO', 'H131'],
      ['FONTE', 'D680'],
      ['MARENO DI PIAVE', 'E940'],
      ['VIDOR', 'L856'],
      ['CAERANO DI SAN MARCO', 'B349'],
      ['BREDA DI PIAVE', 'B128'],
      ['ZERO BRANCO', 'M171'],
      ['TARZO', 'L058'],
      ['MASER', 'F009'],
      ['PIEVE DI SOLIGO', 'G645'],
      ['SAN FIOR', 'H843'],
      ['SUSEGANA', 'L014'],
      ['MOTTA DI LIVENZA', 'F770'],
      ['GAIARINE', 'D854'],
      ['RONCADE', 'H523'],
      ['POVEGLIANO', 'G944'],
      ['SPRESIANO', 'I927'],
      ['MEDUNA DI LIVENZA', 'F088'],
      ['PORTOBUFFOLE\'', 'G909'],
      ['REVINE LAGO', 'H253'],
      ['SANTA LUCIA DI PIAVE', 'I221'],
      ['CASIER', 'B965'],
      ['ISTRANA', 'E373'],
      ['CARBONERA', 'B744'],
      ['CISON DI VALMARINO', 'C735'],
      ['CONEGLIANO', 'C957'],
      ['RESANA', 'H238'],
      ['MONASTIER DI TREVISO', 'F332'],
      ['ORSAGO', 'G123'],
      ['CAVASO DEL TOMBA', 'C384'],
      ['ARCADE', 'A360'],
      ['CASTELLO DI GODEGO', 'C190'],
      ['CORDIGNANO', 'C992'],
      ['SERNAGLIA DELLA BATTAGLIA', 'I635'],
      ['PREGANZIOL', 'H022'],
      ['VEDELAGO', 'L706'],
      ['VAZZOLA', 'L700'],
      ['PONTE DI PIAVE', 'G846'],
      ['CODOGNE\'', 'C815'],
      ['CESSALTO', 'C580'],
      ['PADERNO DEL GRAPPA', 'G221'],
      ['PAESE', 'G229'],
      ['FREGONA', 'D794'],
      ['CROCETTA DEL MONTELLO', 'C670'],
      ['MANSUE\'', 'E893']
    ],
    UD: [
      ['AMPEZZO', 'A267'],
      ['STREGNA', 'I974'],
      ['PALMANOVA', 'G284'],
      ['TRASAGHIS', 'L335'],
      ['LUSEVERA', 'E760'],
      ['TERZO DI AQUILEIA', 'L144'],
      ['TAPOGLIANO', 'L044'],
      ['SAN DANIELE DEL FRIULI', 'H816'],
      ['ZUGLIO', 'M200'],
      ['TAVAGNACCO', 'L065'],
      ['VERZEGNIS', 'L801'],
      ['RAGOGNA', 'H161'],
      ['OVARO', 'G198'],
      ['RONCHIS', 'H533'],
      ['CASSACCO', 'B994'],
      ['MORUZZO', 'F760'],
      ['RIGOLATO', 'H289'],
      ['ENEMONZO', 'D408'],
      ['MAJANO', 'E833'],
      ['DRENCHIA', 'D366'],
      ['MOGGIO UDINESE', 'F266'],
      ['SAN GIORGIO DI NOGARO', 'H895'],
      ['POCENIA', 'G743'],
      ['NIMIS', 'F898'],
      ['CAMPOLONGO AL TORRE', 'B545'],
      ['TRICESIMO', 'L421'],
      ['AMARO', 'A254'],
      ['PASIAN DI PRATO', 'G352'],
      ['LIGOSULLO', 'E586'],
      ['LIGNANO SABBIADORO', 'E584'],
      ['DIGNANO', 'D300'],
      ['TOLMEZZO', 'L195'],
      ['REMANZACCO', 'H229'],
      ['CERVIGNANO DEL FRIULI', 'C556'],
      ['GRIMACCO', 'E179'],
      ['RIVE D\'ARCANO', 'H347'],
      ['REANA DEL ROIALE', 'H206'],
      ['RAVEO', 'H200'],
      ['FAGAGNA', 'D461'],
      ['AIELLO DEL FRIULI', 'A103'],
      ['MANZANO', 'E899'],
      ['SAVOGNA', 'I478'],
      ['FORGARIA NEL FRIULI', 'D700'],
      ['SAN VITO DI FAGAGNA', 'I405'],
      ['SAN VITO AL TORRE', 'I404'],
      ['VILLA SANTINA', 'L909'],
      ['MUZZANA DEL TURGNANO', 'F832'],
      ['UDINE', 'L483'],
      ['SAN LEONARDO', 'H951'],
      ['TORREANO', 'L246'],
      ['TORVISCOSA', 'L309'],
      ['TEOR', 'L101'],
      ['PRECENICCO', 'H014'],
      ['FORNI DI SOTTO', 'D720'],
      ['BORDANO', 'A983'],
      ['RUDA', 'H629'],
      ['PREONE', 'H038'],
      ['PAGNACCO', 'G238'],
      ['PONTEBBA', 'G831'],
      ['CHIOPRIS VISCONE', 'C641'],
      ['RESIA', 'H242'],
      ['RESIUTTA', 'H244'],
      ['FIUMICELLO', 'D627'],
      ['CAMINO AL TAGLIAMENTO', 'B483'],
      ['RAVASCLETTO', 'H196'],
      ['COLLOREDO DI MONTE ALBANO', 'C885'],
      ['TARVISIO', 'L057'],
      ['TARCENTO', 'L050'],
      ['SAN PIETRO AL NATISONE', 'I092'],
      ['PORPETTO', 'G891'],
      ['ATTIMIS', 'A491'],
      ['CORNO DI ROSAZZO', 'D027'],
      ['MONTENARS', 'F574'],
      ['MALBORGHETTO-VALBRUNA', 'E847'],
      ['BUTTRIO', 'B309'],
      ['LAUCO', 'E476'],
      ['LATISANA', 'E473'],
      ['SUTRIO', 'L018'],
      ['TREPPO GRANDE', 'L382'],
      ['TREPPO CARNICO', 'L381'],
      ['PALUZZA', 'G300'],
      ['POVOLETTO', 'G949'],
      ['SOCCHIEVE', 'I777'],
      ['BASILIANO', 'A700'],
      ['TALMASSONS', 'L039'],
      ['MORTEGLIANO', 'F756'],
      ['CAMPOFORMIDO', 'B536'],
      ['SEDEGLIANO', 'I562'],
      ['VISCO', 'M073'],
      ['CERCIVENTO', 'C494'],
      ['COSEANO', 'D085'],
      ['POZZUOLO DEL FRIULI', 'G966'],
      ['PRADAMANO', 'G969'],
      ['PULFERO', 'H089'],
      ['BICINICCO', 'A855'],
      ['MARTIGNACCO', 'E982'],
      ['COMEGLIANS', 'C918'],
      ['ARTA TERME', 'A447'],
      ['ARTEGNA', 'A448'],
      ['OSOPPO', 'G163'],
      ['MAGNANO IN RIVIERA', 'E820'],
      ['DOGNA', 'D316'],
      ['MOIMACCO', 'F275'],
      ['VILLA VICENTINA', 'M034'],
      ['TRIVIGNANO UDINESE', 'L438'],
      ['RIVIGNANO', 'H352'],
      ['TAIPANA', 'G736'],
      ['SAN GIOVANNI AL NATISONE', 'H906'],
      ['PAVIA DI UDINE', 'G389'],
      ['PAULARO', 'G381'],
      ['CAVAZZO CARNICO', 'C389'],
      ['VARMO', 'L686'],
      ['FAEDIS', 'D455'],
      ['FORNI AVOLTRI', 'D718'],
      ['FORNI DI SOPRA', 'D719'],
      ['AQUILEIA', 'A346'],
      ['BAGNARIA ARSA', 'A553'],
      ['LESTIZZA', 'E553'],
      ['GONARS', 'E083'],
      ['BUJA', 'B259'],
      ['SAURIS', 'I464'],
      ['PRATO CARNICO', 'H002'],
      ['CARLINO', 'B788'],
      ['PALAZZOLO DELLO STELLA', 'G268'],
      ['SANTA MARIA LA LONGA', 'I248'],
      ['MERETO DI TOMBA', 'F144'],
      ['PREMARIACCO', 'H029'],
      ['CIVIDALE DEL FRIULI', 'C758'],
      ['BERTIOLO', 'A810'],
      ['CASTIONS DI STRADA', 'C327'],
      ['CODROIPO', 'C817'],
      ['PREPOTTO', 'H040'],
      ['CHIUSAFORTE', 'C656'],
      ['FLAIBANO', 'D630'],
      ['VENZONE', 'L743'],
      ['GEMONA DEL FRIULI', 'D962'],
      ['MARANO LAGUNARE', 'E910']
    ],
    VA: [
      ['OGGIONA CON SANTO STEFANO', 'G008'],
      ['VERGIATE', 'L765'],
      ['GAVIRATE', 'D946'],
      ['BODIO LOMNAGO', 'A918'],
      ['VIZZOLA TICINO', 'M101'],
      ['CUNARDO', 'D204'],
      ['CANTELLO', 'B634'],
      ['CASTELLANZA', 'C139'],
      ['LUVINATE', 'E769'],
      ['BREGANO', 'B131'],
      ['AZZATE', 'A531'],
      ['TRADATE', 'L319'],
      ['CAZZAGO BRABBIA', 'C409'],
      ['VARANO BORGHI', 'L671'],
      ['ALBIZZATE', 'A167'],
      ['MALGESSO', 'E856'],
      ['CASTELLO CABIAGLIO', 'B312'],
      ['CLIVIO', 'C796'],
      ['DUNO', 'D385'],
      ['DUMENZA', 'D384'],
      ['PINO SULLA SPONDA DEL LAGO MAGGIORE', 'G677'],
      ['CASALE LITTA', 'B875'],
      ['SUMIRAGO', 'L003'],
      ['INARZO', 'E292'],
      ['UBOLDO', 'L480'],
      ['CASSANO VALCUVIA', 'B999'],
      ['BRISSAGO-VALTRAVAGLIA', 'B191'],
      ['CARAVATE', 'B732'],
      ['SANGIANO', 'H872'],
      ['SALTRIO', 'H723'],
      ['BESNATE', 'A825'],
      ['BESOZZO', 'A826'],
      ['CASTELSEPRIO', 'C273'],
      ['GERMIGNAGA', 'D987'],
      ['MONTEGRINO VALTRAVAGLIA', 'F526'],
      ['LONATE POZZOLO', 'E666'],
      ['LONATE CEPPINO', 'E665'],
      ['BIANDRONNO', 'A845'],
      ['COMERIO', 'C922'],
      ['ISPRA', 'E367'],
      ['MONVALLE', 'F703'],
      ['CASTRONNO', 'C343'],
      ['AGRA', 'A085'],
      ['FAGNANO OLONA', 'D467'],
      ['MERCALLO', 'F134'],
      ['CARNAGO', 'B796'],
      ['GALLIATE LOMBARDO', 'D871'],
      ['CASTELVECCANA', 'C181'],
      ['OSMATE', 'E529'],
      ['MESENZANA', 'F154'],
      ['ARCISATE', 'A371'],
      ['BARASSO', 'A619'],
      ['CUGLIATE-FABIASCO', 'D199'],
      ['CUASSO AL MONTE', 'D192'],
      ['VENEGONO INFERIORE', 'L733'],
      ['VENEGONO SUPERIORE', 'L734'],
      ['FERNO', 'D543'],
      ['GOLASECCA', 'E079'],
      ['JERAGO CON ORAGO', 'E386'],
      ['MARCHIROLO', 'E929'],
      ['BRUSIMPIANO', 'B228'],
      ['TRAVEDONA-MONATE', 'L342'],
      ['LUINO', 'E734'],
      ['GAZZADA SCHIANNO', 'D951'],
      ['MARNATE', 'E965'],
      ['CUVIO', 'D239'],
      ['CUVEGLIO', 'D238'],
      ['CAIRATE', 'B368'],
      ['CURIGLIA CON MONTEVIASCO', 'D217'],
      ['GORLA MINORE', 'E102'],
      ['GORLA MAGGIORE', 'E101'],
      ['MACCAGNO', 'E775'],
      ['CADREZZATE', 'B347'],
      ['SESTO CALENDE', 'I688'],
      ['BREBBIA', 'B126'],
      ['CARONNO VARESINO', 'B807'],
      ['CARONNO PERTUSELLA', 'B805'],
      ['MASCIAGO PRIMO', 'F007'],
      ['MARZIO', 'F002'],
      ['VIGGIU\'', 'L876'],
      ['CADEGLIANO-VICONAGO', 'B326'],
      ['CARDANO AL CAMPO', 'B754'],
      ['ANGERA', 'A290'],
      ['DAVERIO', 'D256'],
      ['RANCIO VALCUVIA', 'H173'],
      ['RANCO', 'H174'],
      ['BUSTO ARSIZIO', 'B300'],
      ['BESANO', 'A819'],
      ['MALNATE', 'E863'],
      ['BRENTA', 'B150'],
      ['CASORATE SEMPIONE', 'B987'],
      ['BRINZIO', 'B182'],
      ['SAMARATE', 'H736'],
      ['TRONZANO LAGO MAGGIORE', 'A705'],
      ['LAVENA PONTE TRESA', 'E494'],
      ['LAVENO-MOMBELLO', 'E496'],
      ['TAINO', 'L032'],
      ['CASTIGLIONE OLONA', 'C300'],
      ['BEDERO VALCUVIA', 'A728'],
      ['CASSANO MAGNAGO', 'C004'],
      ['COMABBIO', 'C911'],
      ['ARSAGO SEPRIO', 'A441'],
      ['CASCIAGO', 'B949'],
      ['PORTO CERESIO', 'G906'],
      ['PORTO VALTRAVAGLIA', 'G907'],
      ['BISUSCHIO', 'A891'],
      ['GORNATE-OLONA', 'E104'],
      ['MORAZZONE', 'F711'],
      ['ORIGGIO', 'G103'],
      ['ORINO', 'G105'],
      ['CISLAGO', 'C732'],
      ['CAVARIA CON PREMEZZO', 'C382'],
      ['VARESE', 'L682'],
      ['GALLARATE', 'D869'],
      ['SARONNO', 'I441'],
      ['GRANTOLA', 'E144'],
      ['BARDELLO', 'A645'],
      ['CASALZUIGNO', 'B921'],
      ['TERNATE', 'L115'],
      ['BUGUGGIATE', 'B258'],
      ['AZZIO', 'A532'],
      ['SOMMA LOMBARDO', 'I819'],
      ['SOLBIATE ARNO', 'I793'],
      ['SOLBIATE OLONA', 'I794'],
      ['CITTIGLIO', 'C751'],
      ['INDUNO OLONA', 'E299'],
      ['VEDDASCA', 'L705'],
      ['VEDANO OLONA', 'L703'],
      ['LEGGIUNO', 'E510'],
      ['COCQUIO-TREVISAGO', 'C810'],
      ['BRUNELLO', 'B219'],
      ['LOZZA', 'E707'],
      ['CROSIO DELLA VALLE', 'D185'],
      ['GERENZANO', 'D981'],
      ['CREMENAGA', 'D144'],
      ['VALGANNA', 'L577'],
      ['OLGIATE OLONA', 'G028'],
      ['MORNAGO', 'F736'],
      ['GEMONIO', 'D963'],
      ['BREZZO DI BEDERO', 'B166'],
      ['FERRERA DI VARESE', 'D551']
    ],
    VB: [
      ['CANNOBIO', 'B615'],
      ['CANNERO RIVIERA', 'B610'],
      ['OGGEBBIO', 'G007'],
      ['GIGNESE', 'E028'],
      ['LOREGLIA', 'E685'],
      ['PALLANZENO', 'G280'],
      ['TRASQUERA', 'L336'],
      ['TRAREGO VIGGIONA', 'L333'],
      ['FORMAZZA', 'D706'],
      ['FALMENTA', 'D481'],
      ['VIGANELLA', 'L864'],
      ['QUARNA SOTTO', 'H107'],
      ['QUARNA SOPRA', 'H106'],
      ['MONTECRESTESE', 'F483'],
      ['PIEVE VERGONTE', 'G658'],
      ['MALESCO', 'E853'],
      ['VALSTRONA', 'L651'],
      ['CASALE CORTE CERRO', 'B876'],
      ['CAPREZZO', 'B694'],
      ['MIAZZINA', 'F192'],
      ['STRESA', 'I976'],
      ['CRODO', 'D177'],
      ['VILLETTE', 'M042'],
      ['TOCENO', 'L187'],
      ['COSSOGNO', 'D099'],
      ['BEE', 'A733'],
      ['CRAVEGGIA', 'D134'],
      ['ANTRONA SCHIERANCO', 'A317'],
      ['ORNAVASSO', 'G117'],
      ['INTRAGNA', 'E304'],
      ['NONIO', 'F932'],
      ['MACUGNAGA', 'E790'],
      ['RE', 'H203'],
      ['VARZO', 'L691'],
      ['VILLADOSSOLA', 'L906'],
      ['GRAVELLONA TOCE', 'E153'],
      ['BANNIO ANZINO', 'A610'],
      ['PREMOSELLO-CHIOVENDA', 'H037'],
      ['PREMENO', 'H030'],
      ['PREMIA', 'H033'],
      ['GURRO', 'E269'],
      ['VIGNONE', 'L889'],
      ['CEPPO MORELLI', 'C478'],
      ['BROVELLO-CARPUGNINO', 'B207'],
      ['BOGNANCO', 'A925'],
      ['CALASCA-CASTIGLIONE', 'B380'],
      ['MASSIOLA', 'F048'],
      ['VOGOGNA', 'M111'],
      ['PIEDIMULERA', 'G600'],
      ['VANZONE CON SAN CARLO', 'L666'],
      ['MONTESCHENO', 'F639'],
      ['AURANO', 'A497'],
      ['BELGIRATE', 'A742'],
      ['SAN BERNARDINO VERBANO', 'H777'],
      ['MASERA', 'F010'],
      ['BEURA-CARDEZZA', 'A834'],
      ['CREVOLADOSSOLA', 'D168'],
      ['DRUOGNO', 'D374'],
      ['BAVENO', 'A725'],
      ['DOMODOSSOLA', 'D332'],
      ['ANZOLA D\'OSSOLA', 'A325'],
      ['TRONTANO', 'L450'],
      ['ARIZZANO', 'A409'],
      ['CESARA', 'C567'],
      ['CAMBIASCA', 'B463'],
      ['AROLA', 'A427'],
      ['CAVAGLIO-SPOCCIA', 'C367'],
      ['BACENO', 'A534'],
      ['SANTA MARIA MAGGIORE', 'I249'],
      ['MADONNA DEL SASSO', 'E795'],
      ['MERGOZZO', 'F146'],
      ['OMEGNA', 'G062'],
      ['SEPPIANA', 'I619'],
      ['GERMAGNO', 'D984'],
      ['VERBANIA', 'L746'],
      ['GHIFFA', 'E003'],
      ['CURSOLO-ORASSO', 'D225']
    ],
    VC: [
      ['SABBIA', 'H648'],
      ['BOCCIOLETO', 'A914'],
      ['VOCCA', 'M106'],
      ['BREIA', 'B136'],
      ['ROSSA', 'H577'],
      ['QUARONA', 'H108'],
      ['FONTANETTO PO', 'D676'],
      ['SAN GERMANO VERCELLESE', 'H861'],
      ['ROASIO', 'H365'],
      ['ROVASENDA', 'H364'],
      ['SANTHIA\'', 'I337'],
      ['LIVORNO FERRARIS', 'E626'],
      ['RIMA SAN GIUSEPPE', 'H291'],
      ['SALI VERCELLESE', 'H707'],
      ['RIMELLA', 'H293'],
      ['RIMASCO', 'H292'],
      ['CAMPERTOGNO', 'B505'],
      ['SALUGGIA', 'H725'],
      ['QUINTO VERCELLESE', 'H132'],
      ['CRESCENTINO', 'D154'],
      ['SAN GIACOMO VERCELLESE', 'B952'],
      ['BIANZE\'', 'A847'],
      ['CRAVAGLIANA', 'D132'],
      ['VILLARBOIT', 'M003'],
      ['TRICERRO', 'L420'],
      ['TRINO VERCELLESE', 'L429'],
      ['BORGO VERCELLI', 'B046'],
      ['BORGOSESIA', 'B041'],
      ['LIGNANA', 'E583'],
      ['BURONZO', 'B280'],
      ['RIVA VALDOBBIA', 'H329'],
      ['COSTANZANA', 'D113'],
      ['VILLATA', 'M028'],
      ['ALICE CASTELLO', 'A198'],
      ['BORGO D\'ALE', 'B009'],
      ['SALASCO', 'H690'],
      ['RIVE', 'H346'],
      ['SERRAVALLE SESIA', 'I663'],
      ['ARBORIO', 'A358'],
      ['LENTA', 'E528'],
      ['CIGLIANO', 'C680'],
      ['PIODE', 'G685'],
      ['MONCRIVELLO', 'F342'],
      ['VARALLO', 'L669'],
      ['LOZZOLO', 'E711'],
      ['VERCELLI', 'L750'],
      ['OLDENICO', 'G018'],
      ['OLCENENGO', 'G016'],
      ['CELLIO', 'C450'],
      ['GATTINARA', 'D938'],
      ['COLLOBIANO', 'C884'],
      ['LAMPORO', 'E433'],
      ['PERTENGO', 'G471'],
      ['CARCOFORO', 'B752'],
      ['RONSECCO', 'H549'],
      ['FOBELLO', 'D641'],
      ['PILA', 'G666'],
      ['MOTTA DE\' CONTI', 'F774'],
      ['POSTUA', 'G940'],
      ['RASSA', 'H188'],
      ['ALBANO VERCELLESE', 'A130'],
      ['SCOPA', 'I544'],
      ['SCOPELLO', 'I545'],
      ['ALAGNA VALSESIA', 'A119'],
      ['CARESANABLOT', 'B768'],
      ['CARESANA', 'B767'],
      ['GREGGIO', 'E163'],
      ['ASIGLIANO VERCELLESE', 'A466'],
      ['CERVATTO', 'C548'],
      ['MOLLIA', 'F297'],
      ['TRONZANO VERCELLESE', 'L451'],
      ['FORMIGLIANA', 'D712'],
      ['CASANOVA ELVO', 'B928'],
      ['CARISIO', 'B782'],
      ['PALAZZOLO VERCELLESE', 'G266'],
      ['PEZZANA', 'G528'],
      ['PRAROLO', 'G985'],
      ['DESANA', 'D281'],
      ['CIVIASCO', 'C757'],
      ['STROPPIANA', 'I984'],
      ['VALDUGGIA', 'L566'],
      ['BALOCCO', 'A601'],
      ['BALMUCCIA', 'A600'],
      ['CROVA', 'D187'],
      ['GUARDABOSONE', 'E237'],
      ['GHISLARENGO', 'E007']
    ],
    VE: [
      ['TORRE DI MOSTO', 'L267'],
      ['SAN MICHELE AL TAGLIAMENTO', 'I040'],
      ['CEGGIA', 'C422'],
      ['CHIOGGIA', 'C638'],
      ['GRUARO', 'E215'],
      ['MIRA', 'F229'],
      ['MIRANO', 'F241'],
      ['SANTO STINO DI LIVENZA', 'I373'],
      ['SCORZE\'', 'I551'],
      ['CAMPOLONGO MAGGIORE', 'B546'],
      ['PORTOGRUARO', 'G914'],
      ['DOLO', 'D325'],
      ['MEOLO', 'F130'],
      ['FOSSO\'', 'D748'],
      ['FOSSALTA DI PORTOGRUARO', 'D741'],
      ['FOSSALTA DI PIAVE', 'D740'],
      ['VENEZIA', 'L736'],
      ['CAORLE', 'B642'],
      ['QUARTO D\'ALTINO', 'H117'],
      ['SAN DONA\' DI PIAVE', 'H823'],
      ['MARTELLAGO', 'E980'],
      ['CAMPAGNA LUPIA', 'B493'],
      ['STRA', 'I965'],
      ['SALZANO', 'H735'],
      ['CAMPONOGARA', 'B554'],
      ['ERACLEA', 'D415'],
      ['ANNONE VENETO', 'A302'],
      ['CONA', 'C938'],
      ['SPINEA', 'I908'],
      ['VIGONOVO', 'L899'],
      ['NOALE', 'F904'],
      ['CONCORDIA SAGITTARIA', 'C950'],
      ['CAVARZERE', 'C383'],
      ['JESOLO', 'C388'],
      ['CINTO CAOMAGGIORE', 'C714'],
      ['MUSILE DI PIAVE', 'F826'],
      ['CAVALLINO-TREPORTI', 'M308'],
      ['SANTA MARIA DI SALA', 'I242'],
      ['PRAMAGGIORE', 'G981'],
      ['NOVENTA DI PIAVE', 'F963'],
      ['PIANIGA', 'G565'],
      ['MARCON', 'E936'],
      ['FIESSO D\'ARTICO', 'D578'],
      ['TEGLIO VENETO', 'L085']
    ],
    VI: [
      ['VALDASTICO', 'L554'],
      ['VALDAGNO', 'L551'],
      ['CASTELGOMBERTO', 'C119'],
      ['ALBETTONE', 'A154'],
      ['MONTEVIALE', 'F662'],
      ['MONTEBELLO VICENTINO', 'F442'],
      ['LONIGO', 'E682'],
      ['MAROSTICA', 'E970'],
      ['SAN NAZARIO', 'I047'],
      ['LUSIANA', 'E762'],
      ['BREGANZE', 'B132'],
      ['CARRE\'', 'B835'],
      ['LAGHI', 'E403'],
      ['PEDEMONTE', 'G406'],
      ['MONTE DI MALO', 'F486'],
      ['ZANE\'', 'M145'],
      ['ROANA', 'H361'],
      ['MASON VICENTINO', 'F019'],
      ['ROSA\'', 'H556'],
      ['VALSTAGNA', 'L650'],
      ['SCHIO', 'I531'],
      ['BROGLIANO', 'B196'],
      ['GAMBUGLIANO', 'D902'],
      ['SANTORSO', 'I353'],
      ['CASSOLA', 'C037'],
      ['LASTEBASSE', 'E465'],
      ['MOSSANO', 'F768'],
      ['ROMANO D\'EZZELINO', 'H512'],
      ['POZZOLEONE', 'G957'],
      ['ENEGO', 'D407'],
      ['ARZIGNANO', 'A459'],
      ['GAMBELLARA', 'D897'],
      ['GRANCONA', 'E138'],
      ['CAMPOLONGO SUL BRENTA', 'B547'],
      ['CREAZZO', 'D136'],
      ['VICENZA', 'L840'],
      ['CASTEGNERO', 'C056'],
      ['CONCO', 'C949'],
      ['BARBARANO VICENTINO', 'A627'],
      ['POSINA', 'G931'],
      ['SALCEDO', 'F810'],
      ['ROTZO', 'H594'],
      ['SOLAGNA', 'I783'],
      ['SAN VITO DI LEGUZZANO', 'I401'],
      ['ORGIANO', 'G095'],
      ['NOVE', 'F957'],
      ['NANTO', 'F838'],
      ['MOLVENA', 'F306'],
      ['TORREBELVICINO', 'L248'],
      ['ARCUGNANO', 'A377'],
      ['COGOLLO DEL CENGIO', 'C824'],
      ['SAREGO', 'I430'],
      ['MONTORSO VICENTINO', 'F696'],
      ['CALTRANO', 'B433'],
      ['BRENDOLA', 'B143'],
      ['ALTAVILLA VICENTINA', 'A231'],
      ['CRESPADORO', 'D156'],
      ['LUGO DI VICENZA', 'E731'],
      ['GRUMOLO DELLE ABBADESSE', 'E226'],
      ['MONTICELLO CONTE OTTO', 'F675'],
      ['QUINTO VICENTINO', 'H134'],
      ['CAMISANO VICENTINO', 'B485'],
      ['CHIAMPO', 'C605'],
      ['SAN PIETRO MUSSOLINO', 'I117'],
      ['ZERMEGHEDO', 'M170'],
      ['SOVIZZO', 'I879'],
      ['FARA VICENTINO', 'D496'],
      ['SOSSANO', 'I867'],
      ['CORNEDO VICENTINO', 'D020'],
      ['SANDRIGO', 'H829'],
      ['GRISIGNANO DI ZOCCO', 'E184'],
      ['SCHIAVON', 'I527'],
      ['ALTISSIMO', 'A236'],
      ['VALLI DEL PASUBIO', 'L624'],
      ['CARTIGLIANO', 'B844'],
      ['CAMPIGLIA DEI BERICI', 'B511'],
      ['MONTEGALDA', 'F514'],
      ['MONTEGALDELLA', 'F515'],
      ['MALO', 'E864'],
      ['CALDOGNO', 'B403'],
      ['ZOVENCEDO', 'M194'],
      ['ZUGLIANO', 'M199'],
      ['POVE DEL GRAPPA', 'G943'],
      ['SAN GERMANO DEI BERICI', 'H863'],
      ['BASSANO DEL GRAPPA', 'A703'],
      ['LONGARE', 'E671'],
      ['DUEVILLE', 'D379'],
      ['CHIUPPANO', 'C650'],
      ['GALLIO', 'D882'],
      ['POIANA MAGGIORE', 'G776'],
      ['ARSIERO', 'A444'],
      ['ISOLA VICENTINA', 'E354'],
      ['VILLAGA', 'L952'],
      ['AGUGLIARO', 'A093'],
      ['VILLAVERLA', 'M032'],
      ['TRISSINO', 'L433'],
      ['ASIAGO', 'A465'],
      ['ASIGLIANO VENETO', 'A467'],
      ['TEZZE SUL BRENTA', 'L156'],
      ['THIENE', 'L157'],
      ['CISMON DEL GRAPPA', 'C734'],
      ['COSTABISSARA', 'D107'],
      ['TONEZZA DEL CIMONE', 'D717'],
      ['NOGAROLE VICENTINO', 'F922'],
      ['MUSSOLENTE', 'F829'],
      ['RECOARO TERME', 'H214'],
      ['ROSSANO VENETO', 'H580'],
      ['CALVENE', 'B441'],
      ['PIOVENE ROCCHETTE', 'G694'],
      ['FOZA', 'D750'],
      ['NOVENTA VICENTINA', 'F964'],
      ['SARCEDO', 'I425'],
      ['VELO D\'ASTICO', 'L723'],
      ['BOLZANO VICENTINO', 'A954'],
      ['TORRI DI QUARTESOLO', 'L297'],
      ['ALONTE', 'A220'],
      ['PIANEZZE', 'G560'],
      ['MONTECCHIO MAGGIORE', 'F464'],
      ['MONTECCHIO PRECALCINO', 'F465'],
      ['BRESSANVIDO', 'B161'],
      ['MARANO VICENTINO', 'E912']
    ],
    VR: [
      ['SAN BONIFACIO', 'H783'],
      ['SONA', 'I826'],
      ['SOMMACAMPAGNA', 'I821'],
      ['SELVA DI PROGNO', 'I594'],
      ['COLOGNA VENETA', 'C890'],
      ['COLOGNOLA AI COLLI', 'C897'],
      ['VIGASIO', 'L869'],
      ['MOZZECANE', 'F789'],
      ['TREVENZUOLO', 'L396'],
      ['MONTEFORTE D\'ALPONE', 'F508'],
      ['CAVAION VERONESE', 'C370'],
      ['LAVAGNO', 'E489'],
      ['PESCANTINA', 'G481'],
      ['PESCHIERA DEL GARDA', 'G489'],
      ['ISOLA DELLA SCALA', 'E349'],
      ['BELFIORE', 'A737'],
      ['CASTEL D\'AZZANO', 'C078'],
      ['SAN PIETRO IN CARIANO', 'I109'],
      ['SAN PIETRO DI MORUBIO', 'I105'],
      ['NOGARA', 'F918'],
      ['CONCAMARISE', 'C943'],
      ['COSTERMANO', 'D118'],
      ['SAN GIOVANNI ILARIONE', 'H916'],
      ['BARDOLINO', 'A650'],
      ['SANT\'AMBROGIO DI VALPOLICELLA', 'I259'],
      ['SAN ZENO DI MONTAGNA', 'I414'],
      ['FUMANE', 'D818'],
      ['ARCOLE', 'A374'],
      ['BONAVIGO', 'A964'],
      ['MEZZANE DI SOTTO', 'F172'],
      ['CERRO VERONESE', 'C538'],
      ['LAZISE', 'E502'],
      ['VERONELLA', 'D193'],
      ['GARDA', 'D915'],
      ['CASALEONE', 'B886'],
      ['ROVEREDO DI GUA\'', 'H610'],
      ['VALEGGIO SUL MINCIO', 'L567'],
      ['GAZZO VERONESE', 'D957'],
      ['ERBEZZO', 'D420'],
      ['FERRARA DI MONTE BALDO', 'D549'],
      ['PALU\'', 'G297'],
      ['BOVOLONE', 'B107'],
      ['SORGA\'', 'I850'],
      ['AFFI', 'A061'],
      ['CAZZANO DI TRAMIGNA', 'C412'],
      ['ZIMELLA', 'M178'],
      ['ZEVIO', 'M172'],
      ['ANGIARI', 'A292'],
      ['ROVERCHIARA', 'H606'],
      ['TORRI DEL BENACO', 'L287'],
      ['VESTENANOVA', 'L810'],
      ['RONCO ALL\'ADIGE', 'H540'],
      ['MALCESINE', 'E848'],
      ['BUTTAPIETRA', 'B304'],
      ['MINERBE', 'F218'],
      ['SAN MAURO DI SALINE', 'H712'],
      ['SALIZZOLE', 'H714'],
      ['BADIA CALAVENA', 'A540'],
      ['CASTELNUOVO DEL GARDA', 'C225'],
      ['VILLAFRANCA DI VERONA', 'L949'],
      ['ILLASI', 'E284'],
      ['RONCA\'', 'H522'],
      ['BRENTINO BELLUNO', 'B152'],
      ['POVEGLIANO VERONESE', 'G945'],
      ['SANT\'ANNA D\'ALFAEDO', 'I292'],
      ['SOAVE', 'I775'],
      ['BEVILACQUA', 'A837'],
      ['CEREA', 'C498'],
      ['ALBAREDO D\'ADIGE', 'A137'],
      ['CAPRINO VERONESE', 'B709'],
      ['ERBE\'', 'D419'],
      ['ISOLA RIZZA', 'E358'],
      ['DOLCE\'', 'D317'],
      ['VERONA', 'L781'],
      ['SAN GIOVANNI LUPATOTO', 'H924'],
      ['BUSSOLENGO', 'B296'],
      ['RIVOLI VERONESE', 'H356'],
      ['CASTAGNARO', 'C041'],
      ['TERRAZZO', 'L136'],
      ['VILLA BARTOLOMEA', 'L912'],
      ['NOGAROLE ROCCA', 'F921'],
      ['NEGRAR', 'F861'],
      ['BOSCO CHIESANUOVA', 'B073'],
      ['BOSCHI SANT\'ANNA', 'B070'],
      ['OPPEANO', 'G080'],
      ['GREZZANA', 'E171'],
      ['SANGUINETTO', 'H944'],
      ['MONTECCHIA DI CROSARA', 'F461'],
      ['LEGNAGO', 'E512'],
      ['PRESSANA', 'H048'],
      ['ROVERE\' VERONESE', 'H608'],
      ['VELO VERONESE', 'L722'],
      ['CALDIERO', 'B402'],
      ['BRENZONE', 'B154'],
      ['TREGNAGO', 'L364'],
      ['SAN MARTINO BUON ALBERGO', 'I003'],
      ['PASTRENGO', 'G365'],
      ['MARANO DI VALPOLICELLA', 'E911']
    ],
    VT: [
      ['GROTTE DI CASTRO', 'E210'],
      ['CIVITELLA D\'AGLIANO', 'C780'],
      ['MONTE ROMANO', 'F603'],
      ['MONTEROSI', 'F606'],
      ['CELLERE', 'C447'],
      ['CELLENO', 'C446'],
      ['TUSCANIA', 'L310'],
      ['VASANELLO', 'A701'],
      ['BAGNOREGIO', 'A577'],
      ['CAPRAROLA', 'B691'],
      ['RONCIGLIONE', 'H534'],
      ['LATERA', 'E467'],
      ['MARTA', 'E978'],
      ['VALLERANO', 'L612'],
      ['VIGNANELLO', 'L882'],
      ['VILLA SAN GIOVANNI IN TUSCIA', 'H913'],
      ['ARLENA DI CASTRO', 'A412'],
      ['ORIOLO ROMANO', 'G111'],
      ['ORTE', 'G135'],
      ['GALLESE', 'D870'],
      ['GRADOLI', 'E126'],
      ['CIVITA CASTELLANA', 'C765'],
      ['CORCHIANO', 'C988'],
      ['VEJANO', 'L713'],
      ['VITERBO', 'M082'],
      ['VITORCHIANO', 'M086'],
      ['BOLSENA', 'A949'],
      ['FARNESE', 'D503'],
      ['LUBRIANO', 'E713'],
      ['MONTALTO DI CASTRO', 'F419'],
      ['CASTIGLIONE IN TEVERINA', 'C315'],
      ['PIANSANO', 'G571'],
      ['PROCENO', 'H071'],
      ['VALENTANO', 'L569'],
      ['CANINO', 'B604'],
      ['CALCATA', 'B388'],
      ['CANEPINA', 'B597'],
      ['ACQUAPENDENTE', 'A040'],
      ['CAPODIMONTE', 'B663'],
      ['SORIANO NEL CIMINO', 'I855'],
      ['MONTEFIASCONE', 'F499'],
      ['TARQUINIA', 'D024'],
      ['CAPRANICA', 'B688'],
      ['SUTRI', 'L017'],
      ['BASSANO ROMANO', 'A704'],
      ['BASSANO IN TEVERINA', 'A706'],
      ['BLERA', 'A857'],
      ['GRAFFIGNANO', 'E128'],
      ['NEPI', 'F868'],
      ['CASTEL SANT\'ELIA', 'C269'],
      ['TESSENNANO', 'L150'],
      ['VETRALLA', 'L814'],
      ['FABRICA DI ROMA', 'D452'],
      ['FALERIA', 'D475'],
      ['SAN LORENZO NUOVO', 'H969'],
      ['ISCHIA DI CASTRO', 'E330'],
      ['BARBARANO ROMANO', 'A628'],
      ['ONANO', 'G065'],
      ['BOMARZO', 'A955'],
      ['CARBOGNANO', 'B735']
    ],
    VV: [
      ['SAN CALOGERO', 'H785'],
      ['MONTEROSSO CALABRO', 'F607'],
      ['CAPISTRANO', 'B655'],
      ['ZAMBRONE', 'M143'],
      ['ZUNGRI', 'M204'],
      ['MILETO', 'F207'],
      ['SIMBARIO', 'I744'],
      ['BROGNATURO', 'B197'],
      ['SANT\'ONOFRIO', 'I350'],
      ['ROMBIOLO', 'H516'],
      ['MAIERATO', 'E836'],
      ['DRAPIA', 'D364'],
      ['NICOTERA', 'F893'],
      ['DINAMI', 'D303'],
      ['PIZZONI', 'G728'],
      ['PIZZO', 'G722'],
      ['VAZZANO', 'L699'],
      ['VIBO VALENTIA', 'F537'],
      ['RICADI', 'H271'],
      ['MONGIANA', 'F364'],
      ['JOPPOLO', 'E389'],
      ['FRANCAVILLA ANGITOLA', 'D762'],
      ['FRANCICA', 'D767'],
      ['POLIA', 'G785'],
      ['BRIATICO', 'B169'],
      ['ZACCANOPOLI', 'M138'],
      ['SAN NICOLA DA CRISSA', 'I058'],
      ['ACQUARO', 'A043'],
      ['SORIANELLO', 'I853'],
      ['SORIANO CALABRO', 'I854'],
      ['SAN COSTANTINO CALABRO', 'H807'],
      ['DASA\'', 'D253'],
      ['LIMBADI', 'E590'],
      ['VALLELONGA', 'L607'],
      ['STEFANACONI', 'I945'],
      ['FILOGASO', 'D596'],
      ['SPILINGA', 'I905'],
      ['NARDODIPACE', 'F843'],
      ['TROPEA', 'L452'],
      ['FILANDARI', 'D589'],
      ['FILADELFIA', 'D587'],
      ['FABRIZIA', 'D453'],
      ['SPADOLA', 'I884'],
      ['SERRA SAN BRUNO', 'I639'],
      ['SAN GREGORIO D\'IPPONA', 'H941'],
      ['ARENA', 'A386'],
      ['PARGHELIA', 'G335'],
      ['GEROCARNE', 'D988'],
      ['CESSANITI', 'C581'],
      ['IONADI', 'E321']
    ]
  };
  